(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DeskproAppsSDKCore", [], factory);
	else if(typeof exports === 'object')
		exports["DeskproAppsSDKCore"] = factory();
	else
		root["DeskproAppsSDKCore"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "gozv");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+1cx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var prop = "_erd";

function initState(element) {
    element[prop] = {};
    return getState(element);
}

function getState(element) {
    return element[prop];
}

function cleanState(element) {
    delete element[prop];
}

module.exports = {
    initState: initState,
    getState: getState,
    cleanState: cleanState
};


/***/ }),

/***/ "/4rt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OauthConnection = undefined;

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = __webpack_require__("iy81");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _PropertyBag2 = __webpack_require__("K9HL");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 */
var OauthConnection = exports.OauthConnection = function (_PropertyBag) {
  (0, _inherits3.default)(OauthConnection, _PropertyBag);
  (0, _createClass3.default)(OauthConnection, null, [{
    key: 'fromJS',

    /**
     * @static
     * @method
     *
     * @param {{}} js
     * @return {OauthConnection}
     */
    value: function fromJS(js) {
      return new OauthConnection(js);
    }

    /**
     * @param {String} providerName
     * @param {String} urlAuthorize
     * @param {String} urlAccessToken
     * @param {String} urlResourceOwnerDetails
     * @param {String} urlRedirect
     * @param {String} clientId
     * @param {String} clientSecret
     * @param {{}} otherProps
     */

  }]);

  function OauthConnection(_ref) {
    var providerName = _ref.providerName,
        urlAuthorize = _ref.urlAuthorize,
        urlAccessToken = _ref.urlAccessToken,
        urlResourceOwnerDetails = _ref.urlResourceOwnerDetails,
        urlRedirect = _ref.urlRedirect,
        clientId = _ref.clientId,
        clientSecret = _ref.clientSecret,
        otherProps = (0, _objectWithoutProperties3.default)(_ref, ['providerName', 'urlAuthorize', 'urlAccessToken', 'urlResourceOwnerDetails', 'urlRedirect', 'clientId', 'clientSecret']);
    (0, _classCallCheck3.default)(this, OauthConnection);
    return (0, _possibleConstructorReturn3.default)(this, (OauthConnection.__proto__ || (0, _getPrototypeOf2.default)(OauthConnection)).call(this, (0, _extends3.default)({ providerName: providerName, urlAuthorize: urlAuthorize, urlAccessToken: urlAccessToken, urlResourceOwnerDetails: urlResourceOwnerDetails, urlRedirect: urlRedirect, clientId: clientId, clientSecret: clientSecret }, otherProps)));
  }

  /**
   * @readonly
   * @type {*|String}
   */


  (0, _createClass3.default)(OauthConnection, [{
    key: 'providerName',
    get: function get() {
      return this.props.providerName;
    }

    /**
     * @readonly
     * @type {*|String}
     */

  }, {
    key: 'urlAuthorize',
    get: function get() {
      return this.props.urlAuthorize;
    }

    /**
     * @readonly
     * @type {*|String}
     */

  }, {
    key: 'urlAccessToken',
    get: function get() {
      return this.props.urlAccessToken;
    }

    /**
     * @readonly
     * @type {*|String}
     */

  }, {
    key: 'urlResourceOwnerDetails',
    get: function get() {
      return this.props.urlResourceOwnerDetails;
    }

    /**
     * @readonly
     * @type {*|String}
     */

  }, {
    key: 'urlRedirect',
    get: function get() {
      return this.props.urlRedirect;
    }

    /**
     * @readonly
     * @type {*|String}
     */

  }, {
    key: 'clientId',
    get: function get() {
      return this.props.clientId;
    }

    /**
     * @readonly
     * @type {*|String}
     */

  }, {
    key: 'clientSecret',
    get: function get() {
      return this.props.clientSecret;
    }
  }]);
  return OauthConnection;
}(_PropertyBag2.PropertyBag);

/***/ }),

/***/ "/Aoj":
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),

/***/ "/MHE":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),

/***/ "/iXD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextProps = exports.InstanceProps = undefined;

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = __webpack_require__("iy81");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _PropertyBag3 = __webpack_require__("K9HL");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 * @extends {PropertyBag}
 */
var InstanceProps = exports.InstanceProps = function (_PropertyBag) {
  (0, _inherits3.default)(InstanceProps, _PropertyBag);

  /**
   * @param {String} appId
   * @param {String} appTitle
   * @param {String} appPackageName
   * @param {String} instanceId
   * @param {{}} otherProps
   */
  function InstanceProps(_ref) {
    var appId = _ref.appId,
        appTitle = _ref.appTitle,
        appPackageName = _ref.appPackageName,
        instanceId = _ref.instanceId,
        otherProps = (0, _objectWithoutProperties3.default)(_ref, ['appId', 'appTitle', 'appPackageName', 'instanceId']);
    (0, _classCallCheck3.default)(this, InstanceProps);
    return (0, _possibleConstructorReturn3.default)(this, (InstanceProps.__proto__ || (0, _getPrototypeOf2.default)(InstanceProps)).call(this, (0, _extends3.default)({ appId: appId, appTitle: appTitle, appPackageName: appPackageName, instanceId: instanceId }, otherProps)));
  }

  /**
   * @public
   * @readonly
   *
   * @type {String}
   */


  (0, _createClass3.default)(InstanceProps, [{
    key: 'appId',
    get: function get() {
      return this.props.appId;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'appTitle',
    get: function get() {
      return this.props.appTitle;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'appPackageName',
    get: function get() {
      return this.props.appPackageName;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'instanceId',
    get: function get() {
      return this.props.instanceId;
    }
  }]);
  return InstanceProps;
}(_PropertyBag3.PropertyBag);

/**
 * @class
 * @extends {PropertyBag}
 */
/**
 * @module Core/AppProps
 */

var ContextProps = exports.ContextProps = function (_PropertyBag2) {
  (0, _inherits3.default)(ContextProps, _PropertyBag2);

  /**
   * @param {String} type alias for contextType
   * @param {String} contextType
   * @param {String} entityId
   * @param {String} locationId
   * @param {String} tabId
   * @param {String} tabUrl
   * @param {Object} [otherProps] experimental props
   */
  function ContextProps(_ref2) {
    var type = _ref2.type,
        contextType = _ref2.contextType,
        entityId = _ref2.entityId,
        locationId = _ref2.locationId,
        tabId = _ref2.tabId,
        tabUrl = _ref2.tabUrl,
        otherProps = (0, _objectWithoutProperties3.default)(_ref2, ['type', 'contextType', 'entityId', 'locationId', 'tabId', 'tabUrl']);
    (0, _classCallCheck3.default)(this, ContextProps);
    return (0, _possibleConstructorReturn3.default)(this, (ContextProps.__proto__ || (0, _getPrototypeOf2.default)(ContextProps)).call(this, (0, _extends3.default)({ contextType: contextType || type, entityId: entityId, locationId: locationId, tabId: tabId, tabUrl: tabUrl }, otherProps)));
  }

  /**
   * @public
   * @readonly
   *
   * @type {String}
   */


  (0, _createClass3.default)(ContextProps, [{
    key: 'contextType',
    get: function get() {
      return this.props.contextType;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'entityId',
    get: function get() {
      return this.props.entityId;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'locationId',
    get: function get() {
      return this.props.locationId;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'tabId',
    get: function get() {
      return this.props.tabId;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'tabUrl',
    get: function get() {
      return this.props.tabUrl;
    }
  }]);
  return ContextProps;
}(_PropertyBag3.PropertyBag);

/***/ }),

/***/ "02Qm":
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__("YUE5")
  , createDesc     = __webpack_require__("/Aoj")
  , toIObject      = __webpack_require__("Uc+M")
  , toPrimitive    = __webpack_require__("I8xC")
  , has            = __webpack_require__("u9Aa")
  , IE8_DOM_DEFINE = __webpack_require__("JU1L")
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("NLIV") ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),

/***/ "0Sp3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("jzCG"), __esModule: true };

/***/ }),

/***/ "1+b2":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__("ngM3")
  , aFunction = __webpack_require__("mkZG")
  , SPECIES   = __webpack_require__("XGUc")('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),

/***/ "2C9O":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("siAl");

/***/ }),

/***/ "2L74":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__("XAet")
  , global             = __webpack_require__("shmw")
  , ctx                = __webpack_require__("RIJu")
  , classof            = __webpack_require__("yMXy")
  , $export            = __webpack_require__("3/3c")
  , isObject           = __webpack_require__("9Ob+")
  , aFunction          = __webpack_require__("mkZG")
  , anInstance         = __webpack_require__("qQzT")
  , forOf              = __webpack_require__("mwgz")
  , speciesConstructor = __webpack_require__("1+b2")
  , task               = __webpack_require__("vWGD").set
  , microtask          = __webpack_require__("4rPJ")()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__("XGUc")('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("85ZP")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__("CoAh")($Promise, PROMISE);
__webpack_require__("ke43")(PROMISE);
Wrapper = __webpack_require__("Y4Oj")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("EDNw")(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),

/***/ "2njn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorageAdapter = undefined;

var _regenerator = __webpack_require__("ED1s");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("Dfz+");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 */
var StorageAdapter = exports.StorageAdapter = function () {
  function StorageAdapter() {
    (0, _classCallCheck3.default)(this, StorageAdapter);
  }

  (0, _createClass3.default)(StorageAdapter, [{
    key: 'handleSetBatchStorage',

    // noinspection JSMethodCanBeStatic
    /**
     * @public
     * @virtual
     * @method
     *
     * @param {Promise.<{eventDispatcher:EventDispatcher}>} dispatchPromise
     * @param {Array<Array>} nameValuePairsList
     * @param entityId
     * @return {Promise}
     */
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dispatchPromise, nameValuePairsList, entityId) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw new Error('method must be implemented in a subclass');

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSetBatchStorage(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return handleSetBatchStorage;
    }()
  }, {
    key: 'handleSetStorage',


    // noinspection JSMethodCanBeStatic
    /**
     * @public
     * @method
     * @virtual
     *
     * @param {Promise.<{eventDispatcher:EventDispatcher}>} dispatchPromise
     * @param name
     * @param value
     * @param entityId
     * @return {Promise}
     */
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(dispatchPromise, name, value, entityId) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                throw new Error('method must be implemented in a subclass');

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSetStorage(_x4, _x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return handleSetStorage;
    }()
  }, {
    key: 'handleGetStorage',


    // noinspection JSMethodCanBeStatic
    /**
     * @public
     * @method
     * @virtual
     *
     * @param {Promise.<{eventDispatcher:EventDispatcher}>} dispatchPromise
     * @param name
     * @param entityId
     * @param defaultValue
     * @return {Promise.<*>}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(dispatchPromise, name, entityId) {
        var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                throw new Error('method must be implemented in a subclass');

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleGetStorage(_x8, _x9, _x10) {
        return _ref3.apply(this, arguments);
      }

      return handleGetStorage;
    }()
  }, {
    key: 'handleGetBatchStorage',


    /**
     * @public
     * @method
     * @virtual
     *
     * @param {Promise.<{eventDispatcher:EventDispatcher}>} dispatchPromise
     * @param {Array<String>} nameList
     * @param {String} entityId
     * @param {*} defaultValue
     * @return {Promise.<{}>}
     */
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(dispatchPromise, nameList, entityId) {
        var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                throw new Error('method must be implemented in a subclass');

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleGetBatchStorage(_x12, _x13, _x14) {
        return _ref4.apply(this, arguments);
      }

      return handleGetBatchStorage;
    }()
  }]);
  return StorageAdapter;
}();

/***/ }),

/***/ "3/3c":
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__("shmw")
  , core      = __webpack_require__("Y4Oj")
  , ctx       = __webpack_require__("RIJu")
  , hide      = __webpack_require__("siAl")
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),

/***/ "4VVB":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__("k3wI")
  , hiddenKeys = __webpack_require__("u2hb").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),

/***/ "4WzZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeskproWindowFacade = exports.create = undefined;

var _regenerator = __webpack_require__("ED1s");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("Dfz+");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _Events = __webpack_require__("ok1y");

var Events = _interopRequireWildcard(_Events);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {EventDispatcher} eventDispatcher
 * @return {DeskproWindowFacade}
 */
var create = exports.create = function create(eventDispatcher) {
  return new DeskproWindowFacade(eventDispatcher);
};

/**
 * @class
 */

var DeskproWindowFacade = exports.DeskproWindowFacade = function () {
  function DeskproWindowFacade(eventDispatcher) {
    (0, _classCallCheck3.default)(this, DeskproWindowFacade);

    this.props = { eventDispatcher: eventDispatcher };
  }

  /**
   * @method
   *
   * @param notification
   */


  (0, _createClass3.default)(DeskproWindowFacade, [{
    key: 'showNotification',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(notification) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_DESKPROWINDOW_SHOW_NOTIFICATION, notification));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function showNotification(_x) {
        return _ref.apply(this, arguments);
      }

      return showNotification;
    }()

    /**
     * @method
     * 
     * @param markupString
     */

  }, {
    key: 'insertMarkup',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(markupString) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_DESKPROWINDOW_INSERT_MARKUP, markupString));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function insertMarkup(_x2) {
        return _ref2.apply(this, arguments);
      }

      return insertMarkup;
    }()
  }]);
  return DeskproWindowFacade;
}();

/***/ }),

/***/ "4nfh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "4rPJ":
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__("shmw")
  , macrotask = __webpack_require__("vWGD").set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__("nl26")(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),

/***/ "4x0R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetWindowBridge = undefined;

var _regenerator = __webpack_require__("ED1s");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__("Dfz+");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__("fQko");

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _stringify = __webpack_require__("iK2U");

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__("KIIz");

var _typeof3 = _interopRequireDefault(_typeof2);

var _getSize = __webpack_require__("SdC7");

var _getSize2 = _interopRequireDefault(_getSize);

var _elementResizeDetector = __webpack_require__("uk2G");

var _elementResizeDetector2 = _interopRequireDefault(_elementResizeDetector);

var _postRobot = __webpack_require__("SRWI");

var postRobot = _interopRequireWildcard(_postRobot);

var _WidgetFactories = __webpack_require__("HgED");

var _Events = __webpack_require__("rR7O");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 *
 * @param eventName
 * @param listener
 * @param windowObject
 */
var addWindowEventListener = function addWindowEventListener(eventName, listener, windowObject) {
  var addListener = windowObject.addEventListener ? windowObject.addEventListener : windowObject.attachEvent;
  var event = windowObject.addEventListener ? eventName : 'on' + eventName;

  addListener(event, listener);
};

/**
 * @ignore
 *
 * @param windowBridge
 * @param e
 */
var mouseEventHandler = function mouseEventHandler(windowBridge, e) {
  var scalarKeys = function scalarKeys(original) {
    var obj = {};
    for (var key in original) {
      obj[key] = (0, _typeof3.default)(original[key]) === 'object' ? {} : original[key];
    }
    return obj;
  };

  var payload = JSON.parse((0, _stringify2.default)(scalarKeys(e)));
  windowBridge.emitRequest(_Events.EVENT_WINDOW_MOUSEEVENT, payload).then(function (_ref) {
    var emit = _ref.emit;
    return emit();
  });
};

var isResizing = false;
/**
 * @ignore
 *
 * @param {WidgetWindowBridge} windowBridge
 * @return {null}
 */
var windowSizeChangeHandler = function windowSizeChangeHandler(windowBridge) {
  if (isResizing) {
    return null;
  }

  isResizing = true;
  windowBridge.emitRequest(_Events.EVENT_WINDOW_RESIZE, { size: windowBridge.bodySize }).then(function (_ref2) {
    var emit = _ref2.emit;
    return emit();
  }).then(function () {
    isResizing = false;
  });
};

var mouseEvents = ['mousedown', 'mouseup'];

/**
 * @class
 */

var WidgetWindowBridge = function () {

  /**
   * @param {Window} windowObject
   * @param {InitProps} initProps
   */
  function WidgetWindowBridge(windowObject, initProps) {
    (0, _classCallCheck3.default)(this, WidgetWindowBridge);

    this.props = { windowObject: windowObject, initProps: initProps };

    var onLoadExecutor = function onLoadExecutor(resolve, reject) {
      if (windowObject.document.readyState === 'complete') {
        resolve();
      }
      addWindowEventListener('load', resolve, windowObject);
    };
    this.onLoadPromise = new _promise2.default(onLoadExecutor);
  }

  /**
   * @type {String}
   */


  (0, _createClass3.default)(WidgetWindowBridge, [{
    key: "connect",


    /**
     * @param {function} createApp
     * @return {Promise.<App>}
     */
    value: function connect(createApp) {
      var _this = this;

      var windowObject = this.props.windowObject;
      var widgetId = this.widgetId;


      return this.onLoadPromise.then(function () {
        return postRobot.send(postRobot.parent, "urn:deskpro:apps.widget.onready?widgetId=" + widgetId, {}).then(function (event) {
          return event.data;
        });
      }).then(createApp).then(function (app) {
        // reduce verbosity of post-robot logging
        if (app.environment === 'production') {
          postRobot.CONFIG.LOG_LEVEL = 'error';
        }

        var handler = mouseEventHandler.bind(null, _this);
        mouseEvents.forEach(function (event) {
          return addWindowEventListener(event, handler, windowObject);
        });

        // register the window resize strategy
        _this.erd = (0, _elementResizeDetector2.default)({ strategy: "scroll" });
        _this.erd.listenTo(windowObject.document.body, windowSizeChangeHandler.bind(null, _this));

        return app;
      });
    }

    /**
     * @param {String} eventName
     * @param {function} handler
     */

  }, {
    key: "on",
    value: function on(eventName, handler) {
      postRobot.on(eventName, handler);
    }

    /**
     * @param {String} eventName
     * @param {Error|null} error
     * @param {{}} data
     * @param {WidgetRequest} request
     * @return {Promise.<{response: WidgetResponse, emit: (function())}>}
     */

  }, {
    key: "emitResponse",
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(eventName, error, data, request) {
        var widgetId, response, payload, event, emit;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                widgetId = this.widgetId;
                response = _WidgetFactories.WidgetFactories.nextResponse(request, error ? error : data, !!error);
                payload = (0, _extends3.default)({ eventName: eventName }, response.toJS());
                event = "urn:deskpro:apps.widget.event?widgetId=" + widgetId;

                emit = function emit() {
                  postRobot.send(postRobot.parent, event, payload);
                };

                return _context.abrupt("return", _promise2.default.resolve({ response: response, emit: emit }));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function emitResponse(_x, _x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      }

      return emitResponse;
    }()

    /**
     * @param {String} eventName
     * @param {*} data
     * @return {Promise.<{request: WidgetRequest, emit: (function())}>}
     */

  }, {
    key: "emitRequest",
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(eventName, data) {
        var widgetId, request, payload, event, emit;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                widgetId = this.widgetId;
                request = _WidgetFactories.WidgetFactories.nextRequest(widgetId, data);
                payload = (0, _extends3.default)({ eventName: eventName }, request.toJS());
                event = "urn:deskpro:apps.widget.event?widgetId=" + widgetId;

                emit = function emit() {
                  postRobot.send(postRobot.parent, event, payload);
                };

                return _context2.abrupt("return", _promise2.default.resolve({ request: request, emit: emit }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function emitRequest(_x5, _x6) {
        return _ref4.apply(this, arguments);
      }

      return emitRequest;
    }()

    /**
     * @public
     * @constant
     *
     * @type {WidgetWindowBridge~GetSize}
     */

  }, {
    key: "widgetId",
    get: function get() {
      var initProps = this.props.initProps;

      return initProps.dpWidgetId;
    }
  }, {
    key: "bodySize",
    get: function get() {
      var windowObject = this.props.windowObject;

      return (0, _getSize2.default)(windowObject.document.body);
    }
  }]);
  return WidgetWindowBridge;
}();

exports.WidgetWindowBridge = WidgetWindowBridge;

/**
 * GetSize Type.
 *
 * @typedef {Object} WindowProxy~GetSize
 * @property {number} width - Size in pixels.
 * @property {number} height - Size in pixels.
 * @property {number} innerWidth - Size in pixels.
 * @property {number} innerHeight - Size in pixels.
 * @property {number} outerWidth - Size in pixels.
 * @property {number} outerHeight - Size in pixels.
 */

/***/ }),

/***/ "4x8l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("7kNb");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "50hw":
/***/ (function(module, exports) {

module.exports = {};

/***/ }),

/***/ "5Y6L":
/***/ (function(module, exports) {



/***/ }),

/***/ "5esh":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("nl26");
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),

/***/ "5yeL":
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__("GBSe")
  , toIObject = __webpack_require__("Uc+M");
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),

/***/ "601f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var idGenerator     = options.idGenerator;
    var getState        = options.stateHandler.getState;

    /**
     * Gets the resize detector id of the element.
     * @public
     * @param {element} element The target element to get the id of.
     * @returns {string|number|null} The id of the element. Null if it has no id.
     */
    function getId(element) {
        var state = getState(element);

        if (state && state.id !== undefined) {
            return state.id;
        }

        return null;
    }

    /**
     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
     * @public
     * @param {element} element The target element to set the id of.
     * @returns {string|number|null} The id of the element.
     */
    function setId(element) {
        var state = getState(element);

        if (!state) {
            throw new Error("setId required the element to have a resize detection state.");
        }

        var id = idGenerator.generate();

        state.id = id;

        return id;
    }

    return {
        get: getId,
        set: setId
    };
};


/***/ }),

/***/ "6uSB":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("3/3c");

$export($export.S + $export.F, 'Object', {assign: __webpack_require__("IWaA")});

/***/ }),

/***/ "7VO+":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("DWRq");
__webpack_require__("5Y6L");
__webpack_require__("9rNO");
__webpack_require__("vbpo");
module.exports = __webpack_require__("Y4Oj").Symbol;

/***/ }),

/***/ "7kNb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("8Tg/"), __esModule: true };

/***/ }),

/***/ "85ZP":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("siAl");
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

/***/ }),

/***/ "8Tg/":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Fs8B");
var $Object = __webpack_require__("Y4Oj").Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),

/***/ "8VHH":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__("eZLJ")
  , $getPrototypeOf = __webpack_require__("rNJP");

__webpack_require__("hUDZ")('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),

/***/ "8WaV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__("XAet")
  , $export        = __webpack_require__("3/3c")
  , redefine       = __webpack_require__("2C9O")
  , hide           = __webpack_require__("siAl")
  , has            = __webpack_require__("u9Aa")
  , Iterators      = __webpack_require__("50hw")
  , $iterCreate    = __webpack_require__("Xpkd")
  , setToStringTag = __webpack_require__("CoAh")
  , getPrototypeOf = __webpack_require__("rNJP")
  , ITERATOR       = __webpack_require__("XGUc")('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),

/***/ "9Ob+":
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ "9rNO":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("jD66")('asyncIterator');

/***/ }),

/***/ "AuTW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerEventHandlers = undefined;

var _ContextEvents = __webpack_require__("GKfY");

var Events = _interopRequireWildcard(_ContextEvents);

var _EventHandler = __webpack_require__("zx9m");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @method
 * @param {WidgetWindowBridge} windowBridge
 * @param {App} app
 */
/**
 * @module Core/ContextEventHandlers
 */

var registerEventHandlers = exports.registerEventHandlers = function registerEventHandlers(windowBridge, app) {
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, Events.EVENT_ME_GET, Events.props.EVENT_ME_GET);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, Events.EVENT_TAB_DATA, Events.props.EVENT_TAB_DATA);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, Events.EVENT_TAB_ACTIVATE, Events.props.EVENT_TAB_ACTIVATE);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, Events.EVENT_TAB_CLOSE, Events.props.EVENT_TAB_CLOSE);
};

/***/ }),

/***/ "BHzd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventMap = undefined;

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 */
var EventMap = exports.EventMap = function () {
  function EventMap(_ref) {
    var _this = this;

    var map = _ref.map,
        names = _ref.names,
        props = _ref.props;
    (0, _classCallCheck3.default)(this, EventMap);

    this.isEventName = function (name) {
      return _this.props.names.indexOf(name) !== -1;
    };

    this.getEventKey = function (eventName) {
      return _this.props.map.hasOwnProperty(eventName) ? _this.props.map[eventName] : null;
    };

    this.getEventProps = function (eventName) {
      var eventKey = _this.getEventKey(eventName);
      if (eventKey && _this.props.props.hasOwnProperty(eventKey)) {
        return _this.props.props[eventKey];
      }
    };

    this.props = { map: map, names: names, props: props };
  }

  /**
   * @method
   * @public
   *
   * @param {String} name
   * @return boolean
   */


  (0, _createClass3.default)(EventMap, [{
    key: "eventNames",


    /**
     * @public
     *
     * @type {Array.<String>}
     */
    get: function get() {
      return [].concat(this.props.names);
    }

    /**
     * @method
     * @public
     *
     * @param {String} eventName
     * @return {string}
     */


    /**
     * @method
     * @public
     *
     * @param eventName
     * @return {*|null}
     */

  }]);
  return EventMap;
}();

/***/ }),

/***/ "BNfS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventName = exports.eventNames = exports.props = exports.EVENT_SECURITY_SETTINGS_OAUTH = exports.EVENT_SECURITY_AUTHENTICATE_OAUTH = undefined;

var _keys = __webpack_require__("q+0m");

var _keys2 = _interopRequireDefault(_keys);

var _Event = __webpack_require__("kJI2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_SECURITY_AUTHENTICATE_OAUTH = exports.EVENT_SECURITY_AUTHENTICATE_OAUTH = 'security.authenticate.oauth'; /**
                                                                                                                    * Security/Events module.
                                                                                                                    * @module Security/Events
                                                                                                                    */

var EVENT_SECURITY_SETTINGS_OAUTH = exports.EVENT_SECURITY_SETTINGS_OAUTH = 'security.settings.oauth';

var events = {

  EVENT_SECURITY_AUTHENTICATE_OAUTH: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },
  EVENT_SECURITY_SETTINGS_OAUTH: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE }

};

/**
 * @readonly
 * @enum
 * @type {{EVENT_SECURITY_AUTHENTICATE_OAUTH: {channelType, invocationType}, EVENT_SECURITY_SETTINGS_OAUTH: {channelType, invocationType}}}
 */
var props = exports.props = events;

/**
 * @readonly
 * @type {Array}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 * @param {String} name
 * @return {boolean}
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};

/***/ }),

/***/ "BzvE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ "CDue":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("ofgR")
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),

/***/ "CGCf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function() {
    var idCount = 1;

    /**
     * Generates a new unique id in the context.
     * @public
     * @returns {number} A unique id in the context.
     */
    function generate() {
        return idCount++;
    }

    return {
        generate: generate
    };
};


/***/ }),

/***/ "CoAh":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("PR1c").f
  , has = __webpack_require__("u9Aa")
  , TAG = __webpack_require__("XGUc")('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),

/***/ "CurJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageBus = exports.InternalEventDispatcher = exports.OutgoingEventDispatcher = exports.IncomingEventDispatcher = exports.EventDispatcher = exports.emitAsync = undefined;

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = __webpack_require__("fQko");

var _promise2 = _interopRequireDefault(_promise);

var _class, _temp2, _initialiseProps; /**
                                       * @module Core/EventDispatcher
                                       */

var _eventemitter = __webpack_require__("BzvE");

var _Event = __webpack_require__("kJI2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {EventDispatcher} eventDispatcher
 * @param {String} eventName
 * @param {Array} args
 *
 * @return {Promise}
 */
var dispatch = function dispatch(eventDispatcher, eventName) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var emitBinding = eventDispatcher.emit.bind(eventDispatcher);

  var executor = function executor(resolve, reject) {
    var emitArgs = [eventName, resolve, reject].concat(args);
    return emitBinding.apply(null, emitArgs);
  };

  return new _promise2.default(executor);
};

/**
 * @param {EventDispatcher} eventDispatcher
 *
 * @return {Promise}
 */
var emitAsync = exports.emitAsync = function emitAsync(eventDispatcher) {
  var dispatchBinding = dispatch.bind(null, eventDispatcher);
  return _promise2.default.resolve(dispatchBinding);
};

/**
 * @class
 * @extend {EventEmitter}
 */
var EventDispatcher = exports.EventDispatcher = (_temp2 = _class = function (_EventEmitter) {
  (0, _inherits3.default)(EventDispatcher, _EventEmitter);

  function EventDispatcher() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EventDispatcher);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EventDispatcher.__proto__ || (0, _getPrototypeOf2.default)(EventDispatcher)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EventDispatcher, [{
    key: 'onInvoke',

    /**
     *
     * @param handler
     */
    value: function onInvoke(handler) {
      this.on('invoke', handler);
    }

    /**
     * @public
     * @method
     *
     * @return {Promise}
     */

  }, {
    key: 'emitInvokeAsync',
    value: function emitInvokeAsync() {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.emitAsync.apply(this, ['invoke'].concat(args));
    }

    /**
     * @public
     * @method
     * @param {string} eventName
     * @param [args]
     * @return {Promise}
     */


    /**
     * @public
     * @method
     *
     * @param {String} beforeEventName
     * @param {function} onBeforeEmit
     * @return {function()}
     */

  }]);
  return EventDispatcher;
}(_eventemitter.EventEmitter), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.emitAsync = function (eventName) {
    for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }

    var executor = function executor(resolve, reject) {
      _this2.emit.apply(_this2, [eventName, resolve, reject].concat(args));
    };
    return new _promise2.default(executor);
  };

  this.emitCancelable = function (beforeEventName, onBeforeEmit) {
    return function (eventName) {
      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      var event = new _Event.Event({ name: eventName, args: args });
      _this2.emit(beforeEventName, event);

      if (event.enabled) {
        onBeforeEmit();
        _this2.emit.apply(_this2, [eventName].concat(args));
      }
    };
  };
}, _temp2);

/**
 * @type {EventDispatcher}
 */

var IncomingEventDispatcher = exports.IncomingEventDispatcher = new EventDispatcher();

/**
 * @type {EventDispatcher}
 */
var OutgoingEventDispatcher = exports.OutgoingEventDispatcher = new EventDispatcher();

/**
 * @type {EventDispatcher}
 */
var InternalEventDispatcher = exports.InternalEventDispatcher = new EventDispatcher();

/**
 * @type {EventDispatcher}
 */
var MessageBus = exports.MessageBus = new EventDispatcher();

/***/ }),

/***/ "DWRq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__("shmw")
  , has            = __webpack_require__("u9Aa")
  , DESCRIPTORS    = __webpack_require__("NLIV")
  , $export        = __webpack_require__("3/3c")
  , redefine       = __webpack_require__("2C9O")
  , META           = __webpack_require__("pzZL").KEY
  , $fails         = __webpack_require__("gM7W")
  , shared         = __webpack_require__("iUVn")
  , setToStringTag = __webpack_require__("CoAh")
  , uid            = __webpack_require__("pfI3")
  , wks            = __webpack_require__("XGUc")
  , wksExt         = __webpack_require__("LO75")
  , wksDefine      = __webpack_require__("jD66")
  , keyOf          = __webpack_require__("5yeL")
  , enumKeys       = __webpack_require__("WGV/")
  , isArray        = __webpack_require__("5esh")
  , anObject       = __webpack_require__("ngM3")
  , toIObject      = __webpack_require__("Uc+M")
  , toPrimitive    = __webpack_require__("I8xC")
  , createDesc     = __webpack_require__("/Aoj")
  , _create        = __webpack_require__("MmDC")
  , gOPNExt        = __webpack_require__("oIaV")
  , $GOPD          = __webpack_require__("02Qm")
  , $DP            = __webpack_require__("PR1c")
  , $keys          = __webpack_require__("GBSe")
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__("4VVB").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("YUE5").f  = $propertyIsEnumerable;
  __webpack_require__("mexi").f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__("XAet")){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("siAl")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),

/***/ "Dfz+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__("fQko");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ "E3Jr":
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__("yMXy")
  , ITERATOR  = __webpack_require__("XGUc")('iterator')
  , Iterators = __webpack_require__("50hw");
module.exports = __webpack_require__("Y4Oj").isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};

/***/ }),

/***/ "E60P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabContext = undefined;

var _regenerator = __webpack_require__("ED1s");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("Dfz+");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = __webpack_require__("iy81");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _Context2 = __webpack_require__("v+o1");

var _ContextEvents = __webpack_require__("GKfY");

var ContextEvents = _interopRequireWildcard(_ContextEvents);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabContext = exports.TabContext = function (_Context) {
  (0, _inherits3.default)(TabContext, _Context);

  /**
   * @param {EventDispatcher} outgoingDispatcher
   * @param {EventDispatcher} incomingDispatcher
   * @param {String} type
   * @param {String} entityId
   * @param {String} locationId
   * @param {String} tabId
   * @param {String} tabUrl
   * @param rest
   */
  function TabContext(_ref) {
    var outgoingDispatcher = _ref.outgoingDispatcher,
        incomingDispatcher = _ref.incomingDispatcher,
        type = _ref.type,
        entityId = _ref.entityId,
        locationId = _ref.locationId,
        tabId = _ref.tabId,
        tabUrl = _ref.tabUrl,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['outgoingDispatcher', 'incomingDispatcher', 'type', 'entityId', 'locationId', 'tabId', 'tabUrl']);
    (0, _classCallCheck3.default)(this, TabContext);
    return (0, _possibleConstructorReturn3.default)(this, (TabContext.__proto__ || (0, _getPrototypeOf2.default)(TabContext)).call(this, (0, _extends3.default)({
      outgoingDispatcher: outgoingDispatcher,
      incomingDispatcher: incomingDispatcher,
      type: type,
      entityId: entityId,
      locationId: locationId,
      tabId: tabId,
      tabUrl: tabUrl
    }, rest)));
  }

  /**
   * @public
   * @return {String}
   */


  (0, _createClass3.default)(TabContext, [{
    key: 'isTabActive',


    /**
     * @public
     * @method
     * @async
     * @return {Promise}
     */
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.props.outgoingDispatcher.emitAsync(ContextEvents.EVENT_TAB_STATUS, this.props.tabId).then(function (status) {
                  return status.active;
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function isTabActive() {
        return _ref2.apply(this, arguments);
      }

      return isTabActive;
    }()
  }, {
    key: 'activateTab',


    /**
     * @public
     * @method
     * @async
     * @return {Promise}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.props.outgoingDispatcher.emitAsync(ContextEvents.EVENT_TAB_ACTIVATE, this.props.tabId));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function activateTab() {
        return _ref3.apply(this, arguments);
      }

      return activateTab;
    }()

    /**
     * @public
     * @method
     * @async
     * @return {Promise}
     */

  }, {
    key: 'closeTab',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.props.outgoingDispatcher.emitAsync(ContextEvents.EVENT_TAB_CLOSE, this.props.tabId));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function closeTab() {
        return _ref4.apply(this, arguments);
      }

      return closeTab;
    }()

    /**
     * @public
     * @method
     * @async
     * @return {Promise}
     */

  }, {
    key: 'getTabData',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', this.props.outgoingDispatcher.emitAsync(ContextEvents.EVENT_TAB_DATA, this.props.tabId));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getTabData() {
        return _ref5.apply(this, arguments);
      }

      return getTabData;
    }()
  }, {
    key: 'tabId',
    get: function get() {
      return this.props.tabId.toString();
    }

    /**
     * @public
     * @return {String}
     */

  }, {
    key: 'tabUrl',
    get: function get() {
      return this.props.tabUrl.toString();
    }
  }]);
  return TabContext;
}(_Context2.Context);

/***/ }),

/***/ "ED1s":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("seUs");


/***/ }),

/***/ "EDNw":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__("XGUc")('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),

/***/ "EL/j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetMessage = undefined;

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _PropertyBag2 = __webpack_require__("K9HL");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 * @extends {PropertyBag}
 */
var WidgetMessage = exports.WidgetMessage = function (_PropertyBag) {
  (0, _inherits3.default)(WidgetMessage, _PropertyBag);

  function WidgetMessage() {
    (0, _classCallCheck3.default)(this, WidgetMessage);
    return (0, _possibleConstructorReturn3.default)(this, (WidgetMessage.__proto__ || (0, _getPrototypeOf2.default)(WidgetMessage)).apply(this, arguments));
  }

  (0, _createClass3.default)(WidgetMessage, [{
    key: 'id',

    /**
     * @readonly
     *
     * @type {String}
     */
    get: function get() {
      return this.props.id;
    }
  }, {
    key: 'widgetId',


    /**
     * @readonly
     *
     * @type {String}
     */
    get: function get() {
      return this.props.widgetId;
    }
  }, {
    key: 'correlationId',


    /**
     * @readonly
     *
     * @type {String}
     */
    get: function get() {
      return this.props.correlationId;
    }
  }, {
    key: 'body',


    /**
     * @readonly
     *
     * @type {*}
     */
    get: function get() {
      return this.props.body;
    }
  }]);
  return WidgetMessage;
}(_PropertyBag2.PropertyBag);

/***/ }),

/***/ "F0gX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("7VO+"), __esModule: true };

/***/ }),

/***/ "FRPW":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("9Ob+")
  , anObject = __webpack_require__("ngM3");
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__("RIJu")(Function.call, __webpack_require__("02Qm").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),

/***/ "Fs8B":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("3/3c");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("NLIV"), 'Object', {defineProperty: __webpack_require__("PR1c").f});

/***/ }),

/***/ "GBSe":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__("k3wI")
  , enumBugKeys = __webpack_require__("u2hb");

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),

/***/ "GKUm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrganizationContext = undefined;

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = __webpack_require__("iy81");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _TabContext2 = __webpack_require__("E60P");

var _CustomFields = __webpack_require__("S6PW");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 * @extends {Context}
 */
var OrganizationContext = exports.OrganizationContext = function (_TabContext) {
  (0, _inherits3.default)(OrganizationContext, _TabContext);
  (0, _createClass3.default)(OrganizationContext, null, [{
    key: 'tryAndCreate',


    /**
     * @method
     * @static
     *
     * @param {EventDispatcher} outgoingDispatcher
     * @param {EventDispatcher} incomingDispatcher
     * @param {InstanceProps} instanceProps
     * @param {ContextProps} contextProps
     * @return {OrganizationContext|null}
     */
    value: function tryAndCreate(_ref) {
      var outgoingDispatcher = _ref.outgoingDispatcher,
          incomingDispatcher = _ref.incomingDispatcher,
          instanceProps = _ref.instanceProps,
          contextProps = _ref.contextProps;

      if (contextProps.contextType === OrganizationContext.TYPE) {
        var props = (0, _extends3.default)({
          outgoingDispatcher: outgoingDispatcher,
          incomingDispatcher: incomingDispatcher
        }, contextProps.toJS(), {
          type: contextProps.contextType,
          instanceId: instanceProps.instanceId
        });
        return new OrganizationContext(props);
      }

      return null;
    }

    /**
     * @constructor
     *
     * @param {string} instanceId
     * @param {{}} rest
     */

  }, {
    key: 'TYPE',

    /**
     * @static
     * @readonly
     * @type {string}
     */
    get: function get() {
      return 'organization';
    }
  }]);

  function OrganizationContext(_ref2) {
    var instanceId = _ref2.instanceId,
        rest = (0, _objectWithoutProperties3.default)(_ref2, ['instanceId']);
    (0, _classCallCheck3.default)(this, OrganizationContext);
    return (0, _possibleConstructorReturn3.default)(this, (OrganizationContext.__proto__ || (0, _getPrototypeOf2.default)(OrganizationContext)).call(this, (0, _extends3.default)({ instanceId: instanceId }, rest)));
  }

  /**
   * @public
   * @return {CustomFieldsClient}
   */


  (0, _createClass3.default)(OrganizationContext, [{
    key: 'customFields',
    get: function get() {
      var _props = this.props,
          outgoingDispatcher = _props.outgoingDispatcher,
          instanceId = _props.instanceId;

      return new _CustomFields.CustomFieldsClient({
        outgoingDispatcher: outgoingDispatcher,
        instanceId: instanceId,
        endpoint: 'organizations/' + this.entityId
      });
    }
  }]);
  return OrganizationContext;
}(_TabContext2.TabContext);

/***/ }),

/***/ "GKfY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventName = exports.eventNames = exports.props = exports.EVENT_BEFORE_TAB_CLOSED = exports.EVENT_TAB_CLOSE = exports.EVENT_BEFORE_TAB_DEACTIVATED = exports.EVENT_TAB_ACTIVATE = exports.EVENT_TAB_DATA = exports.EVENT_TAB_STATUS = exports.EVENT_ME_GET = undefined;

var _keys = __webpack_require__("q+0m");

var _keys2 = _interopRequireDefault(_keys);

var _Event = __webpack_require__("kJI2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @readonly
 * @type {string}
 */
var EVENT_ME_GET = exports.EVENT_ME_GET = 'context.me_get';

/**
 * @readonly
 * @type {string}
 */
/**
 * @module Core/ContextEvents
 */

var EVENT_TAB_STATUS = exports.EVENT_TAB_STATUS = 'context.tab_status';

/**
 * @readonly
 * @type {string}
 */
var EVENT_TAB_DATA = exports.EVENT_TAB_DATA = 'context.tab_data';

/**
 * @readonly
 * @type {string}
 */
var EVENT_TAB_ACTIVATE = exports.EVENT_TAB_ACTIVATE = 'context.tab_activate';

/**
 * @readonly
 * @type {string}
 */
var EVENT_BEFORE_TAB_DEACTIVATED = exports.EVENT_BEFORE_TAB_DEACTIVATED = 'context.before_tab_deactivated';

/**
 * @readonly
 * @type {string}
 */
var EVENT_TAB_CLOSE = exports.EVENT_TAB_CLOSE = 'context.tab_close';

/**
 * @readonly
 * @type {string}
 */
var EVENT_BEFORE_TAB_CLOSED = exports.EVENT_BEFORE_TAB_CLOSED = 'context.before_tab_closed';

var events = {

  EVENT_ME_GET: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },

  EVENT_TAB_DATA: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },

  EVENT_TAB_ACTIVATE: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },

  EVENT_TAB_CLOSE: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE }
};

/**
 * @enum
 * @readonly
 * @type {{EVENT_ME_GET: {channelType: string, invocationType: string}, EVENT_TAB_DATA: {channelType: string, invocationType: string}, EVENT_TAB_ACTIVATE: {channelType: string, invocationType: string}, EVENT_TAB_CLOSE: {channelType: string, invocationType: string}}}
 */
var props = exports.props = events;

/**
 * @readonly
 * @type {Array<string>}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 *
 * @param {string} name
 * @return {boolean}
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};

/***/ }),

/***/ "GZ7I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("Rln+");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "GpqH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("LBxF");

module.exports = function batchProcessorMaker(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var asyncProcess    = utils.getOption(options, "async", true);
    var autoProcess     = utils.getOption(options, "auto", true);

    if(autoProcess && !asyncProcess) {
        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
        asyncProcess = true;
    }

    var batch = Batch();
    var asyncFrameHandler;
    var isProcessing = false;

    function addFunction(level, fn) {
        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
            // This needs to be done before, since we're checking the size of the batch to be 0.
            processBatchAsync();
        }

        batch.add(level, fn);
    }

    function processBatch() {
        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
        isProcessing = true;
        while (batch.size()) {
            var processingBatch = batch;
            batch = Batch();
            processingBatch.process();
        }
        isProcessing = false;
    }

    function forceProcessBatch(localAsyncProcess) {
        if (isProcessing) {
            return;
        }

        if(localAsyncProcess === undefined) {
            localAsyncProcess = asyncProcess;
        }

        if(asyncFrameHandler) {
            cancelFrame(asyncFrameHandler);
            asyncFrameHandler = null;
        }

        if(localAsyncProcess) {
            processBatchAsync();
        } else {
            processBatch();
        }
    }

    function processBatchAsync() {
        asyncFrameHandler = requestFrame(processBatch);
    }

    function clearBatch() {
        batch           = {};
        batchSize       = 0;
        topLevel        = 0;
        bottomLevel     = 0;
    }

    function cancelFrame(listener) {
        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
        var cancel = clearTimeout;
        return cancel(listener);
    }

    function requestFrame(callback) {
        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
        var raf = function(fn) { return setTimeout(fn, 0); };
        return raf(callback);
    }

    return {
        add: addFunction,
        force: forceProcessBatch
    };
};

function Batch() {
    var batch       = {};
    var size        = 0;
    var topLevel    = 0;
    var bottomLevel = 0;

    function add(level, fn) {
        if(!fn) {
            fn = level;
            level = 0;
        }

        if(level > topLevel) {
            topLevel = level;
        } else if(level < bottomLevel) {
            bottomLevel = level;
        }

        if(!batch[level]) {
            batch[level] = [];
        }

        batch[level].push(fn);
        size++;
    }

    function process() {
        for(var level = bottomLevel; level <= topLevel; level++) {
            var fns = batch[level];

            for(var i = 0; i < fns.length; i++) {
                var fn = fns[i];
                fn();
            }
        }
    }

    function getSize() {
        return size;
    }

    return {
        add: add,
        process: process,
        size: getSize
    };
}


/***/ }),

/***/ "HCjt":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("iImc");
module.exports = __webpack_require__("Y4Oj").Object.keys;

/***/ }),

/***/ "HFsX":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),

/***/ "HgED":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetFactories = undefined;

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _WidgetRequest = __webpack_require__("pmdG");

var _WidgetResponse = __webpack_require__("i81l");

var _WidgetWindowBridge = __webpack_require__("4x0R");

var _InitProps = __webpack_require__("MouD");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nextMessageId = 0;
var nextCorrelationId = 0;

/**
 * @class
 */

var WidgetFactories = exports.WidgetFactories = function () {
  function WidgetFactories() {
    (0, _classCallCheck3.default)(this, WidgetFactories);
  }

  (0, _createClass3.default)(WidgetFactories, null, [{
    key: 'windowBridgeFromGlobals',

    /**
     * @static
     * @method
     *
     * @return {WidgetFactories.windowBridgeFromWindow}
     */
    value: function windowBridgeFromGlobals() {
      return new WidgetFactories.windowBridgeFromWindow(window);
    }

    /**
     * @static
     * @method
     *
     * @param {Window} windowObject
     * @return {WidgetWindowBridge}
     * @throws Error
     */

  }, {
    key: 'windowBridgeFromWindow',
    value: function windowBridgeFromWindow(windowObject) {
      var initProps = _InitProps.InitProps.fromWindow(windowObject);
      if (_InitProps.InitProps.validate(initProps)) {
        return new _WidgetWindowBridge.WidgetWindowBridge(windowObject, initProps);
      }

      throw new Error('invalid or missing init properties');
    }

    /**
     * @static
     * @method
     *
     * @param {*} raw
     * @return {WidgetMessage}
     */

  }, {
    key: 'parseMessageFromJS',
    value: function parseMessageFromJS(raw) {
      var status = raw.status;


      if (status) {
        return _WidgetResponse.WidgetResponse.parse(raw);
      }

      return _WidgetRequest.WidgetRequest.parse(raw);
    }

    /**
     * @static
     * @method
     *
     * @param {string} widgetId
     * @param {*} payload
     * @return {WidgetRequest}
     */

  }, {
    key: 'nextRequest',
    value: function nextRequest(widgetId, payload) {
      var correlationId = ++nextCorrelationId;
      var id = ++nextMessageId;

      return new _WidgetRequest.WidgetRequest({ id: id.toString(), widgetId: widgetId, correlationId: correlationId.toString(), body: payload });
    }
  }, {
    key: 'nextResponse',


    /**
     * @static
     * @method
     *
     * @param {WidgetRequest} request
     * @param {*} body
     * @param {boolean} isError
     * @return {WidgetResponse}
     */
    value: function nextResponse(request, body, isError) {
      var id = ++nextMessageId;
      var widgetId = request.widgetId,
          correlationId = request.correlationId;

      var status = isError ? 'error' : 'success';

      //const parsedBody = body === null ? body : JSON.stringify(body);
      return new _WidgetResponse.WidgetResponse({ id: id.toString(), widgetId: widgetId, correlationId: correlationId.toString(), body: body, status: status });
    }
  }]);
  return WidgetFactories;
}();

/***/ }),

/***/ "HmPl":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("ofgR")
  , defined   = __webpack_require__("/MHE");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),

/***/ "I8xC":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("9Ob+");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ "IWaA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__("GBSe")
  , gOPS     = __webpack_require__("mexi")
  , pIE      = __webpack_require__("YUE5")
  , toObject = __webpack_require__("eZLJ")
  , IObject  = __webpack_require__("OvYF")
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("gM7W")(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),

/***/ "IlDj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__("HmPl")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("8WaV")(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),

/***/ "JU1L":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("NLIV") && !__webpack_require__("gM7W")(function(){
  return Object.defineProperty(__webpack_require__("ZVhn")('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),

/***/ "JYxG":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("iUVn")('keys')
  , uid    = __webpack_require__("pfI3");
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),

/***/ "Js+k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OauthFacade = undefined;

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__("ED1s");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("Dfz+");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _Events = __webpack_require__("BNfS");

var Events = _interopRequireWildcard(_Events);

var _OauthToken = __webpack_require__("K0ms");

var _OauthConnection = __webpack_require__("/4rt");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 */
var OauthFacade = exports.OauthFacade = function () {
  /**
   * @param {EventDispatcher} eventDispatcher
   * @param {function} setStorage
   * @param {String} appId
   * @param {String} helpdeskUrl
   */
  function OauthFacade(eventDispatcher, setStorage, _ref) {
    var appId = _ref.appId,
        helpdeskUrl = _ref.helpdeskUrl;
    (0, _classCallCheck3.default)(this, OauthFacade);

    this.props = { eventDispatcher: eventDispatcher, setStorage: setStorage, appId: appId, helpdeskUrl: helpdeskUrl };
  }

  /**
   * @method
   *
   * @param {String} provider
   * @return {Promise}
   */


  (0, _createClass3.default)(OauthFacade, [{
    key: 'settings',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(provider) {
        var eventDispatcher;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                eventDispatcher = this.props.eventDispatcher;
                return _context.abrupt('return', eventDispatcher.emitAsync(Events.EVENT_SECURITY_SETTINGS_OAUTH, { provider: provider }));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function settings(_x) {
        return _ref2.apply(this, arguments);
      }

      return settings;
    }()
  }, {
    key: 'register',


    /**
     * @method
     *
     * @param {String} provider
     * @param {{ urlAuthorize:String, urlAccessToken:String, urlAccessToken:String, urlResourceOwnerDetails:String, clientId:String, clientSecret:String }}  details
     * @return {Promise}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(provider, details) {
        var connectionProps, connectionJS, storageName;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                connectionProps = (0, _extends3.default)({}, details, { providerName: provider });
                connectionJS = _OauthConnection.OauthConnection.fromJS(connectionProps).toJS();
                storageName = 'oauth:' + provider;
                return _context2.abrupt('return', this.props.setStorage(storageName, connectionJS).then(function () {
                  return { name: storageName, value: connectionJS };
                }));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function register(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return register;
    }()
  }, {
    key: 'access',


    /**
     * @method
     *
     * @param provider
     * @param options
     * @return {Promise}
     */
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(provider, options) {
        var eventDispatcher;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                eventDispatcher = this.props.eventDispatcher;
                return _context3.abrupt('return', eventDispatcher.emitAsync(Events.EVENT_SECURITY_AUTHENTICATE_OAUTH, { provider: provider, options: options }).then(_OauthToken.OauthToken.fromOauthProxyResponse).then(function (oauthToken) {
                  return oauthToken.toJS();
                }));

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function access(_x4, _x5) {
        return _ref4.apply(this, arguments);
      }

      return access;
    }()
  }]);
  return OauthFacade;
}();

/***/ }),

/***/ "K0ms":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OauthToken = undefined;

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = __webpack_require__("iy81");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _PropertyBag2 = __webpack_require__("K9HL");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 */
var OauthToken = exports.OauthToken = function (_PropertyBag) {
  (0, _inherits3.default)(OauthToken, _PropertyBag);
  (0, _createClass3.default)(OauthToken, null, [{
    key: 'fromJS',

    /**
     * @static
     * @method
     *
     * @param {{}} js
     * @return {OauthToken}
     */
    value: function fromJS(js) {
      return new OauthToken(js);
    }

    /**
     * @static
     * @method
     *
     * @param response
     * @return {OauthToken}
     */

  }, {
    key: 'fromOauthProxyResponse',
    value: function fromOauthProxyResponse(response) {
      var token = response.body.token;
      var accessToken = token.access_token,
          refreshToken = token.refresh_token,
          expires = token.expires,
          resourceOwnerId = token.resource_owner_id;


      var props = (0, _extends3.default)({ accessToken: accessToken, refreshToken: refreshToken, expires: expires, resourceOwnerId: resourceOwnerId }, token);
      return new OauthToken(props);
    }

    /**
     * @param {String} accessToken
     * @param {String} refreshToken
     * @param {String} expires
     * @param {String} resourceOwnerId
     * @param {{}} otherProps
     */

  }]);

  function OauthToken(_ref) {
    var accessToken = _ref.accessToken,
        refreshToken = _ref.refreshToken,
        expires = _ref.expires,
        resourceOwnerId = _ref.resourceOwnerId,
        otherProps = (0, _objectWithoutProperties3.default)(_ref, ['accessToken', 'refreshToken', 'expires', 'resourceOwnerId']);
    (0, _classCallCheck3.default)(this, OauthToken);
    return (0, _possibleConstructorReturn3.default)(this, (OauthToken.__proto__ || (0, _getPrototypeOf2.default)(OauthToken)).call(this, (0, _extends3.default)({ accessToken: accessToken, refreshToken: refreshToken, expires: expires, resourceOwnerId: resourceOwnerId }, otherProps)));
  }

  /**
   * @readonly
   * @type {string}
   */


  (0, _createClass3.default)(OauthToken, [{
    key: 'accessToken',
    get: function get() {
      return this.props.accessToken;
    }

    /**
     * @readonly
     * @type {string}
     */

  }, {
    key: 'refreshToken',
    get: function get() {
      return this.props.refreshToken;
    }

    /**
     * @readonly
     * @type {string}
     */

  }, {
    key: 'expires',
    get: function get() {
      return this.props.expires;
    }

    /**
     * @readonly
     * @type {string}
     */

  }, {
    key: 'resourceOwnerId',
    get: function get() {
      return this.props.resourceOwnerId;
    }
  }]);
  return OauthToken;
}(_PropertyBag2.PropertyBag);

/***/ }),

/***/ "K9HL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyBag = undefined;

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__("iK2U");

var _stringify2 = _interopRequireDefault(_stringify);

var _objectWithoutProperties2 = __webpack_require__("iy81");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 */
var PropertyBag =
/**
 * @param {{}} props
 */
exports.PropertyBag = function PropertyBag(_ref) {
  var _this = this;

  var props = (0, _objectWithoutProperties3.default)(_ref, []);
  (0, _classCallCheck3.default)(this, PropertyBag);

  this.getProperty = function (propName) {
    if (_this.props.hasOwnProperty(propName)) {
      return _this.props[propName];
    }

    return undefined;
  };

  this.toJSON = function () {
    return _this.toJS();
  };

  this.toJS = function () {
    return JSON.parse((0, _stringify2.default)(_this.props));
  };

  this.props = (0, _extends3.default)({}, props);
}

/**
 * @method
 *
 * @param {String} propName
 * @return {{}}
 */


/**
 * @method
 *
 * @return {Object}
 */


/**
 * @method
 *
 * @return {Object}
 */
;

/***/ }),

/***/ "KIIz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("UHHj");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("F0gX");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "Kf0p":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__("50hw")
  , ITERATOR   = __webpack_require__("XGUc")('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),

/***/ "LBxF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

utils.getOption = getOption;

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),

/***/ "LO75":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("XGUc");

/***/ }),

/***/ "MmDC":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__("ngM3")
  , dPs         = __webpack_require__("MvNI")
  , enumBugKeys = __webpack_require__("u2hb")
  , IE_PROTO    = __webpack_require__("JYxG")('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("ZVhn")('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("rq3c").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "MouD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InitProps = undefined;

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = __webpack_require__("iy81");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _typeof2 = __webpack_require__("KIIz");

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = __webpack_require__("q+0m");

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = __webpack_require__("xs8S");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__("XGVB");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _PropertyBag2 = __webpack_require__("K9HL");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 *
 * @type {string}
 */
var paramPrefix = 'dp.';

/**
 * @ignore
 *
 * @type {{dpXconfTag: string, dpWidgetId: string}}
 */
var propNamesMap = {
  dpXconfTag: 'dp.xconf.tag',
  dpWidgetId: 'dp.widgetId'
};

/**
 * @ignore
 *
 * @param {String} str
 * @return {void|*|string|XML}
 */
var toPropName = function toPropName(str) {
  var replace = function replace(match) {
    return match.charAt(1).toUpperCase() + match.substr(2);
  };
  return str.replace(/[.](\w|$)/g, replace);
};

/**
 * @ignore
 * @private
 *
 * @param {String} str
 * @return {string}
 */
var toParamName = function toParamName(str) {
  return paramPrefix + str.replace(/([a-z\d])([A-Z])/g, '$1' + '.' + '$2').replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + '.' + '$2').toLowerCase();
};

/**
 * @ignore
 *
 * @param {String} qs
 * @return {*}
 */
var parseQueryString = function parseQueryString(qs) {
  "use strict";

  var props = {};

  var queryParams = qs.split('&').map(function (nameAndValue) {
    return nameAndValue.split('=');
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(queryParams), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var param = _step.value;

      var _param = (0, _slicedToArray3.default)(param, 2),
          name = _param[0],
          value = _param[1];

      if (name.substr(0, paramPrefix.length) === paramPrefix) {
        var propName = toPropName(name);
        props[propName] = decodeURIComponent(value);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return props;
};

/**
 * @ignore
 * @private
 *
 * @param props
 * @return {*}
 */
var encodeAsQueryString = function encodeAsQueryString(props) {
  "use strict";

  var reducer = function reducer(acc, key) {
    var paramKey = toParamName(key);
    var paramValue = encodeURIComponent(props[key]);

    return acc + (acc === '' ? '' : '&') + (paramKey + '=' + paramValue);
  };

  return (0, _keys2.default)(props).reduce(reducer, '');
};

/**
 * @class
 */

var InitProps = function (_PropertyBag) {
  (0, _inherits3.default)(InitProps, _PropertyBag);
  (0, _createClass3.default)(InitProps, null, [{
    key: 'validate',

    /**
     * @param {*|InitProps} propsOrInstance
     * @return {boolean}
     */
    value: function validate(propsOrInstance) {
      if (propsOrInstance && (typeof propsOrInstance === 'undefined' ? 'undefined' : (0, _typeof3.default)(propsOrInstance)) === 'object') {
        var dpWidgetId = propsOrInstance.dpWidgetId;


        return dpWidgetId && typeof dpWidgetId === 'string' && dpWidgetId != '';
      }

      return false;
    }

    /**
     * @type {string} queryString
     * @return {InitProps|null}
     */

  }, {
    key: 'fromQueryString',
    value: function fromQueryString(queryString) {
      var initParams = parseQueryString(queryString);
      if (InitProps.validate(initParams)) {
        return new InitProps(initParams);
      }

      return null;
    }

    /**
     * @param {Window} windowObject
     * @return {InitProps}
     */

  }, {
    key: 'fromWindow',
    value: function fromWindow(windowObject) {
      var location = windowObject.location;

      // build a list of potential sources for init params, ordered by priority

      var paramsQueryStrings = [location.hash.length ? location.hash.substring(1) : null, location.search.length ? location.search.substring(1) : null].filter(function (string) {
        return !!string;
      });

      if (paramsQueryStrings.length === 0) {
        return null;
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(paramsQueryStrings), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var queryString = _step2.value;

          var initParams = InitProps.fromQueryString(queryString);
          if (initParams) {
            return initParams;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null;
    }

    /**
     * @param {string} dpXconfTag
     * @param {string} dpWidgetId
     * @param rest
     */

  }, {
    key: 'PARAM_PREFIX',

    /**
     * @type {string}
     */
    get: function get() {
      return paramPrefix;
    }
  }, {
    key: 'PROP_NAMES',


    /**
     * @type {{dpXconfTag: string, dpWidgetId: string}}
     */
    get: function get() {
      return propNamesMap;
    }
  }]);

  function InitProps(_ref) {
    var dpXconfTag = _ref.dpXconfTag,
        dpWidgetId = _ref.dpWidgetId,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['dpXconfTag', 'dpWidgetId']);
    (0, _classCallCheck3.default)(this, InitProps);
    return (0, _possibleConstructorReturn3.default)(this, (InitProps.__proto__ || (0, _getPrototypeOf2.default)(InitProps)).call(this, (0, _extends3.default)({ dpXconfTag: dpXconfTag, dpWidgetId: dpWidgetId }, rest)));
  }

  /**
   * @deprecated
   *
   * @type {String}
   */


  (0, _createClass3.default)(InitProps, [{
    key: 'toQueryString',


    /**
     * @method
     *
     * @return {string}
     */
    value: function toQueryString() {
      return encodeAsQueryString(this.props);
    }
  }, {
    key: 'dpXconfTag',
    get: function get() {
      return this.props.dpXconfTag;
    }

    /**
     * @type {string}
     */

  }, {
    key: 'dpWidgetId',
    get: function get() {
      return this.props.dpWidgetId;
    }
  }]);
  return InitProps;
}(_PropertyBag2.PropertyBag);

exports.InitProps = InitProps;

/***/ }),

/***/ "MvNI":
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__("PR1c")
  , anObject = __webpack_require__("ngM3")
  , getKeys  = __webpack_require__("GBSe");

module.exports = __webpack_require__("NLIV") ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),

/***/ "NLIV":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("gM7W")(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),

/***/ "Nwwp":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("skuU");
__webpack_require__("IlDj");
module.exports = __webpack_require__("E3Jr");

/***/ }),

/***/ "Og1S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global console: false */

/**
 * Reporter that handles the reporting of logs, warnings and errors.
 * @public
 * @param {boolean} quiet Tells if the reporter should be quiet or not.
 */
module.exports = function(quiet) {
    function noop() {
        //Does nothing.
    }

    var reporter = {
        log: noop,
        warn: noop,
        error: noop
    };

    if(!quiet && window.console) {
        var attachFunction = function(reporter, name) {
            //The proxy is needed to be able to call the method with the console context,
            //since we cannot use bind.
            reporter[name] = function reporterProxy() {
                var f = console[name];
                if (f.apply) { //IE9 does not support console.log.apply :)
                    f.apply(console, arguments);
                } else {
                    for (var i = 0; i < arguments.length; i++) {
                        f(arguments[i]);
                    }
                }
            };
        };

        attachFunction(reporter, "log");
        attachFunction(reporter, "warn");
        attachFunction(reporter, "error");
    }

    return reporter;
};

/***/ }),

/***/ "OmsT":
/***/ (function(module, exports, __webpack_require__) {

var core  = __webpack_require__("Y4Oj")
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

/***/ }),

/***/ "OpEi":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("ofgR")
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),

/***/ "OvYF":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("nl26");
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),

/***/ "PJO8":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("3/3c")
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__("MmDC")});

/***/ }),

/***/ "PR1c":
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__("ngM3")
  , IE8_DOM_DEFINE = __webpack_require__("JU1L")
  , toPrimitive    = __webpack_require__("I8xC")
  , dP             = Object.defineProperty;

exports.f = __webpack_require__("NLIV") ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ "Pob6":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("hYG7");
module.exports = __webpack_require__("Y4Oj").Object.setPrototypeOf;

/***/ }),

/***/ "Q0K3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TicketContext = undefined;

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = __webpack_require__("iy81");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _TabContext2 = __webpack_require__("E60P");

var _Event = __webpack_require__("kJI2");

var _TicketEvents = __webpack_require__("p+xz");

var _CustomFields = __webpack_require__("S6PW");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 * @extends {Context}
 */
/**
 * @module Context/TicketContext
 */

var TicketContext = exports.TicketContext = function (_TabContext) {
  (0, _inherits3.default)(TicketContext, _TabContext);
  (0, _createClass3.default)(TicketContext, null, [{
    key: 'tryAndCreate',


    /**
     * @method
     * @static
     *
     * @param {EventDispatcher} outgoingDispatcher
     * @param {EventDispatcher} incomingDispatcher
     * @param {InstanceProps} instanceProps
     * @param {ContextProps} contextProps
     * @return {TicketContext|null}
     */
    value: function tryAndCreate(_ref) {
      var outgoingDispatcher = _ref.outgoingDispatcher,
          incomingDispatcher = _ref.incomingDispatcher,
          instanceProps = _ref.instanceProps,
          contextProps = _ref.contextProps;

      if (contextProps.contextType === TicketContext.TYPE) {
        var props = (0, _extends3.default)({
          outgoingDispatcher: outgoingDispatcher,
          incomingDispatcher: incomingDispatcher
        }, contextProps.toJS(), {
          type: contextProps.contextType,
          instanceId: instanceProps.instanceId
        });
        return new TicketContext(props);
      }

      return null;
    }

    /**
     * @constructor
     *
     * @param {string} instanceId
     * @param {{}} rest
     */

  }, {
    key: 'TYPE',

    /**
     * @static
     * @readonly
     * @type {string}
     */
    get: function get() {
      return 'ticket';
    }
  }]);

  function TicketContext(_ref2) {
    var instanceId = _ref2.instanceId,
        rest = (0, _objectWithoutProperties3.default)(_ref2, ['instanceId']);
    (0, _classCallCheck3.default)(this, TicketContext);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TicketContext.__proto__ || (0, _getPrototypeOf2.default)(TicketContext)).call(this, (0, _extends3.default)({ instanceId: instanceId }, rest)));

    _this.on = function (eventName, eventHandler) {
      // the event is not an incoming event so we can't subscribe to it
      if (!(0, _TicketEvents.matchEvent)(eventName, { channelType: _Event.CHANNEL_INCOMING })) {
        return;
      }

      _this.props.outgoingDispatcher.emitAsync('app.subscribe_to_event', { events: [eventName] }).then(function () {
        return _this.props.incomingDispatcher.on(eventName, eventHandler);
      });
    };

    return _this;
  }

  /**
   * @param {string} eventName
   * @param {object} eventHandler
   */


  (0, _createClass3.default)(TicketContext, [{
    key: 'customFields',


    /**
     * @public
     * @return {CustomFieldsClient}
     */
    get: function get() {
      var _props = this.props,
          outgoingDispatcher = _props.outgoingDispatcher,
          instanceId = _props.instanceId;

      return new _CustomFields.CustomFieldsClient({
        outgoingDispatcher: outgoingDispatcher,
        instanceId: instanceId,
        endpoint: 'tickets/' + this.entityId
      });
    }
  }]);
  return TicketContext;
}(_TabContext2.TabContext);

/***/ }),

/***/ "QIOw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventName = exports.eventNames = exports.props = exports.EVENT_ENTITY_FETCHED = exports.EVENT_APP_FETCHED = exports.EVENT_ENTITY_CHANGED = exports.EVENT_APP_CHANGED = undefined;

var _keys = __webpack_require__("q+0m");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Storage/Events module.
 * @module Storage/Events
 */

/**
 * @type {string}
 */
var EVENT_APP_CHANGED = exports.EVENT_APP_CHANGED = 'storage.app.changed';

/**
 * @type {string}
 */
var EVENT_ENTITY_CHANGED = exports.EVENT_ENTITY_CHANGED = 'storage.entity.changed';

/**
 * @type {string}
 */
var EVENT_APP_FETCHED = exports.EVENT_APP_FETCHED = 'storage.app.fetched';

/**
 * @type {string}
 */
var EVENT_ENTITY_FETCHED = exports.EVENT_ENTITY_FETCHED = 'storage.entity.fetched';

/**
 * @readonly
 * @enum {string}
 * @type {{EVENT_APP_CHANGED: string, EVENT_ENTITY_CHANGED: string, EVENT_APP_FETCHED: string, EVENT_ENTITY_FETCHED: string}}
 */
var events = {
  EVENT_APP_CHANGED: EVENT_APP_CHANGED,
  EVENT_ENTITY_CHANGED: EVENT_ENTITY_CHANGED,
  EVENT_APP_FETCHED: EVENT_APP_FETCHED,
  EVENT_ENTITY_FETCHED: EVENT_ENTITY_FETCHED
};

/**
 * @constant
 *
 * @type {{}}
 */
var props = exports.props = events;

/**
 * @constant
 *
 * @type {Array}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 *
 * @param {String} name
 * @return {boolean}
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};

/***/ }),

/***/ "QqyQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("ED1s");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("fQko");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__("Dfz+");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _temp, _initialiseProps;

var _AppEvents = __webpack_require__("nadw");

var AppEvents = _interopRequireWildcard(_AppEvents);

var _Context = __webpack_require__("peDZ");

var _UI = __webpack_require__("t2//");

var _Storage = __webpack_require__("yNLq");

var _WebAPI = __webpack_require__("qvG3");

var _DeskproWindow = __webpack_require__("v3IQ");

var _Security = __webpack_require__("Xjm4");

var _Event = __webpack_require__("kJI2");

var Event = _interopRequireWildcard(_Event);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 */
var App = (_temp = _class = function () {
  /**
   * @param {EventDispatcher} outgoingDispatcher
   * @param {EventDispatcher} incomingDispatcher
   * @param {EventDispatcher} internalDispatcher
   * @param {InstanceProps} instanceProps
   * @param {ContextProps} contextProps
   */
  function App(_ref) {
    var outgoingDispatcher = _ref.outgoingDispatcher,
        incomingDispatcher = _ref.incomingDispatcher,
        internalDispatcher = _ref.internalDispatcher,
        instanceProps = _ref.instanceProps,
        contextProps = _ref.contextProps;
    (0, _classCallCheck3.default)(this, App);

    _initialiseProps.call(this);

    var context = (0, _Context.createContext)(outgoingDispatcher, incomingDispatcher, instanceProps, contextProps);
    this.props = {
      outgoingDispatcher: outgoingDispatcher,
      incomingDispatcher: incomingDispatcher,
      internalDispatcher: internalDispatcher,
      instanceProps: instanceProps,
      contextProps: contextProps,
      restApi: (0, _WebAPI.createDeskproApiClient)(outgoingDispatcher),
      storageApi: (0, _Storage.createStorageAPIClient)(outgoingDispatcher, internalDispatcher, instanceProps, contextProps),
      deskproWindow: (0, _DeskproWindow.createDeskproWindowFacade)(outgoingDispatcher),
      context: context,
      ui: (0, _UI.create)(internalDispatcher),
      oauth: (0, _Security.createOauthAPIClient)(outgoingDispatcher, internalDispatcher, instanceProps, contextProps)
    };

    this._state = {
      isResizing: false,
      appTitle: instanceProps.appTitle,
      badgeCount: 0
    };
  }

  // EVENT EMITTER API

  /**
   * @public
   * @return {EventDispatcher}
   */


  (0, _createClass3.default)(App, [{
    key: 'emit',


    /**
     * @public
     * @method
     * @param {string|{}} event
     * @param args
     * @return {Promise.<*>}
     */
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var outgoingDispatcher, internalDispatcher, dispatcherArgs;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(Event.isInvocation(event) && args.length > 0)) {
                  _context.next = 3;
                  break;
                }

                outgoingDispatcher = this.props.outgoingDispatcher;
                return _context.abrupt('return', outgoingDispatcher.emitInvokeAsync((0, _extends3.default)({}, event, { data: args[0] })));

              case 3:

                // internal event
                internalDispatcher = this.props.internalDispatcher;
                dispatcherArgs = [event].concat(args);

                internalDispatcher.emit.apply(internalDispatcher, dispatcherArgs);
                return _context.abrupt('return', _promise2.default.resolve(args));

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function emit(_x) {
        return _ref2.apply(this, arguments);
      }

      return emit;
    }()

    // Properties API

    /**
     * @public
     * @method
     * @param {String} propertyName
     * @return {String|null|undefined}
     */

  }, {
    key: 'eventDispatcher',
    get: function get() {
      return this.props.internalDispatcher;
    }

    /**
     * @public
     * @param {String} eventName
     * @param {function} listener
     */


    /**
     * @public
     * @method
     * @param {String} eventName
     * @param {function} listener
     */


    /**
     * @public
     * @method
     * @param {String} eventName
     * @param {function} listener
     */

  }, {
    key: 'properties',


    /**
     * @public
     * @return {Object}
     */
    get: function get() {
      var _props = this.props,
          instanceProps = _props.instanceProps,
          contextProps = _props.contextProps;


      var instanceProperties = instanceProps.toJS();
      var contextProperties = contextProps.toJS();

      return (0, _extends3.default)({}, instanceProperties, contextProperties);
    }

    /**
     * @public
     * @return {'production'|'development'}
     */

  }, {
    key: 'environment',
    get: function get() {
      var defaultEnvironment = 'production';

      var contextProps = this.props.contextProps;

      var env = contextProps.getProperty('appsEnvironment');
      return env || defaultEnvironment;
    }

    /**
     * @public
     * @return {String}
     */

  }, {
    key: 'appId',
    get: function get() {
      return this.props.instanceProps.appId;
    }

    /**
     * @public
     * @return {String}
     */

  }, {
    key: 'appTitle',
    get: function get() {
      return this._state.appTitle;
    }

    /**
     * @public
     * @param {String} newTitle
     */
    ,
    set: function set(newTitle) {
      var oldTitle = this._state.appTitle;

      if (newTitle !== oldTitle) {
        this._state.appTitle = newTitle;

        var eventDispatcher = this.props.eventDispatcher;

        eventDispatcher.emit(AppEvents.EVENT_TITLE_CHANGED, newTitle, oldTitle);
      }
    }
  }, {
    key: 'packageName',


    /**
     * public
     * @return {String}
     */
    get: function get() {
      return this.props.instanceProps.appPackageName;
    }

    /**
     * public
     * @return {String}
     */

  }, {
    key: 'instanceId',
    get: function get() {
      return this.props.instanceProps.instanceId;
    }

    // OAUTH API

    /**
     * @public
     * @return {OauthFacade}
     */

  }, {
    key: 'oauth',
    get: function get() {
      return this.props.oauth;
    }

    // Settings API

    /**
     * @public
     * @return {Array}
     */

  }, {
    key: 'settings',
    get: function get() {
      return [];
    }

    // Misc API

    /**
     * @public
     * @method
     */


    /**
     * @public
     * @method
     */

  }, {
    key: 'ui',


    // CLIENTS

    /**
     * @public
     * @return {UIFacade}
     */
    get: function get() {
      return this.props.ui;
    }

    /**
     * @public
     * @return {DeskproWindowFacade}
     */

  }, {
    key: 'deskproWindow',
    get: function get() {
      return this.props.deskproWindow;
    }
  }, {
    key: 'restApi',


    /**
     * @public
     * @return {DeskproAPIClient}
     */
    get: function get() {
      return this.props.restApi;
    }
  }, {
    key: 'state',


    /**
     * @deprecated
     * 
     * @public
     * @return {StorageApiFacade}
     */
    get: function get() {
      return this.props.storageApi;
    }
  }, {
    key: 'storage',


    /**
     * @public
     * @return {StorageApiFacade}
     */
    get: function get() {
      return this.props.storageApi;
    }
  }, {
    key: 'context',


    /**
     * @public
     * @return {Context}
     */
    get: function get() {
      return this.props.context;
    }
  }]);
  return App;
}(), _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.on = function (eventName, listener) {
    // TODO need to check if eventName is an internal one, for now just assume everyything is
    _this.eventDispatcher.on(eventName, listener);
  };

  this.off = function (eventName, listener) {
    // TODO need to check if eventName is an internal one, for now just assume everything is
    _this.eventDispatcher.removeListener(eventName, listener);
  };

  this.once = function (eventName, listener) {
    // TODO need to check if eventName is an internal one, for now just assume everything is
    _this.eventDispatcher.once(eventName, listener);
  };

  this.getProperty = function (propertyName) {
    var _props2 = _this.props,
        instanceProps = _props2.instanceProps,
        contextProps = _props2.contextProps;

    var value = instanceProps.getProperty(propertyName);

    if (value === undefined) {
      value = contextProps.getProperty(propertyName);
    }

    return value;
  };

  this.resetAppTitle = function () {
    _this.appTitle = _this.props.instanceProps.appTitle;
  };

  this.refresh = function () {
    var eventDispatcher = _this.props.internalDispatcher;

    eventDispatcher.emit(AppEvents.EVENT_REFRESH);
  };

  this.unload = function () {
    var eventDispatcher = _this.props.internalDispatcher;

    eventDispatcher.emit(AppEvents.EVENT_UNLOAD);
  };

  this.log = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    console.log.apply(console, args);
  };
}, _temp);
exports.default = App;

/***/ }),

/***/ "R5tu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UIFacade = undefined;

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _Events = __webpack_require__("zKo7");

var Events = _interopRequireWildcard(_Events);

var _Constants = __webpack_require__("tMk4");

var Constants = _interopRequireWildcard(_Constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 */
var UIFacade = exports.UIFacade = function () {
  /**
   * @param {EventDispatcher} UIEventsDispatcher
   */
  function UIFacade(UIEventsDispatcher) {
    var _this = this;

    (0, _classCallCheck3.default)(this, UIFacade);

    this.showMenu = function () {
      var _props = _this.props,
          eventDispatcher = _props.eventDispatcher,
          oldVisibility = _props.menu;

      var newVisibility = Constants.VISIBILITY_VISIBLE;

      if (oldVisibility !== newVisibility) {
        _this.props.menu = newVisibility;
        eventDispatcher.emit(Events.EVENT_MENU_VISIBILITYCHANGED, newVisibility, oldVisibility);
      }
    };

    this.hideMenu = function () {
      var _props2 = _this.props,
          eventDispatcher = _props2.eventDispatcher,
          oldVisibility = _props2.menu;

      var newVisibility = Constants.VISIBILITY_HIDDEN;

      if (oldVisibility !== newVisibility) {
        _this.props.menu = newVisibility;
        eventDispatcher.emit(Events.EVENT_MENU_VISIBILITYCHANGED, newVisibility, oldVisibility);
      }
    };

    this.showBadgeCount = function () {
      var newVisibility = Constants.VISIBILITY_VISIBLE;
      var _props3 = _this.props,
          eventDispatcher = _props3.eventDispatcher,
          oldVisibility = _props3.badge;


      if (oldVisibility !== newVisibility) {
        _this.props.badge = newVisibility;
        eventDispatcher.emit(Events.EVENT_BADGE_VISIBILITYCHANGED, newVisibility, oldVisibility);
      }
    };

    this.hideBadgeCount = function () {
      var newVisibility = Constants.VISIBILITY_HIDDEN;
      var _props4 = _this.props,
          eventDispatcher = _props4.eventDispatcher,
          oldVisibility = _props4.badge;


      if (oldVisibility !== newVisibility) {
        _this.props.badge = newVisibility;
        eventDispatcher.emit(Events.EVENT_BADGE_VISIBILITYCHANGED, newVisibility, oldVisibility);
      }
    };

    this.isVisible = function () {
      return _this.props.visibility === Constants.VISIBILITY_VISIBLE;
    };

    this.isHidden = function () {
      return _this.props.visibility === Constants.VISIBILITY_HIDDEN;
    };

    this.show = function () {
      var newVisibility = Constants.VISIBILITY_VISIBLE;
      var _props5 = _this.props,
          eventDispatcher = _props5.eventDispatcher,
          oldVisibility = _props5.visibility;


      if (oldVisibility !== newVisibility) {
        var emit = eventDispatcher.emitCancelable(Events.EVENT_UI_BEFOREVISIBILITYCHANGED, function () {
          _this.props.visibility = newVisibility;
        });

        emit(Events.EVENT_UI_VISIBILITYCHANGED, newVisibility, oldVisibility);
      }
    };

    this.hide = function () {
      var newVisibility = Constants.VISIBILITY_HIDDEN;
      var _props6 = _this.props,
          eventDispatcher = _props6.eventDispatcher,
          oldVisibility = _props6.visibility;


      if (oldVisibility !== newVisibility) {
        var emit = eventDispatcher.emitCancelable(Events.EVENT_UI_BEFOREVISIBILITYCHANGED, function () {
          _this.props.visibility = newVisibility;
        });

        emit(Events.EVENT_UI_VISIBILITYCHANGED, newVisibility, oldVisibility);
      }
    };

    this.isExpanded = function () {
      return _this.props.display === Constants.DISPLAY_EXPANDED;
    };

    this.isCollapsed = function () {
      return _this.props.display === Constants.DISPLAY_COLLAPSED;
    };

    this.collapse = function () {
      var newDisplay = Constants.DISPLAY_COLLAPSED;
      var _props7 = _this.props,
          eventDispatcher = _props7.eventDispatcher,
          oldDisplay = _props7.display;


      if (oldDisplay !== newDisplay) {
        var emit = eventDispatcher.emitCancelable(Events.EVENT_UI_BEFOREDISPLAYCHANGED, function () {
          _this.props.display = newDisplay;
        });

        emit(Events.EVENT_UI_DISPLAYCHANGED, newDisplay, oldDisplay);
      }
    };

    this.expand = function () {
      var newDisplay = Constants.DISPLAY_EXPANDED;
      var _props8 = _this.props,
          eventDispatcher = _props8.eventDispatcher,
          oldDisplay = _props8.display;


      if (oldDisplay !== newDisplay) {
        var emit = eventDispatcher.emitCancelable(Events.EVENT_UI_BEFOREDISPLAYCHANGED, function () {
          _this.props.display = newDisplay;
        });

        emit(Events.EVENT_UI_DISPLAYCHANGED, newDisplay, oldDisplay);
      }
    };

    this.isLoading = function () {
      return _this.props.state === Constants.STATE_LOADING;
    };

    this.isReady = function () {
      return _this.props.state === Constants.STATE_READY;
    };

    this.showLoading = function () {
      var _props9 = _this.props,
          eventDispatcher = _props9.eventDispatcher,
          state = _props9.state;


      if (state !== Constants.STATE_LOADING) {
        _this.props.state = Constants.STATE_LOADING;
        eventDispatcher.emit(Events.EVENT_UI_STATECHANGED, Constants.STATE_LOADING, state);
      }
    };

    this.hideLoading = function () {
      var _props10 = _this.props,
          eventDispatcher = _props10.eventDispatcher,
          state = _props10.state;


      if (state === Constants.STATE_LOADING) {
        _this.props.state = Constants.STATE_READY;
        eventDispatcher.emit(Events.EVENT_UI_STATECHANGED, Constants.STATE_READY, state);
      }
    };

    this.showSettings = function () {
      var newVisibility = Constants.VISIBILITY_VISIBLE;
      var _props11 = _this.props,
          eventDispatcher = _props11.eventDispatcher,
          oldVisibility = _props11.settings;


      if (oldVisibility !== newVisibility) {
        _this.props.settings = newVisibility;
        eventDispatcher.emit(Events.EVENT_SETTINGS_VISIBILITYCHANGED, newVisibility, oldVisibility);
      }
    };

    this.props = {
      eventDispatcher: UIEventsDispatcher,
      display: Constants.DISPLAY_EXPANDED, // expanded, collapsed
      visibility: Constants.VISIBILITY_VISIBLE, // visible, hidden
      state: Constants.STATE_READY, // loading, ready, empty, error, ? partial
      menu: Constants.VISIBILITY_VISIBLE, // visible, hidden
      badge: Constants.VISIBILITY_HIDDEN, // visible, hidden
      settings: Constants.VISIBILITY_HIDDEN, // visible, hidden
      badgeCount: 0,
      isResizing: false
    };
  }

  // MENU API

  (0, _createClass3.default)(UIFacade, [{
    key: 'menu',
    get: function get() {
      return this.props.menu;
    }

    /**
     * @method
     */


    /**
     * @method
     */

  }, {
    key: 'badge',


    // BADGE API

    /**
     * @readonly
     * @type {string}
     */
    get: function get() {
      return this.props.badge;
    }

    /**
     * @method
     */


    /**
     * @method
     */

  }, {
    key: 'badgeCount',


    /**
     * @type {number}
     */
    get: function get() {
      return this.props.badgeCount;
    }

    /**
     * @param {number} newCount
     */
    ,
    set: function set(newCount) {
      var _props12 = this.props,
          eventDispatcher = _props12.eventDispatcher,
          oldCount = _props12.badgeCount;

      this.props.badgeCount = newCount;

      if (oldCount !== newCount) {
        eventDispatcher.emit(Events.EVENT_BADGE_COUNTCHANGED, newCount, oldCount);
      }
    }

    // APP VISIBILITY API

    /**
     * @readonly
     * @type {string}
     */

  }, {
    key: 'visibility',
    get: function get() {
      return this.props.visibility;
    }

    /**
     * @method
     *
     * @return {boolean}
     */


    /**
     * @method
     *
     * @return {boolean}
     */


    /**
     * @method
     */


    /**
     * @method
     */

  }, {
    key: 'display',


    // APP DISPLAY / APP LAYOUT API

    /**
     * @readonly
     * @type {string}
     */
    get: function get() {
      return this.props.display;
    }

    /**
     * @method
     *
     * @return {boolean}
     */


    /**
     * @method
     *
     * @return {boolean}
     */


    /**
     * @method
     */


    /**
     * @method
     */

  }, {
    key: 'state',


    // UI STATE API

    /**
     * @readonly
     * @type {string}
     */
    get: function get() {
      return this.props.state;
    }

    /**
     * @method
     *
     * @return {boolean}
     */


    /**
     * @method
     *
     * @return {boolean}
     */


    /**
     * @method
     */


    /**
     * @method
     */


    // SETTINGS API

    /**
     * @method
     */

  }]);
  return UIFacade;
}();

/***/ }),

/***/ "RIJu":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("mkZG");
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ "RTjf":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("6uSB");
module.exports = __webpack_require__("Y4Oj").Object.assign;

/***/ }),

/***/ "Rln+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("RTjf"), __esModule: true };

/***/ }),

/***/ "S1QW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
 */



var forEach = __webpack_require__("dbB1").forEach;

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;
    var hasState        = options.stateHandler.hasState;
    var idHandler       = options.idHandler;

    if (!batchProcessor) {
        throw new Error("Missing required dependency: batchProcessor");
    }

    if (!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    //TODO: Could this perhaps be done at installation time?
    var scrollbarSizes = getScrollbarSizes();

    // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
    // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
    var styleId = "erd_scroll_detection_scrollbar_style";
    var detectionContainerClass = "erd_scroll_detection_container";
    injectScrollStyle(styleId, detectionContainerClass);

    function getScrollbarSizes() {
        var width = 500;
        var height = 500;

        var child = document.createElement("div");
        child.style.cssText = "position: absolute; width: " + width*2 + "px; height: " + height*2 + "px; visibility: hidden; margin: 0; padding: 0;";

        var container = document.createElement("div");
        container.style.cssText = "position: absolute; width: " + width + "px; height: " + height + "px; overflow: scroll; visibility: none; top: " + -width*3 + "px; left: " + -height*3 + "px; visibility: hidden; margin: 0; padding: 0;";

        container.appendChild(child);

        document.body.insertBefore(container, document.body.firstChild);

        var widthSize = width - container.clientWidth;
        var heightSize = height - container.clientHeight;

        document.body.removeChild(container);

        return {
            width: widthSize,
            height: heightSize
        };
    }

    function injectScrollStyle(styleId, containerClass) {
        function injectStyle(style, method) {
            method = method || function (element) {
                document.head.appendChild(element);
            };

            var styleElement = document.createElement("style");
            styleElement.innerHTML = style;
            styleElement.id = styleId;
            method(styleElement);
            return styleElement;
        }

        if (!document.getElementById(styleId)) {
            var containerAnimationClass = containerClass + "_animation";
            var containerAnimationActiveClass = containerClass + "_animation_active";
            var style = "/* Created by the element-resize-detector library. */\n";
            style += "." + containerClass + " > div::-webkit-scrollbar { display: none; }\n\n";
            style += "." + containerAnimationActiveClass + " { -webkit-animation-duration: 0.1s; animation-duration: 0.1s; -webkit-animation-name: " + containerAnimationClass + "; animation-name: " + containerAnimationClass + "; }\n";
            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
            injectStyle(style);
        }
    }

    function addAnimationClass(element) {
        element.className += " " + detectionContainerClass + "_animation_active";
    }

    function addEvent(el, name, cb) {
        if (el.addEventListener) {
            el.addEventListener(name, cb);
        } else if(el.attachEvent) {
            el.attachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to add event listeners.");
        }
    }

    function removeEvent(el, name, cb) {
        if (el.removeEventListener) {
            el.removeEventListener(name, cb);
        } else if(el.detachEvent) {
            el.detachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to remove event listeners.");
        }
    }

    function getExpandElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
    }

    function getShrinkElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        var listeners = getState(element).listeners;

        if (!listeners.push) {
            throw new Error("Cannot add listener to an element that is not detectable.");
        }

        getState(element).listeners.push(listener);
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};

        function debug() {
            if (options.debug) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift(idHandler.get(element), "Scroll: ");
                if (reporter.log.apply) {
                    reporter.log.apply(null, args);
                } else {
                    for (var i = 0; i < args.length; i++) {
                        reporter.log(args[i]);
                    }
                }
            }
        }

        function isDetached(element) {
            function isInDocument(element) {
                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element);
            }

            if (!isInDocument(element)) {
                return true;
            }

            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
            if (getComputedStyle(element) === null) {
                return true;
            }

            return false;
        }

        function isUnrendered(element) {
            // Check the absolute positioned container since the top level container is display: inline.
            var container = getState(element).container.childNodes[0];
            var style = getComputedStyle(container);
            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
        }

        function getStyle() {
            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
            var elementStyle            = getComputedStyle(element);
            var style                   = {};
            style.position              = elementStyle.position;
            style.width                 = element.offsetWidth;
            style.height                = element.offsetHeight;
            style.top                   = elementStyle.top;
            style.right                 = elementStyle.right;
            style.bottom                = elementStyle.bottom;
            style.left                  = elementStyle.left;
            style.widthCSS              = elementStyle.width;
            style.heightCSS             = elementStyle.height;
            return style;
        }

        function storeStartSize() {
            var style = getStyle();
            getState(element).startSize = {
                width: style.width,
                height: style.height
            };
            debug("Element start size", getState(element).startSize);
        }

        function initListeners() {
            getState(element).listeners = [];
        }

        function storeStyle() {
            debug("storeStyle invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getStyle();
            getState(element).style = style;
        }

        function storeCurrentSize(element, width, height) {
            getState(element).lastWidth = width;
            getState(element).lastHeight  = height;
        }

        function getExpandChildElement(element) {
            return getExpandElement(element).childNodes[0];
        }

        function getWidthOffset() {
            return 2 * scrollbarSizes.width + 1;
        }

        function getHeightOffset() {
            return 2 * scrollbarSizes.height + 1;
        }

        function getExpandWidth(width) {
            return width + 10 + getWidthOffset();
        }

        function getExpandHeight(height) {
            return height + 10 + getHeightOffset();
        }

        function getShrinkWidth(width) {
            return width * 2 + getWidthOffset();
        }

        function getShrinkHeight(height) {
            return height * 2 + getHeightOffset();
        }

        function positionScrollbars(element, width, height) {
            var expand          = getExpandElement(element);
            var shrink          = getShrinkElement(element);
            var expandWidth     = getExpandWidth(width);
            var expandHeight    = getExpandHeight(height);
            var shrinkWidth     = getShrinkWidth(width);
            var shrinkHeight    = getShrinkHeight(height);
            expand.scrollLeft   = expandWidth;
            expand.scrollTop    = expandHeight;
            shrink.scrollLeft   = shrinkWidth;
            shrink.scrollTop    = shrinkHeight;
        }

        function injectContainerElement() {
            var container = getState(element).container;

            if (!container) {
                container                   = document.createElement("div");
                container.className         = detectionContainerClass;
                container.style.cssText     = "visibility: hidden; display: inline; width: 0px; height: 0px; z-index: -1; overflow: hidden; margin: 0; padding: 0;";
                getState(element).container = container;
                addAnimationClass(container);
                element.appendChild(container);

                var onAnimationStart = function () {
                    getState(element).onRendered && getState(element).onRendered();
                };

                addEvent(container, "animationstart", onAnimationStart);

                // Store the event handler here so that they may be removed when uninstall is called.
                // See uninstall function for an explanation why it is needed.
                getState(element).onAnimationStart = onAnimationStart;
            }

            return container;
        }

        function injectScrollElements() {
            function alterPositionStyles() {
                var style = getState(element).style;

                if(style.position === "static") {
                    element.style.position = "relative";

                    var removeRelativeStyles = function(reporter, element, style, property) {
                        function getNumericalValue(value) {
                            return value.replace(/[^-\d\.]/g, "");
                        }

                        var value = style[property];

                        if(value !== "auto" && getNumericalValue(value) !== "0") {
                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                            element.style[property] = 0;
                        }
                    };

                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                    removeRelativeStyles(reporter, element, style, "top");
                    removeRelativeStyles(reporter, element, style, "right");
                    removeRelativeStyles(reporter, element, style, "bottom");
                    removeRelativeStyles(reporter, element, style, "left");
                }
            }

            function getLeftTopBottomRightCssText(left, top, bottom, right) {
                left = (!left ? "0" : (left + "px"));
                top = (!top ? "0" : (top + "px"));
                bottom = (!bottom ? "0" : (bottom + "px"));
                right = (!right ? "0" : (right + "px"));

                return "left: " + left + "; top: " + top + "; right: " + right + "; bottom: " + bottom + ";";
            }

            debug("Injecting elements");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            alterPositionStyles();

            var rootContainer = getState(element).container;

            if (!rootContainer) {
                rootContainer = injectContainerElement();
            }

            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
            // the targeted element.
            // When the bug is resolved, "containerContainer" may be removed.

            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.

            var scrollbarWidth          = scrollbarSizes.width;
            var scrollbarHeight         = scrollbarSizes.height;
            var containerContainerStyle = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; width: 100%; height: 100%; left: 0px; top: 0px;";
            var containerStyle          = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; " + getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth);
            var expandStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
            var shrinkStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
            var expandChildStyle        = "position: absolute; left: 0; top: 0;";
            var shrinkChildStyle        = "position: absolute; width: 200%; height: 200%;";

            var containerContainer      = document.createElement("div");
            var container               = document.createElement("div");
            var expand                  = document.createElement("div");
            var expandChild             = document.createElement("div");
            var shrink                  = document.createElement("div");
            var shrinkChild             = document.createElement("div");

            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
            containerContainer.dir              = "ltr";

            containerContainer.style.cssText    = containerContainerStyle;
            containerContainer.className        = detectionContainerClass;
            container.className                 = detectionContainerClass;
            container.style.cssText             = containerStyle;
            expand.style.cssText                = expandStyle;
            expandChild.style.cssText           = expandChildStyle;
            shrink.style.cssText                = shrinkStyle;
            shrinkChild.style.cssText           = shrinkChildStyle;

            expand.appendChild(expandChild);
            shrink.appendChild(shrinkChild);
            container.appendChild(expand);
            container.appendChild(shrink);
            containerContainer.appendChild(container);
            rootContainer.appendChild(containerContainer);

            function onExpandScroll() {
                getState(element).onExpand && getState(element).onExpand();
            }

            function onShrinkScroll() {
                getState(element).onShrink && getState(element).onShrink();
            }

            addEvent(expand, "scroll", onExpandScroll);
            addEvent(shrink, "scroll", onShrinkScroll);

            // Store the event handlers here so that they may be removed when uninstall is called.
            // See uninstall function for an explanation why it is needed.
            getState(element).onExpandScroll = onExpandScroll;
            getState(element).onShrinkScroll = onShrinkScroll;
        }

        function registerListenersAndPositionElements() {
            function updateChildSizes(element, width, height) {
                var expandChild             = getExpandChildElement(element);
                var expandWidth             = getExpandWidth(width);
                var expandHeight            = getExpandHeight(height);
                expandChild.style.width     = expandWidth + "px";
                expandChild.style.height    = expandHeight + "px";
            }

            function updateDetectorElements(done) {
                var width           = element.offsetWidth;
                var height          = element.offsetHeight;

                debug("Storing current size", width, height);

                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
                // Otherwise the if-check in handleScroll is useless.
                storeCurrentSize(element, width, height);

                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.

                batchProcessor.add(0, function performUpdateChildSizes() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    if (options.debug) {
                        var w = element.offsetWidth;
                        var h = element.offsetHeight;

                        if (w !== width || h !== height) {
                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
                        }
                    }

                    updateChildSizes(element, width, height);
                });

                batchProcessor.add(1, function updateScrollbars() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    positionScrollbars(element, width, height);
                });

                if (done) {
                    batchProcessor.add(2, function () {
                        if (!getState(element)) {
                            debug("Aborting because element has been uninstalled");
                            return;
                        }

                        if (!areElementsInjected()) {
                          debug("Aborting because element container has not been initialized");
                          return;
                        }

                        done();
                    });
                }
            }

            function areElementsInjected() {
                return !!getState(element).container;
            }

            function notifyListenersIfNeeded() {
                function isFirstNotify() {
                    return getState(element).lastNotifiedWidth === undefined;
                }

                debug("notifyListenersIfNeeded invoked");

                var state = getState(element);

                // Don't notify the if the current size is the start size, and this is the first notification.
                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
                }

                // Don't notify if the size already has been notified.
                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
                    return debug("Not notifying: Size already notified");
                }


                debug("Current size not notified, notifying...");
                state.lastNotifiedWidth = state.lastWidth;
                state.lastNotifiedHeight = state.lastHeight;
                forEach(getState(element).listeners, function (listener) {
                    listener(element);
                });
            }

            function handleRender() {
                debug("startanimation triggered.");

                if (isUnrendered(element)) {
                    debug("Ignoring since element is still unrendered...");
                    return;
                }

                debug("Element rendered.");
                var expand = getExpandElement(element);
                var shrink = getShrinkElement(element);
                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
                    debug("Scrollbars out of sync. Updating detector elements...");
                    updateDetectorElements(notifyListenersIfNeeded);
                }
            }

            function handleScroll() {
                debug("Scroll detected.");

                if (isUnrendered(element)) {
                    // Element is still unrendered. Skip this scroll event.
                    debug("Scroll event fired while unrendered. Ignoring...");
                    return;
                }

                var width = element.offsetWidth;
                var height = element.offsetHeight;

                if (width !== element.lastWidth || height !== element.lastHeight) {
                    debug("Element size changed.");
                    updateDetectorElements(notifyListenersIfNeeded);
                } else {
                    debug("Element size has not changed (" + width + "x" + height + ").");
                }
            }

            debug("registerListenersAndPositionElements invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            getState(element).onRendered = handleRender;
            getState(element).onExpand = handleScroll;
            getState(element).onShrink = handleScroll;

            var style = getState(element).style;
            updateChildSizes(element, style.width, style.height);
        }

        function finalizeDomMutation() {
            debug("finalizeDomMutation invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getState(element).style;
            storeCurrentSize(element, style.width, style.height);
            positionScrollbars(element, style.width, style.height);
        }

        function ready() {
            callback(element);
        }

        function install() {
            debug("Installing...");
            initListeners();
            storeStartSize();

            batchProcessor.add(0, storeStyle);
            batchProcessor.add(1, injectScrollElements);
            batchProcessor.add(2, registerListenersAndPositionElements);
            batchProcessor.add(3, finalizeDomMutation);
            batchProcessor.add(4, ready);
        }

        debug("Making detectable...");

        if (isDetached(element)) {
            debug("Element is detached");

            injectContainerElement();

            debug("Waiting until element is attached...");

            getState(element).onRendered = function () {
                debug("Element is now attached");
                install();
            };
        } else {
            install();
        }
    }

    function uninstall(element) {
        var state = getState(element);

        if (!state) {
            // Uninstall has been called on a non-erd element.
            return;
        }

        // Uninstall may have been called in the following scenarios:
        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
        // So to be on the safe side, let's check for each thing before removing.

        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);

        state.container && element.removeChild(state.container);
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),

/***/ "S6PW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CustomFieldsClient = __webpack_require__("SfmA");

Object.defineProperty(exports, 'CustomFieldsClient', {
  enumerable: true,
  get: function get() {
    return _CustomFieldsClient.CustomFieldsClient;
  }
});

/***/ }),

/***/ "SKY5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects objects to elements in order to detect resize events.
 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
 */



var browserDetector = __webpack_require__("Saiw");

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;

    if(!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        if(!getObject(element)) {
            throw new Error("Element is not detectable by this strategy.");
        }

        function listenerProxy() {
            listener(element);
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support object, but supports the resize event directly on elements.
            getState(element).object = {
                proxy: listenerProxy
            };
            element.attachEvent("onresize", listenerProxy);
        } else {
            var object = getObject(element);
            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
        }
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};
        var debug = options.debug;

        function injectObject(element, callback) {
            var OBJECT_STYLE = "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; padding: 0; margin: 0; opacity: 0; z-index: -1000; pointer-events: none;";

            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.

            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
            var positionCheckPerformed = false;

            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
            var style = window.getComputedStyle(element);
            var width = element.offsetWidth;
            var height = element.offsetHeight;

            getState(element).startSize = {
                width: width,
                height: height
            };

            function mutateDom() {
                function alterPositionStyles() {
                    if(style.position === "static") {
                        element.style.position = "relative";

                        var removeRelativeStyles = function(reporter, element, style, property) {
                            function getNumericalValue(value) {
                                return value.replace(/[^-\d\.]/g, "");
                            }

                            var value = style[property];

                            if(value !== "auto" && getNumericalValue(value) !== "0") {
                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                                element.style[property] = 0;
                            }
                        };

                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                        removeRelativeStyles(reporter, element, style, "top");
                        removeRelativeStyles(reporter, element, style, "right");
                        removeRelativeStyles(reporter, element, style, "bottom");
                        removeRelativeStyles(reporter, element, style, "left");
                    }
                }

                function onObjectLoad() {
                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
                    if (!positionCheckPerformed) {
                        alterPositionStyles();
                    }

                    /*jshint validthis: true */

                    function getDocument(element, callback) {
                        //Opera 12 seem to call the object.onload before the actual document has been created.
                        //So if it is not present, poll it with an timeout until it is present.
                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
                        if(!element.contentDocument) {
                            setTimeout(function checkForObjectDocument() {
                                getDocument(element, callback);
                            }, 100);

                            return;
                        }

                        callback(element.contentDocument);
                    }

                    //Mutating the object element here seems to fire another load event.
                    //Mutating the inner document of the object element is fine though.
                    var objectElement = this;

                    //Create the style element to be added to the object.
                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
                        //Notify that the element is ready to be listened to.
                        callback(element);
                    });
                }

                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
                if (style.position !== "") {
                    alterPositionStyles(style);
                    positionCheckPerformed = true;
                }

                //Add an object element as a child to the target element that will be listened to for resize events.
                var object = document.createElement("object");
                object.style.cssText = OBJECT_STYLE;
                object.tabIndex = -1;
                object.type = "text/html";
                object.onload = onObjectLoad;

                //Safari: This must occur before adding the object to the DOM.
                //IE: Does not like that this happens before, even if it is also added after.
                if(!browserDetector.isIE()) {
                    object.data = "about:blank";
                }

                element.appendChild(object);
                getState(element).object = object;

                //IE: This must occur after adding the object to the DOM.
                if(browserDetector.isIE()) {
                    object.data = "about:blank";
                }
            }

            if(batchProcessor) {
                batchProcessor.add(mutateDom);
            } else {
                mutateDom();
            }
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support objects properly. Luckily they do support the resize event.
            //So do not inject the object and notify that the element is already ready to be listened to.
            //The event handler for the resize event is attached in the utils.addListener instead.
            callback(element);
        } else {
            injectObject(element, callback);
        }
    }

    /**
     * Returns the child object of the target element.
     * @private
     * @param {element} element The target element.
     * @returns The object element of the target.
     */
    function getObject(element) {
        return getState(element).object;
    }

    function uninstall(element) {
        if(browserDetector.isIE(8)) {
            element.detachEvent("onresize", getState(element).object.proxy);
        } else {
            element.removeChild(getObject(element));
        }
        delete getState(element).object;
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),

/***/ "SRWI":
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__("ZXPY");
module.exports.default = module.exports;


/***/ }),

/***/ "Saiw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var detector = module.exports = {};

detector.isIE = function(version) {
    function isAnyIeVersion() {
        var agent = navigator.userAgent.toLowerCase();
        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
    }

    if(!isAnyIeVersion()) {
        return false;
    }

    if(!version) {
        return true;
    }

    //Shamelessly stolen from https://gist.github.com/padolsey/527683
    var ieVersion = (function(){
        var undef,
            v = 3,
            div = document.createElement("div"),
            all = div.getElementsByTagName("i");

        do {
            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
        }
        while (all[0]);

        return v > 4 ? v : undef;
    }());

    return version === ieVersion;
};

detector.isLegacyOpera = function() {
    return !!window.opera;
};


/***/ }),

/***/ "SdC7":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * getSize v2.0.2
 * measure size of elements
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */
/*global define: false, module: false, console: false */

( function( window, factory ) {
  'use strict';

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return factory();
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See http://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * WebKit measures the outer-width on style.width on border-box elems
   * IE & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );

  getSize.isBoxSizeOuter = isBoxSizeOuter = getStyleSize( style.width ) == 200;
  body.removeChild( div );

}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});


/***/ }),

/***/ "SfmA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomFieldsClient = undefined;

var _regenerator = __webpack_require__("ED1s");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__("iK2U");

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__("4x8l");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _asyncToGenerator2 = __webpack_require__("Dfz+");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _keys = __webpack_require__("q+0m");

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__("KIIz");

var _typeof3 = _interopRequireDefault(_typeof2);

var _WebAPI = __webpack_require__("qvG3");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findFieldValue = function findFieldValue(_ref, alias, defaultValue) {
  var fields = _ref.data.fields;

  if (!fields || (typeof fields === 'undefined' ? 'undefined' : (0, _typeof3.default)(fields)) !== 'object') {
    return defaultValue;
  }

  var foundFields = (0, _keys2.default)(fields).map(function (key) {
    return fields[key];
  }).filter(function (field) {
    if (field && field.aliases instanceof Array) {
      return -1 !== field.aliases.indexOf(alias);
    }
    return false;
  });

  if (1 === foundFields.length) {
    var field = foundFields.pop();
    return field.value;
  }

  return defaultValue;
};

/**
 * @class
 */

var CustomFieldsClient = exports.CustomFieldsClient = function () {
  /**
   * @param {EventDispatcher} outgoingDispatcher
   * @param {string} instanceId
   * @param {string} endpoint
   */
  function CustomFieldsClient(_ref2) {
    var outgoingDispatcher = _ref2.outgoingDispatcher,
        instanceId = _ref2.instanceId,
        endpoint = _ref2.endpoint;
    (0, _classCallCheck3.default)(this, CustomFieldsClient);

    this.props = { outgoingDispatcher: outgoingDispatcher, instanceId: instanceId, endpoint: endpoint };
  }

  /**
   * @method
   *
   * @param {string} id
   * @param {*} value
   *
   * @return {Promise.<*>}
   */


  (0, _createClass3.default)(CustomFieldsClient, [{
    key: 'setField',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(id, value) {
        var _props, outgoingDispatcher, url, body, init;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, outgoingDispatcher = _props.outgoingDispatcher, url = _props.endpoint;
                body = {
                  fields: (0, _defineProperty3.default)({}, id, value)
                };
                init = {
                  method: 'PUT',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },
                  body: (0, _stringify2.default)(body)
                };
                return _context.abrupt('return', outgoingDispatcher.emitAsync(_WebAPI.WebAPIEvents.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: init }));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setField(_x, _x2) {
        return _ref3.apply(this, arguments);
      }

      return setField;
    }()

    /**
     * @param {String} id
     * @param {*} defaultValue
     * @return {Promise.<*>}
     */

  }, {
    key: 'getField',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(id) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var _props2, outgoingDispatcher, url, init;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, outgoingDispatcher = _props2.outgoingDispatcher, url = _props2.endpoint;
                init = {
                  method: 'GET',
                  headers: { 'Accept': 'application/json' }
                };
                return _context2.abrupt('return', outgoingDispatcher.emitAsync(_WebAPI.WebAPIEvents.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: init }).then(function (_ref5) {
                  var status = _ref5.status,
                      body = _ref5.body;
                  return status === 'success' ? findFieldValue(body, id, defaultValue) : defaultValue;
                }));

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getField(_x3) {
        return _ref4.apply(this, arguments);
      }

      return getField;
    }()

    /**
     * @param {string} alias
     * @param {*} value
     * @return {Promise.<*>}
     */

  }, {
    key: 'setAppField',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(alias, value) {
        var fieldId;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fieldId = 'app:' + this.props.instanceId + ':' + alias;
                return _context3.abrupt('return', this.setField(fieldId, value));

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setAppField(_x5, _x6) {
        return _ref6.apply(this, arguments);
      }

      return setAppField;
    }()

    /**
     * @param {string} alias
     * @param {*} defaultValue
     *
     * @return {Promise.<*>}
     */

  }, {
    key: 'getAppField',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(alias) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var fieldId;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                fieldId = 'app:' + this.props.instanceId + ':' + alias;
                return _context4.abrupt('return', this.getField(fieldId, defaultValue));

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAppField(_x7) {
        return _ref7.apply(this, arguments);
      }

      return getAppField;
    }()
  }]);
  return CustomFieldsClient;
}();

/***/ }),

/***/ "U4Vh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("Nwwp"), __esModule: true };

/***/ }),

/***/ "UHHj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("eMMM"), __esModule: true };

/***/ }),

/***/ "UQxd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var registerEventHandlers = exports.registerEventHandlers = function registerEventHandlers() {};

/***/ }),

/***/ "UZB7":
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),

/***/ "Uc+M":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("OvYF")
  , defined = __webpack_require__("/MHE");
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),

/***/ "VCyk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchStorageAdapter = undefined;

var _regenerator = __webpack_require__("ED1s");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = __webpack_require__("q+0m");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("iK2U");

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__("xs8S");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _asyncToGenerator2 = __webpack_require__("Dfz+");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _WebAPI = __webpack_require__("qvG3");

var _StorageAdapter2 = __webpack_require__("2njn");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 */
var FetchStorageAdapter = exports.FetchStorageAdapter = function (_StorageAdapter) {
  (0, _inherits3.default)(FetchStorageAdapter, _StorageAdapter);

  function FetchStorageAdapter() {
    (0, _classCallCheck3.default)(this, FetchStorageAdapter);
    return (0, _possibleConstructorReturn3.default)(this, (FetchStorageAdapter.__proto__ || (0, _getPrototypeOf2.default)(FetchStorageAdapter)).apply(this, arguments));
  }

  (0, _createClass3.default)(FetchStorageAdapter, [{
    key: 'handleSetBatchStorage',

    /**
     * @method
     *
     * @param {Promise.<{outgoingDispatcher:EventDispatcher}>} dispatchPromise
     * @param {Array<Array>} nameValuePairsList
     * @param entityId
     * @return {Promise}
     */
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dispatchPromise, nameValuePairsList, entityId) {
        var _this2 = this;

        var buildRequestBody, parseSaveBatchStatus, collectSaveFailures;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                buildRequestBody = function buildRequestBody(instanceId, body, nameAndValue) {
                  var _nameAndValue = (0, _slicedToArray3.default)(nameAndValue, 2),
                      name = _nameAndValue[0],
                      value = _nameAndValue[1];

                  if (value === null || value === undefined) {
                    body[name] = {
                      method: "DELETE",
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      },
                      url: 'apps/' + instanceId + '/state/' + entityId + '/' + name
                    };
                  } else {
                    body[name] = {
                      method: "PUT",
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      },
                      url: 'apps/' + instanceId + '/state/' + entityId + '/' + name,
                      body: (0, _stringify2.default)({ value: value })
                    };
                  }

                  return body;
                };

                parseSaveBatchStatus = function parseSaveBatchStatus(batchResponse) {
                  /**
                   * @param result
                   * @param response
                   * @param name
                   * @return {*}
                   */
                  var reducer = function reducer(result, response, name) {
                    result[name] = response.headers['status-code'] === 200;
                    return result;
                  };
                  var responses = batchResponse.body.responses;

                  return (0, _keys2.default)(responses).reduce(function (result, name) {
                    return reducer(result, responses[name], name);
                  }, {});
                };

                /**
                 * @return {Array}
                 * @param saveBatchResults
                 */


                collectSaveFailures = function collectSaveFailures(saveBatchResults) {
                  var reducer = function reducer(failures, nameAndValue) {
                    var _nameAndValue2 = (0, _slicedToArray3.default)(nameAndValue, 1),
                        name = _nameAndValue2[0];

                    if (!saveBatchResults[name]) {
                      failures.push(nameAndValue);
                    }

                    return failures;
                  };
                  return nameValuePairsList.reduce(reducer, []);
                };

                return _context.abrupt('return', dispatchPromise.then(function (props) {
                  var url = 'batch';
                  var requests = nameValuePairsList.reduce(buildRequestBody.bind(_this2, props.instanceId));

                  var init = {
                    method: 'POST',
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    },
                    body: (0, _stringify2.default)({ requests: requests })
                  };
                  return props.outgoingDispatcher.emitAsync(_WebAPI.WebAPIEvents.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: init });
                }).then(parseSaveBatchStatus).then(collectSaveFailures));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSetBatchStorage(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return handleSetBatchStorage;
    }()
  }, {
    key: 'handleSetStorage',


    /**
     * @method
     *
     * @param {Promise.<{outgoingDispatcher:EventDispatcher}>} dispatchPromise
     * @param name
     * @param value
     * @param entityId
     * @return {Promise}
     */
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(dispatchPromise, name, value, entityId) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', dispatchPromise.then(function (props) {
                  var url = 'apps/' + props.instanceId + '/state/' + entityId + '/' + name;

                  var init = void 0;
                  if (value === null || value === undefined) {
                    init = {
                      method: 'DELETE',
                      'Accept': 'application/json'
                    };
                  } else {
                    init = {
                      method: 'PUT',
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      },
                      body: (0, _stringify2.default)({ value: value })
                    };
                  }

                  return props.outgoingDispatcher.emitAsync(_WebAPI.WebAPIEvents.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: init });
                }).then(function () {
                  return value;
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSetStorage(_x4, _x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return handleSetStorage;
    }()
  }, {
    key: 'handleGetStorage',


    /**
     * @method
     *
     * @param {Promise.<{outgoingDispatcher:EventDispatcher}>} dispatchPromise
     * @param name
     * @param entityId
     * @param defaultValue
     * @return {Promise.<*>}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(dispatchPromise, name, entityId) {
        var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', dispatchPromise.then(function (props) {
                  var url = 'apps/' + props.instanceId + '/state/' + entityId + '/' + name + '?options.mode=find';

                  var init = {
                    method: 'GET',
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    }
                  };
                  return props.outgoingDispatcher.emitAsync(_WebAPI.WebAPIEvents.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: init });
                }).then(function (response) {
                  return response.body && response.body.value ? response.body.value : defaultValue;
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleGetStorage(_x8, _x9, _x10) {
        return _ref3.apply(this, arguments);
      }

      return handleGetStorage;
    }()
  }, {
    key: 'handleGetBatchStorage',


    /**
     * @method
     *
     * @param {Promise.<{outgoingDispatcher:EventDispatcher}>} dispatchPromise
     * @param {Array<String>} nameList
     * @param {String} entityId
     * @param {*} defaultValue
     * @return {Promise.<{}>}
     */
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(dispatchPromise, nameList, entityId) {
        var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var buildRequestBody, parseBatchResponse;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                buildRequestBody = function buildRequestBody(instanceId, body, name) {
                  body[name] = 'apps/' + instanceId + '/state/' + entityId + '/' + name + '?options.mode=find';
                  return body;
                };

                parseBatchResponse = function parseBatchResponse(response, result, name) {
                  if (response.headers['status-code'] === 200) {
                    result[name] = response.value;
                  } else {
                    result[name] = defaultValue;
                  }
                  return result;
                };

                return _context4.abrupt('return', dispatchPromise.then(function (props) {
                  var url = 'batch';
                  var requests = nameList.reduce(function (body, name) {
                    return buildRequestBody(props.instanceId, body, name);
                  }, {});

                  var init = {
                    method: 'POST',
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    },
                    body: (0, _stringify2.default)({ requests: requests })
                  };
                  return props.outgoingDispatcher.emitAsync(_WebAPI.WebAPIEvents.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: init });
                }).then(function (response) {
                  var responses = response.body.responses;

                  return (0, _keys2.default)(responses).reduce(function (result, name) {
                    return parseBatchResponse(responses[name], result, name);
                  }, {});
                }));

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleGetBatchStorage(_x12, _x13, _x14) {
        return _ref4.apply(this, arguments);
      }

      return handleGetBatchStorage;
    }()
  }]);
  return FetchStorageAdapter;
}(_StorageAdapter2.StorageAdapter);

/***/ }),

/***/ "WGV/":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("GBSe")
  , gOPS    = __webpack_require__("mexi")
  , pIE     = __webpack_require__("YUE5");
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),

/***/ "Wd3d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("vSv8")
  , step             = __webpack_require__("UZB7")
  , Iterators        = __webpack_require__("50hw")
  , toIObject        = __webpack_require__("Uc+M");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("8WaV")(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),

/***/ "XAet":
/***/ (function(module, exports) {

module.exports = true;

/***/ }),

/***/ "XGUc":
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__("iUVn")('wks')
  , uid        = __webpack_require__("pfI3")
  , Symbol     = __webpack_require__("shmw").Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),

/***/ "XGVB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("rZLs"), __esModule: true };

/***/ }),

/***/ "Xjm4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOauthAPIClient = exports.registerEventHandlers = exports.OauthToken = exports.SecurityEvents = undefined;

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _OauthToken = __webpack_require__("K0ms");

Object.defineProperty(exports, 'OauthToken', {
  enumerable: true,
  get: function get() {
    return _OauthToken.OauthToken;
  }
});

var _EventHandlers = __webpack_require__("pASt");

Object.defineProperty(exports, 'registerEventHandlers', {
  enumerable: true,
  get: function get() {
    return _EventHandlers.registerEventHandlers;
  }
});

var _Events = __webpack_require__("BNfS");

var SecurityEvents = _interopRequireWildcard(_Events);

var _OauthFacade = __webpack_require__("Js+k");

var _Storage = __webpack_require__("yNLq");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Security module.
 * @module Security
 */

exports.SecurityEvents = SecurityEvents;


/**
 * @method
 *
 * @param {EventDispatcher} outgoingDispatcher
 * @param {EventDispatcher} internalDispatcher
 * @param {InstanceProps} instanceProps
 * @param {ContextProps} contextProps
 * @return {OauthFacade}
 */
var createOauthAPIClient = exports.createOauthAPIClient = function createOauthAPIClient(outgoingDispatcher, internalDispatcher, instanceProps, contextProps) {
  var storageClient = (0, _Storage.createStorageAPIClient)(outgoingDispatcher, internalDispatcher, instanceProps, contextProps);
  var setStorage = storageClient.setAppStorage.bind(storageClient);

  var props = (0, _extends3.default)({}, instanceProps.toJS(), contextProps.toJS());
  return new _OauthFacade.OauthFacade(outgoingDispatcher, setStorage, props);
};

/***/ }),

/***/ "Xpkd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__("MmDC")
  , descriptor     = __webpack_require__("/Aoj")
  , setToStringTag = __webpack_require__("CoAh")
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("siAl")(IteratorPrototype, __webpack_require__("XGUc")('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),

/***/ "Y4Oj":
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),

/***/ "YGBz":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("5Y6L");
__webpack_require__("IlDj");
__webpack_require__("skuU");
__webpack_require__("2L74");
module.exports = __webpack_require__("Y4Oj").Promise;

/***/ }),

/***/ "YUE5":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),

/***/ "ZVhn":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("9Ob+")
  , document = __webpack_require__("shmw").document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ "ZXPY":
/***/ (function(module, exports, __webpack_require__) {

!function(root, factory) {
     true ? module.exports = factory() : "function" == typeof define && define.amd ? define("postRobot", [], factory) : "object" == typeof exports ? exports.postRobot = factory() : root.postRobot = factory();
}(this, function() {
    return function(modules) {
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
            module.l = !0, module.exports;
        }
        var installedModules = {};
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
        __webpack_require__.i = function(value) {
            return value;
        }, __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                configurable: !1,
                enumerable: !0,
                get: getter
            });
        }, __webpack_require__.n = function(module) {
            var getter = module && module.__esModule ? function() {
                return module.default;
            } : function() {
                return module;
            };
            return __webpack_require__.d(getter, "a", getter), getter;
        }, __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 25);
    }([ function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _config = __webpack_require__(21);
        Object.keys(_config).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _config[key];
                }
            });
        });
        var _constants = __webpack_require__(10);
        Object.keys(_constants).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _constants[key];
                }
            });
        });
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function getActualDomain(win) {
            var location = win.location;
            if (!location) throw new Error("Can not read window location");
            var protocol = location.protocol;
            if (!protocol) throw new Error("Can not read window protocol");
            if (protocol === CONSTANTS.FILE_PROTOCOL) return "file://";
            var host = location.host;
            if (!host) throw new Error("Can not read window host");
            return protocol + "//" + host;
        }
        function getDomain(win) {
            win = win || window;
            var domain = getActualDomain(win);
            return domain && win.mockDomain && 0 === win.mockDomain.indexOf(CONSTANTS.MOCK_PROTOCOL) ? win.mockDomain : domain;
        }
        function isBlankDomain(win) {
            try {
                if (!win.location.href) return !0;
                if ("about:blank" === win.location.href) return !0;
            } catch (err) {}
            return !1;
        }
        function isActuallySameDomain(win) {
            try {
                var desc = Object.getOwnPropertyDescriptor(win, "location");
                if (desc && !1 === desc.enumerable) return !1;
            } catch (err) {}
            try {
                if (isBlankDomain(win)) return !0;
                if (getActualDomain(win) === getActualDomain(window)) return !0;
            } catch (err) {}
            return !1;
        }
        function isSameDomain(win) {
            if (!isActuallySameDomain(win)) return !1;
            try {
                if (isBlankDomain(win)) return !0;
                if (getDomain(window) === getDomain(win)) return !0;
            } catch (err) {}
            return !1;
        }
        function getParent(win) {
            if (win) try {
                if (win.parent && win.parent !== win) return win.parent;
            } catch (err) {
                return;
            }
        }
        function getOpener(win) {
            if (win && !getParent(win)) try {
                return win.opener;
            } catch (err) {
                return;
            }
        }
        function getParents(win) {
            var result = [];
            try {
                for (;win.parent !== win; ) result.push(win.parent), win = win.parent;
            } catch (err) {}
            return result;
        }
        function isAncestorParent(parent, child) {
            if (!parent || !child) return !1;
            var childParent = getParent(child);
            return childParent ? childParent === parent : -1 !== getParents(child).indexOf(parent);
        }
        function getFrames(win) {
            var result = [], frames = void 0;
            try {
                frames = win.frames;
            } catch (err) {
                frames = win;
            }
            var len = void 0;
            try {
                len = frames.length;
            } catch (err) {}
            if (0 === len) return result;
            if (len) {
                for (var i = 0; i < len; i++) {
                    var frame = void 0;
                    try {
                        frame = frames[i];
                    } catch (err) {
                        continue;
                    }
                    result.push(frame);
                }
                return result;
            }
            for (var _i = 0; _i < 100; _i++) {
                var _frame = void 0;
                try {
                    _frame = frames[_i];
                } catch (err) {
                    return result;
                }
                if (!_frame) return result;
                result.push(_frame);
            }
            return result;
        }
        function getAllChildFrames(win) {
            for (var result = [], _iterator = getFrames(win), _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                var _ref;
                if (_isArray) {
                    if (_i2 >= _iterator.length) break;
                    _ref = _iterator[_i2++];
                } else {
                    if (_i2 = _iterator.next(), _i2.done) break;
                    _ref = _i2.value;
                }
                var frame = _ref;
                result.push(frame);
                for (var _iterator2 = getAllChildFrames(frame), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                    var _ref2;
                    if (_isArray2) {
                        if (_i3 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i3++];
                    } else {
                        if (_i3 = _iterator2.next(), _i3.done) break;
                        _ref2 = _i3.value;
                    }
                    var childFrame = _ref2;
                    result.push(childFrame);
                }
            }
            return result;
        }
        function getTop(win) {
            if (win) {
                try {
                    if (win.top) return win.top;
                } catch (err) {}
                if (getParent(win) === win) return win;
                try {
                    if (isAncestorParent(window, win) && window.top) return window.top;
                } catch (err) {}
                try {
                    if (isAncestorParent(win, window) && window.top) return window.top;
                } catch (err) {}
                for (var _iterator3 = getAllChildFrames(win), _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator](); ;) {
                    var _ref3;
                    if (_isArray3) {
                        if (_i4 >= _iterator3.length) break;
                        _ref3 = _iterator3[_i4++];
                    } else {
                        if (_i4 = _iterator3.next(), _i4.done) break;
                        _ref3 = _i4.value;
                    }
                    var frame = _ref3;
                    try {
                        if (frame.top) return frame.top;
                    } catch (err) {}
                    if (getParent(frame) === frame) return frame;
                }
            }
        }
        function getAllFramesInWindow(win) {
            var top = getTop(win);
            return getAllChildFrames(top).concat(top);
        }
        function isTop(win) {
            return win === getTop(win);
        }
        function isFrameWindowClosed(frame) {
            if (!frame.contentWindow) return !0;
            if (!frame.parentNode) return !0;
            var doc = frame.ownerDocument;
            return !(!doc || !doc.body || doc.body.contains(frame));
        }
        function isWindowClosed(win) {
            var allowMock = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            try {
                if (win === window) return !1;
            } catch (err) {
                return !0;
            }
            try {
                if (!win) return !0;
            } catch (err) {
                return !0;
            }
            try {
                if (win.closed) return !0;
            } catch (err) {
                return !err || "Call was rejected by callee.\r\n" !== err.message;
            }
            if (allowMock && isSameDomain(win)) try {
                if (win.mockclosed) return !0;
            } catch (err) {}
            try {
                if (!win.parent || !win.top) return !0;
            } catch (err) {}
            try {
                var index = iframeWindows.indexOf(win);
                if (-1 !== index) {
                    var frame = iframeFrames[index];
                    if (frame && isFrameWindowClosed(frame)) return !0;
                }
            } catch (err) {}
            return !1;
        }
        function cleanIframes() {
            for (var i = 0; i < iframeFrames.length; i++) isFrameWindowClosed(iframeFrames[i]) && (iframeFrames.splice(i, 1), 
            iframeWindows.splice(i, 1));
            for (var _i5 = 0; _i5 < iframeWindows.length; _i5++) isWindowClosed(iframeWindows[_i5]) && (iframeFrames.splice(_i5, 1), 
            iframeWindows.splice(_i5, 1));
        }
        function linkFrameWindow(frame) {
            if (cleanIframes(), frame && frame.contentWindow) try {
                iframeWindows.push(frame.contentWindow), iframeFrames.push(frame);
            } catch (err) {}
        }
        function getUserAgent(win) {
            return win = win || window, win.navigator.mockUserAgent || win.navigator.userAgent;
        }
        function getFrameByName(win, name) {
            for (var winFrames = getFrames(win), _iterator4 = winFrames, _isArray4 = Array.isArray(_iterator4), _i6 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator](); ;) {
                var _ref4;
                if (_isArray4) {
                    if (_i6 >= _iterator4.length) break;
                    _ref4 = _iterator4[_i6++];
                } else {
                    if (_i6 = _iterator4.next(), _i6.done) break;
                    _ref4 = _i6.value;
                }
                var childFrame = _ref4;
                try {
                    if (isSameDomain(childFrame) && childFrame.name === name && -1 !== winFrames.indexOf(childFrame)) return childFrame;
                } catch (err) {}
            }
            try {
                if (-1 !== winFrames.indexOf(win.frames[name])) return win.frames[name];
            } catch (err) {}
            try {
                if (-1 !== winFrames.indexOf(win[name])) return win[name];
            } catch (err) {}
        }
        function findChildFrameByName(win, name) {
            var frame = getFrameByName(win, name);
            if (frame) return frame;
            for (var _iterator5 = getFrames(win), _isArray5 = Array.isArray(_iterator5), _i7 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator](); ;) {
                var _ref5;
                if (_isArray5) {
                    if (_i7 >= _iterator5.length) break;
                    _ref5 = _iterator5[_i7++];
                } else {
                    if (_i7 = _iterator5.next(), _i7.done) break;
                    _ref5 = _i7.value;
                }
                var childFrame = _ref5, namedFrame = findChildFrameByName(childFrame, name);
                if (namedFrame) return namedFrame;
            }
        }
        function findFrameByName(win, name) {
            return getFrameByName(win, name) || findChildFrameByName(getTop(win), name);
        }
        function isParent(win, frame) {
            var frameParent = getParent(frame);
            if (frameParent) return frameParent === win;
            for (var _iterator6 = getFrames(win), _isArray6 = Array.isArray(_iterator6), _i8 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator](); ;) {
                var _ref6;
                if (_isArray6) {
                    if (_i8 >= _iterator6.length) break;
                    _ref6 = _iterator6[_i8++];
                } else {
                    if (_i8 = _iterator6.next(), _i8.done) break;
                    _ref6 = _i8.value;
                }
                if (_ref6 === frame) return !0;
            }
            return !1;
        }
        function isOpener(parent, child) {
            return parent === getOpener(child);
        }
        function getAncestor(win) {
            win = win || window;
            var opener = getOpener(win);
            if (opener) return opener;
            var parent = getParent(win);
            return parent || void 0;
        }
        function getAncestors(win) {
            for (var results = [], ancestor = win; ancestor; ) (ancestor = getAncestor(ancestor)) && results.push(ancestor);
            return results;
        }
        function isAncestor(parent, child) {
            var actualParent = getAncestor(child);
            if (actualParent) return actualParent === parent;
            if (child === parent) return !1;
            if (getTop(child) === child) return !1;
            for (var _iterator7 = getFrames(parent), _isArray7 = Array.isArray(_iterator7), _i9 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator](); ;) {
                var _ref7;
                if (_isArray7) {
                    if (_i9 >= _iterator7.length) break;
                    _ref7 = _iterator7[_i9++];
                } else {
                    if (_i9 = _iterator7.next(), _i9.done) break;
                    _ref7 = _i9.value;
                }
                if (_ref7 === child) return !0;
            }
            return !1;
        }
        function isPopup() {
            return Boolean(getOpener(window));
        }
        function isIframe() {
            return Boolean(getParent(window));
        }
        function isFullpage() {
            return Boolean(!isIframe() && !isPopup());
        }
        function anyMatch(collection1, collection2) {
            for (var _iterator8 = collection1, _isArray8 = Array.isArray(_iterator8), _i10 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator](); ;) {
                var _ref8;
                if (_isArray8) {
                    if (_i10 >= _iterator8.length) break;
                    _ref8 = _iterator8[_i10++];
                } else {
                    if (_i10 = _iterator8.next(), _i10.done) break;
                    _ref8 = _i10.value;
                }
                for (var item1 = _ref8, _iterator9 = collection2, _isArray9 = Array.isArray(_iterator9), _i11 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator](); ;) {
                    var _ref9;
                    if (_isArray9) {
                        if (_i11 >= _iterator9.length) break;
                        _ref9 = _iterator9[_i11++];
                    } else {
                        if (_i11 = _iterator9.next(), _i11.done) break;
                        _ref9 = _i11.value;
                    }
                    if (item1 === _ref9) return !0;
                }
            }
        }
        function getDistanceFromTop() {
            for (var win = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window, distance = 0; win; ) (win = getParent(win)) && (distance += 1);
            return distance;
        }
        function getNthParent(win) {
            for (var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, i = 0; i < n; i++) win = getParent(win);
            return win;
        }
        function getNthParentFromTop(win) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
            return getNthParent(win, getDistanceFromTop(win) - n);
        }
        function isSameTopWindow(win1, win2) {
            var top1 = getTop(win1), top2 = getTop(win2);
            try {
                if (top1 && top2) return top1 === top2;
            } catch (err) {}
            var allFrames1 = getAllFramesInWindow(win1), allFrames2 = getAllFramesInWindow(win2);
            if (anyMatch(allFrames1, allFrames2)) return !0;
            var opener1 = getOpener(top1), opener2 = getOpener(top2);
            return (!opener1 || !anyMatch(getAllFramesInWindow(opener1), allFrames2)) && ((!opener2 || !anyMatch(getAllFramesInWindow(opener2), allFrames1)) && void 0);
        }
        function matchDomain(pattern, origin) {
            if ("string" == typeof pattern) {
                if ("string" == typeof origin) return pattern === CONSTANTS.WILDCARD || origin === pattern;
                if ((0, _util.isRegex)(origin)) return !1;
                if (Array.isArray(origin)) return !1;
            }
            return (0, _util.isRegex)(pattern) ? (0, _util.isRegex)(origin) ? pattern.toString() === origin.toString() : !Array.isArray(origin) && Boolean(origin.match(pattern)) : !!Array.isArray(pattern) && (Array.isArray(origin) ? JSON.stringify(pattern) === JSON.stringify(origin) : !(0, 
            _util.isRegex)(origin) && pattern.some(function(subpattern) {
                return matchDomain(subpattern, origin);
            }));
        }
        function getDomainFromUrl(url) {
            var domain = void 0;
            return url.match(/^(https?|mock|file):\/\//) ? (domain = url, domain = domain.split("/").slice(0, 3).join("/")) : getDomain();
        }
        function onCloseWindow(win, callback) {
            var delay = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1e3, maxtime = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1 / 0, timeout = void 0;
            return function check() {
                if (isWindowClosed(win)) return timeout && clearTimeout(timeout), callback();
                maxtime <= 0 ? clearTimeout(timeout) : (maxtime -= delay, timeout = setTimeout(check, delay));
            }(), {
                cancel: function() {
                    timeout && clearTimeout(timeout);
                }
            };
        }
        function isWindow(obj) {
            try {
                if (obj && obj.self === obj) return !0;
            } catch (err) {}
            return !1;
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.getActualDomain = getActualDomain, exports.getDomain = getDomain, exports.isBlankDomain = isBlankDomain, 
        exports.isActuallySameDomain = isActuallySameDomain, exports.isSameDomain = isSameDomain, 
        exports.getParent = getParent, exports.getOpener = getOpener, exports.getParents = getParents, 
        exports.isAncestorParent = isAncestorParent, exports.getFrames = getFrames, exports.getAllChildFrames = getAllChildFrames, 
        exports.getTop = getTop, exports.getAllFramesInWindow = getAllFramesInWindow, exports.isTop = isTop, 
        exports.isFrameWindowClosed = isFrameWindowClosed, exports.isWindowClosed = isWindowClosed, 
        exports.linkFrameWindow = linkFrameWindow, exports.getUserAgent = getUserAgent, 
        exports.getFrameByName = getFrameByName, exports.findChildFrameByName = findChildFrameByName, 
        exports.findFrameByName = findFrameByName, exports.isParent = isParent, exports.isOpener = isOpener, 
        exports.getAncestor = getAncestor, exports.getAncestors = getAncestors, exports.isAncestor = isAncestor, 
        exports.isPopup = isPopup, exports.isIframe = isIframe, exports.isFullpage = isFullpage, 
        exports.getDistanceFromTop = getDistanceFromTop, exports.getNthParent = getNthParent, 
        exports.getNthParentFromTop = getNthParentFromTop, exports.isSameTopWindow = isSameTopWindow, 
        exports.matchDomain = matchDomain, exports.getDomainFromUrl = getDomainFromUrl, 
        exports.onCloseWindow = onCloseWindow, exports.isWindow = isWindow;
        var _util = __webpack_require__(16), CONSTANTS = {
            MOCK_PROTOCOL: "mock:",
            FILE_PROTOCOL: "file:",
            WILDCARD: "*"
        }, iframeWindows = [], iframeFrames = [];
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _promise = __webpack_require__(18);
        Object.defineProperty(exports, "ZalgoPromise", {
            enumerable: !0,
            get: function() {
                return _promise.ZalgoPromise;
            }
        });
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.global = void 0;
        var _conf = __webpack_require__(0);
        (exports.global = window[_conf.CONSTANTS.WINDOW_PROPS.POSTROBOT] = window[_conf.CONSTANTS.WINDOW_PROPS.POSTROBOT] || {}).registerSelf = function() {};
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _util = __webpack_require__(7);
        Object.keys(_util).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _util[key];
                }
            });
        });
        var _log = __webpack_require__(9);
        Object.keys(_log).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _log[key];
                }
            });
        });
        var _serialize = __webpack_require__(27);
        Object.keys(_serialize).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _serialize[key];
                }
            });
        });
        var _ready = __webpack_require__(26);
        Object.keys(_ready).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _ready[key];
                }
            });
        });
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _interface = __webpack_require__(13);
        Object.keys(_interface).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _interface[key];
                }
            });
        });
        var INTERFACE = function(obj) {
            if (obj && obj.__esModule) return obj;
            var newObj = {};
            if (null != obj) for (var key in obj) Object.prototype.hasOwnProperty.call(obj, key) && (newObj[key] = obj[key]);
            return newObj.default = obj, newObj;
        }(_interface);
        exports.default = INTERFACE;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _receive = __webpack_require__(22);
        Object.keys(_receive).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _receive[key];
                }
            });
        });
        var _send = __webpack_require__(12);
        Object.keys(_send).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _send[key];
                }
            });
        });
        var _listeners = __webpack_require__(11);
        Object.keys(_listeners).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _listeners[key];
                }
            });
        });
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function stringifyError(err) {
            if (!err) return "<unknown error: " + Object.prototype.toString.call(err) + ">";
            if ("string" == typeof err) return err;
            if (err instanceof Error) {
                var stack = err && err.stack, message = err && err.message;
                if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + "\n" + stack;
                if (stack) return stack;
                if (message) return message;
            }
            return "function" == typeof err.toString ? err.toString() : Object.prototype.toString.call(err);
        }
        function noop() {}
        function addEventListener(obj, event, handler) {
            return obj.addEventListener ? obj.addEventListener(event, handler) : obj.attachEvent("on" + event, handler), 
            {
                cancel: function() {
                    obj.removeEventListener ? obj.removeEventListener(event, handler) : obj.detachEvent("on" + event, handler);
                }
            };
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "xxxxxxxxxx".replace(/./g, function() {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            });
        }
        function eachArray(item, callback) {
            for (var i = 0; i < item.length; i++) callback(item[i], i);
        }
        function eachObject(item, callback) {
            for (var _key in item) item.hasOwnProperty(_key) && callback(item[_key], _key);
        }
        function each(item, callback) {
            Array.isArray(item) ? eachArray(item, callback) : "object" === (void 0 === item ? "undefined" : _typeof(item)) && null !== item && eachObject(item, callback);
        }
        function replaceObject(item, callback) {
            var depth = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
            if (depth >= 100) throw new Error("Self-referential object passed, or object contained too many layers");
            var newobj = void 0;
            if ("object" !== (void 0 === item ? "undefined" : _typeof(item)) || null === item || Array.isArray(item)) {
                if (!Array.isArray(item)) throw new Error("Invalid type: " + (void 0 === item ? "undefined" : _typeof(item)));
                newobj = [];
            } else newobj = {};
            return each(item, function(childItem, key) {
                var result = callback(childItem, key);
                void 0 !== result ? newobj[key] = result : "object" === (void 0 === childItem ? "undefined" : _typeof(childItem)) && null !== childItem ? newobj[key] = replaceObject(childItem, callback, depth + 1) : newobj[key] = childItem;
            }), newobj;
        }
        function safeInterval(method, time) {
            function runInterval() {
                timeout = setTimeout(runInterval, time), method.call();
            }
            var timeout = void 0;
            return timeout = setTimeout(runInterval, time), {
                cancel: function() {
                    clearTimeout(timeout);
                }
            };
        }
        function isRegex(item) {
            return "[object RegExp]" === Object.prototype.toString.call(item);
        }
        function getWindowType() {
            return (0, _src2.isPopup)() ? _conf.CONSTANTS.WINDOW_TYPES.POPUP : (0, _src2.isIframe)() ? _conf.CONSTANTS.WINDOW_TYPES.IFRAME : _conf.CONSTANTS.WINDOW_TYPES.FULLPAGE;
        }
        function jsonStringify(obj, replacer, indent) {
            var objectToJSON = void 0, arrayToJSON = void 0;
            try {
                if ("{}" !== JSON.stringify({}) && (objectToJSON = Object.prototype.toJSON, delete Object.prototype.toJSON), 
                "{}" !== JSON.stringify({})) throw new Error("Can not correctly serialize JSON objects");
                if ("[]" !== JSON.stringify([]) && (arrayToJSON = Array.prototype.toJSON, delete Array.prototype.toJSON), 
                "[]" !== JSON.stringify([])) throw new Error("Can not correctly serialize JSON objects");
            } catch (err) {
                throw new Error("Can not repair JSON.stringify: " + err.message);
            }
            var result = JSON.stringify.call(this, obj, replacer, indent);
            try {
                objectToJSON && (Object.prototype.toJSON = objectToJSON), arrayToJSON && (Array.prototype.toJSON = arrayToJSON);
            } catch (err) {
                throw new Error("Can not repair JSON.stringify: " + err.message);
            }
            return result;
        }
        function jsonParse(item) {
            return JSON.parse(item);
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.weakMapMemoize = exports.once = void 0;
        var _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        exports.stringifyError = stringifyError, exports.noop = noop, exports.addEventListener = addEventListener, 
        exports.uniqueID = uniqueID, exports.eachArray = eachArray, exports.eachObject = eachObject, 
        exports.each = each, exports.replaceObject = replaceObject, exports.safeInterval = safeInterval, 
        exports.isRegex = isRegex, exports.getWindowType = getWindowType, exports.jsonStringify = jsonStringify, 
        exports.jsonParse = jsonParse;
        var _src = __webpack_require__(5), _src2 = __webpack_require__(1), _conf = __webpack_require__(0);
        exports.once = function(method) {
            if (!method) return method;
            var called = !1;
            return function() {
                if (!called) return called = !0, method.apply(this, arguments);
            };
        }, exports.weakMapMemoize = function(method) {
            var weakmap = new _src.WeakMap();
            return function(arg) {
                var result = weakmap.get(arg);
                return void 0 !== result ? result : (result = method.call(this, arg), void 0 !== result && weakmap.set(arg, result), 
                result);
            };
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function init() {
            _global.global.initialized || ((0, _drivers.listenForMessages)(), (0, _lib.initOnReady)(), 
            (0, _lib.listenForMethods)()), _global.global.initialized = !0;
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.Promise = exports.cleanUpWindow = void 0;
        var _clean = __webpack_require__(20);
        Object.defineProperty(exports, "cleanUpWindow", {
            enumerable: !0,
            get: function() {
                return _clean.cleanUpWindow;
            }
        }), exports.init = init;
        var _public = __webpack_require__(30);
        Object.keys(_public).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _public[key];
                }
            });
        });
        var _src = __webpack_require__(2);
        Object.defineProperty(exports, "Promise", {
            enumerable: !0,
            get: function() {
                return _src.ZalgoPromise;
            }
        });
        var _lib = __webpack_require__(4), _drivers = __webpack_require__(6), _global = __webpack_require__(3);
        init();
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.log = void 0;
        var _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _util = __webpack_require__(7), _conf = __webpack_require__(0), LOG_LEVELS = [ "debug", "info", "warn", "error" ];
        Function.prototype.bind && window.console && "object" === _typeof(console.log) && [ "log", "info", "warn", "error" ].forEach(function(method) {
            console[method] = this.bind(console[method], console);
        }, Function.prototype.call);
        var log = exports.log = {
            clearLogs: function() {
                if (window.console && window.console.clear && window.console.clear(), _conf.CONFIG.LOG_TO_PAGE) {
                    var container = document.getElementById("postRobotLogs");
                    container && container.parentNode && container.parentNode.removeChild(container);
                }
            },
            writeToPage: function(level, args) {
                setTimeout(function() {
                    var container = document.getElementById("postRobotLogs");
                    container || (container = document.createElement("div"), container.id = "postRobotLogs", 
                    container.style.cssText = "width: 800px; font-family: monospace; white-space: pre-wrap;", 
                    document.body && document.body.appendChild(container));
                    var el = document.createElement("div"), date = new Date().toString().split(" ")[4], payload = Array.prototype.slice.call(args).map(function(item) {
                        if ("string" == typeof item) return item;
                        if (!item) return Object.prototype.toString.call(item);
                        var json = void 0;
                        try {
                            json = (0, _util.jsonStringify)(item, null, 2);
                        } catch (e) {
                            json = "[object]";
                        }
                        return "\n\n" + json + "\n\n";
                    }).join(" "), msg = date + " " + level + " " + payload;
                    el.innerHTML = msg;
                    var color = {
                        log: "#ddd",
                        warn: "orange",
                        error: "red",
                        info: "blue",
                        debug: "#aaa"
                    }[level];
                    el.style.cssText = "margin-top: 10px; color: " + color + ";", container.childNodes.length ? container.insertBefore(el, container.childNodes[0]) : container.appendChild(el);
                });
            },
            logLevel: function(level, args) {
                setTimeout(function() {
                    try {
                        var logLevel = window.LOG_LEVEL || _conf.CONFIG.LOG_LEVEL;
                        if (LOG_LEVELS.indexOf(level) < LOG_LEVELS.indexOf(logLevel)) return;
                        if (args = Array.prototype.slice.call(args), args.unshift("" + window.location.host + window.location.pathname), 
                        args.unshift("::"), args.unshift("" + (0, _util.getWindowType)().toLowerCase()), 
                        args.unshift("[post-robot]"), _conf.CONFIG.LOG_TO_PAGE && log.writeToPage(level, args), 
                        !window.console) return;
                        if (window.console[level] || (level = "log"), !window.console[level]) return;
                        window.console[level].apply(window.console, args);
                    } catch (err) {}
                }, 1);
            },
            debug: function() {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                log.logLevel("debug", args);
            },
            info: function() {
                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
                log.logLevel("info", args);
            },
            warn: function() {
                for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) args[_key3] = arguments[_key3];
                log.logLevel("warn", args);
            },
            error: function() {
                for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) args[_key4] = arguments[_key4];
                log.logLevel("error", args);
            }
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var CONSTANTS = exports.CONSTANTS = {
            POST_MESSAGE_TYPE: {
                REQUEST: "postrobot_message_request",
                RESPONSE: "postrobot_message_response",
                ACK: "postrobot_message_ack"
            },
            POST_MESSAGE_ACK: {
                SUCCESS: "success",
                ERROR: "error"
            },
            POST_MESSAGE_NAMES: {
                METHOD: "postrobot_method",
                READY: "postrobot_ready",
                OPEN_TUNNEL: "postrobot_open_tunnel"
            },
            WINDOW_TYPES: {
                FULLPAGE: "fullpage",
                POPUP: "popup",
                IFRAME: "iframe"
            },
            WINDOW_PROPS: {
                POSTROBOT: "__postRobot__"
            },
            SERIALIZATION_TYPES: {
                METHOD: "postrobot_method",
                ERROR: "postrobot_error",
                PROMISE: "postrobot_promise",
                ZALGO_PROMISE: "postrobot_zalgo_promise",
                REGEX: "regex"
            },
            SEND_STRATEGIES: {
                POST_MESSAGE: "postrobot_post_message",
                BRIDGE: "postrobot_bridge",
                GLOBAL: "postrobot_global"
            },
            MOCK_PROTOCOL: "mock:",
            FILE_PROTOCOL: "file:",
            BRIDGE_NAME_PREFIX: "__postrobot_bridge__",
            POSTROBOT_PROXY: "__postrobot_proxy__",
            WILDCARD: "*"
        };
        exports.POST_MESSAGE_NAMES_LIST = Object.keys(CONSTANTS.POST_MESSAGE_NAMES).map(function(key) {
            return CONSTANTS.POST_MESSAGE_NAMES[key];
        });
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function resetListeners() {
            _global.global.responseListeners = {}, _global.global.requestListeners = {};
        }
        function addResponseListener(hash, listener) {
            _global.global.responseListeners[hash] = listener;
        }
        function getResponseListener(hash) {
            return _global.global.responseListeners[hash];
        }
        function deleteResponseListener(hash) {
            delete _global.global.responseListeners[hash];
        }
        function getRequestListener(_ref) {
            var name = _ref.name, win = _ref.win, domain = _ref.domain;
            if (win === _conf.CONSTANTS.WILDCARD && (win = null), domain === _conf.CONSTANTS.WILDCARD && (domain = null), 
            !name) throw new Error("Name required to get request listener");
            var nameListeners = _global.global.requestListeners[name];
            if (nameListeners) for (var _arr = [ win, _global.global.WINDOW_WILDCARD ], _i = 0; _i < _arr.length; _i++) {
                var winQualifier = _arr[_i], winListeners = winQualifier && nameListeners.get(winQualifier);
                if (winListeners) {
                    for (var _arr2 = [ domain, _conf.CONSTANTS.WILDCARD ], _i2 = 0; _i2 < _arr2.length; _i2++) {
                        var domainQualifier = _arr2[_i2];
                        if (domainQualifier && (domainQualifier = domainQualifier.toString(), winListeners[domainQualifier])) return winListeners[domainQualifier];
                    }
                    if (winListeners[__DOMAIN_REGEX__]) for (var _iterator = winListeners[__DOMAIN_REGEX__], _isArray = Array.isArray(_iterator), _i3 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                        var _ref3;
                        if (_isArray) {
                            if (_i3 >= _iterator.length) break;
                            _ref3 = _iterator[_i3++];
                        } else {
                            if (_i3 = _iterator.next(), _i3.done) break;
                            _ref3 = _i3.value;
                        }
                        var _ref4 = _ref3, regex = _ref4.regex, listener = _ref4.listener;
                        if ((0, _src2.matchDomain)(regex, domain)) return listener;
                    }
                }
            }
        }
        function addRequestListener(_ref5, listener) {
            var name = _ref5.name, win = _ref5.win, domain = _ref5.domain;
            if (!name || "string" != typeof name) throw new Error("Name required to add request listener");
            if (Array.isArray(win)) {
                for (var listenersCollection = [], _iterator2 = win, _isArray2 = Array.isArray(_iterator2), _i4 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                    var _ref6;
                    if (_isArray2) {
                        if (_i4 >= _iterator2.length) break;
                        _ref6 = _iterator2[_i4++];
                    } else {
                        if (_i4 = _iterator2.next(), _i4.done) break;
                        _ref6 = _i4.value;
                    }
                    var item = _ref6;
                    listenersCollection.push(addRequestListener({
                        name: name,
                        domain: domain,
                        win: item
                    }, listener));
                }
                return {
                    cancel: function() {
                        for (var _iterator3 = listenersCollection, _isArray3 = Array.isArray(_iterator3), _i5 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator](); ;) {
                            var _ref7;
                            if (_isArray3) {
                                if (_i5 >= _iterator3.length) break;
                                _ref7 = _iterator3[_i5++];
                            } else {
                                if (_i5 = _iterator3.next(), _i5.done) break;
                                _ref7 = _i5.value;
                            }
                            _ref7.cancel();
                        }
                    }
                };
            }
            if (Array.isArray(domain)) {
                for (var _listenersCollection = [], _iterator4 = domain, _isArray4 = Array.isArray(_iterator4), _i6 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator](); ;) {
                    var _ref8;
                    if (_isArray4) {
                        if (_i6 >= _iterator4.length) break;
                        _ref8 = _iterator4[_i6++];
                    } else {
                        if (_i6 = _iterator4.next(), _i6.done) break;
                        _ref8 = _i6.value;
                    }
                    var _item = _ref8;
                    _listenersCollection.push(addRequestListener({
                        name: name,
                        win: win,
                        domain: _item
                    }, listener));
                }
                return {
                    cancel: function() {
                        for (var _iterator5 = _listenersCollection, _isArray5 = Array.isArray(_iterator5), _i7 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator](); ;) {
                            var _ref9;
                            if (_isArray5) {
                                if (_i7 >= _iterator5.length) break;
                                _ref9 = _iterator5[_i7++];
                            } else {
                                if (_i7 = _iterator5.next(), _i7.done) break;
                                _ref9 = _i7.value;
                            }
                            _ref9.cancel();
                        }
                    }
                };
            }
            var existingListener = getRequestListener({
                name: name,
                win: win,
                domain: domain
            });
            if (win && win !== _conf.CONSTANTS.WILDCARD || (win = _global.global.WINDOW_WILDCARD), 
            domain = domain || _conf.CONSTANTS.WILDCARD, existingListener) throw win && domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString() + " for specified window") : win ? new Error("Request listener already exists for " + name + " for specified window") : domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString()) : new Error("Request listener already exists for " + name);
            var requestListeners = _global.global.requestListeners, nameListeners = requestListeners[name];
            nameListeners || (nameListeners = new _src.WeakMap(), requestListeners[name] = nameListeners);
            var winListeners = nameListeners.get(win);
            winListeners || (winListeners = {}, nameListeners.set(win, winListeners));
            var strDomain = domain.toString();
            winListeners[strDomain] = listener;
            var regexListeners = winListeners[__DOMAIN_REGEX__], regexListener = void 0;
            return (0, _lib.isRegex)(domain) && (regexListeners || (regexListeners = [], winListeners[__DOMAIN_REGEX__] = regexListeners), 
            regexListener = {
                regex: domain,
                listener: listener
            }, regexListeners.push(regexListener)), {
                cancel: function() {
                    winListeners && (delete winListeners[strDomain], win && 0 === Object.keys(winListeners).length && nameListeners.delete(win), 
                    regexListener && regexListeners.splice(regexListeners.indexOf(regexListener, 1)));
                }
            };
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.resetListeners = resetListeners, exports.addResponseListener = addResponseListener, 
        exports.getResponseListener = getResponseListener, exports.deleteResponseListener = deleteResponseListener, 
        exports.getRequestListener = getRequestListener, exports.addRequestListener = addRequestListener, 
        __webpack_require__(2);
        var _src = __webpack_require__(5), _src2 = __webpack_require__(1), _global = __webpack_require__(3), _lib = __webpack_require__(4), _conf = __webpack_require__(0);
        _global.global.responseListeners = _global.global.responseListeners || {}, _global.global.requestListeners = _global.global.requestListeners || {}, 
        _global.global.WINDOW_WILDCARD = _global.global.WINDOW_WILDCARD || new function() {}();
        var __DOMAIN_REGEX__ = "__domain_regex__";
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function _defineProperty(obj, key, value) {
            return key in obj ? Object.defineProperty(obj, key, {
                value: value,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : obj[key] = value, obj;
        }
        function buildMessage(win, message) {
            var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, id = (0, 
            _lib.uniqueID)(), type = (0, _lib.getWindowType)(), sourceDomain = (0, _src.getDomain)(window);
            return _extends({}, message, options, {
                sourceDomain: sourceDomain,
                id: message.id || id,
                windowType: type
            });
        }
        function sendMessage(win, message, domain) {
            return _src2.ZalgoPromise.try(function() {
                message = buildMessage(win, message, {
                    data: (0, _lib.serializeMethods)(win, domain, message.data),
                    domain: domain
                });
                var level = void 0;
                if (level = -1 !== _conf.POST_MESSAGE_NAMES_LIST.indexOf(message.name) || message.type === _conf.CONSTANTS.POST_MESSAGE_TYPE.ACK ? "debug" : "error" === message.ack ? "error" : "info", 
                _lib.log.logLevel(level, [ "\n\n\t", "#send", message.type.replace(/^postrobot_message_/, ""), "::", message.name, "::", domain || _conf.CONSTANTS.WILDCARD, "\n\n", message ]), 
                win === window) throw new Error("Attemping to send message to self");
                if ((0, _src.isWindowClosed)(win)) throw new Error("Window is closed");
                _lib.log.debug("Running send message strategies", message);
                var messages = [], serializedMessage = (0, _lib.jsonStringify)(_defineProperty({}, _conf.CONSTANTS.WINDOW_PROPS.POSTROBOT, message), null, 2);
                return _src2.ZalgoPromise.map(Object.keys(_strategies.SEND_MESSAGE_STRATEGIES), function(strategyName) {
                    return _src2.ZalgoPromise.try(function() {
                        if (!_conf.CONFIG.ALLOWED_POST_MESSAGE_METHODS[strategyName]) throw new Error("Strategy disallowed: " + strategyName);
                        return _strategies.SEND_MESSAGE_STRATEGIES[strategyName](win, serializedMessage, domain);
                    }).then(function() {
                        return messages.push(strategyName + ": success"), !0;
                    }, function(err) {
                        return messages.push(strategyName + ": " + (0, _lib.stringifyError)(err) + "\n"), 
                        !1;
                    });
                }).then(function(results) {
                    var success = results.some(Boolean), status = message.type + " " + message.name + " " + (success ? "success" : "error") + ":\n  - " + messages.join("\n  - ") + "\n";
                    if (_lib.log.debug(status), !success) throw new Error(status);
                });
            });
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _extends = Object.assign || function(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];
                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
            }
            return target;
        };
        exports.sendMessage = sendMessage;
        var _src = __webpack_require__(1), _src2 = __webpack_require__(2), _conf = __webpack_require__(0), _lib = __webpack_require__(4), _strategies = __webpack_require__(24);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _weakmap = __webpack_require__(15);
        Object.defineProperty(exports, "WeakMap", {
            enumerable: !0,
            get: function() {
                return _weakmap.CrossDomainSafeWeakMap;
            }
        });
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function hasNativeWeakMap() {
            if (!window.WeakMap) return !1;
            if (!window.Object.freeze) return !1;
            try {
                var testWeakMap = new window.WeakMap(), testKey = {};
                return window.Object.freeze(testKey), testWeakMap.set(testKey, "__testvalue__"), 
                "__testvalue__" === testWeakMap.get(testKey);
            } catch (err) {
                return !1;
            }
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.hasNativeWeakMap = hasNativeWeakMap;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.CrossDomainSafeWeakMap = void 0;
        var _createClass = function() {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                    "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
                Constructor;
            };
        }(), _src = __webpack_require__(1), _native = __webpack_require__(14), defineProperty = Object.defineProperty, counter = Date.now() % 1e9;
        exports.CrossDomainSafeWeakMap = function() {
            function CrossDomainSafeWeakMap() {
                if (_classCallCheck(this, CrossDomainSafeWeakMap), counter += 1, this.name = "__weakmap_" + (1e9 * Math.random() >>> 0) + "__" + counter, 
                (0, _native.hasNativeWeakMap)()) try {
                    this.weakmap = new window.WeakMap();
                } catch (err) {}
                this.keys = [], this.values = [];
            }
            return _createClass(CrossDomainSafeWeakMap, [ {
                key: "_cleanupClosedWindows",
                value: function() {
                    for (var weakmap = this.weakmap, keys = this.keys, i = 0; i < keys.length; i++) {
                        var value = keys[i];
                        if ((0, _src.isWindowClosed)(value)) {
                            if (weakmap) try {
                                weakmap.delete(value);
                            } catch (err) {}
                            keys.splice(i, 1), this.values.splice(i, 1), i -= 1;
                        }
                    }
                }
            }, {
                key: "isSafeToReadWrite",
                value: function(key) {
                    if ((0, _src.isWindow)(key)) return !1;
                    try {
                        key && key.self, key && key[this.name];
                    } catch (err) {
                        return !1;
                    }
                    return !0;
                }
            }, {
                key: "set",
                value: function(key, value) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.set(key, value);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) {
                        var name = this.name, entry = key[name];
                        entry && entry[0] === key ? entry[1] = value : defineProperty(key, name, {
                            value: [ key, value ],
                            writable: !0
                        });
                    } else {
                        this._cleanupClosedWindows();
                        var keys = this.keys, values = this.values, index = keys.indexOf(key);
                        -1 === index ? (keys.push(key), values.push(value)) : values[index] = value;
                    }
                }
            }, {
                key: "get",
                value: function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        if (weakmap.has(key)) return weakmap.get(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (!this.isSafeToReadWrite(key)) {
                        this._cleanupClosedWindows();
                        var keys = this.keys, index = keys.indexOf(key);
                        if (-1 === index) return;
                        return this.values[index];
                    }
                    var entry = key[this.name];
                    if (entry && entry[0] === key) return entry[1];
                }
            }, {
                key: "delete",
                value: function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.delete(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) {
                        var entry = key[this.name];
                        entry && entry[0] === key && (entry[0] = entry[1] = void 0);
                    } else {
                        this._cleanupClosedWindows();
                        var keys = this.keys, index = keys.indexOf(key);
                        -1 !== index && (keys.splice(index, 1), this.values.splice(index, 1));
                    }
                }
            }, {
                key: "has",
                value: function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        return weakmap.has(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) {
                        var entry = key[this.name];
                        return !(!entry || entry[0] !== key);
                    }
                    return this._cleanupClosedWindows(), -1 !== this.keys.indexOf(key);
                }
            } ]), CrossDomainSafeWeakMap;
        }();
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function isRegex(item) {
            return "[object RegExp]" === Object.prototype.toString.call(item);
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.isRegex = isRegex;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function dispatchPossiblyUnhandledError(err) {
            if (-1 === dispatchedErrors.indexOf(err)) {
                dispatchedErrors.push(err), setTimeout(function() {
                    throw err;
                }, 1);
                for (var j = 0; j < possiblyUnhandledPromiseHandlers.length; j++) possiblyUnhandledPromiseHandlers[j](err);
            }
        }
        function onPossiblyUnhandledException(handler) {
            return possiblyUnhandledPromiseHandlers.push(handler), {
                cancel: function() {
                    possiblyUnhandledPromiseHandlers.splice(possiblyUnhandledPromiseHandlers.indexOf(handler), 1);
                }
            };
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.dispatchPossiblyUnhandledError = dispatchPossiblyUnhandledError, exports.onPossiblyUnhandledException = onPossiblyUnhandledException;
        var possiblyUnhandledPromiseHandlers = [], dispatchedErrors = [];
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.ZalgoPromise = void 0;
        var _createClass = function() {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                    "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
                Constructor;
            };
        }(), _utils = __webpack_require__(19), _exceptions = __webpack_require__(17), ZalgoPromise = function() {
            function ZalgoPromise(handler) {
                var _this = this;
                if (_classCallCheck(this, ZalgoPromise), this.resolved = !1, this.rejected = !1, 
                this.errorHandled = !1, this.handlers = [], handler) {
                    var _result = void 0, _error = void 0, resolved = !1, rejected = !1, isAsync = !1;
                    try {
                        handler(function(res) {
                            isAsync ? _this.resolve(res) : (resolved = !0, _result = res);
                        }, function(err) {
                            isAsync ? _this.reject(err) : (rejected = !0, _error = err);
                        });
                    } catch (err) {
                        return void this.reject(err);
                    }
                    isAsync = !0, resolved ? this.resolve(_result) : rejected && this.reject(_error);
                }
            }
            return _createClass(ZalgoPromise, [ {
                key: "resolve",
                value: function(result) {
                    if (this.resolved || this.rejected) return this;
                    if ((0, _utils.isPromise)(result)) throw new Error("Can not resolve promise with another promise");
                    return this.resolved = !0, this.value = result, this.dispatch(), this;
                }
            }, {
                key: "reject",
                value: function(error) {
                    var _this2 = this;
                    if (this.resolved || this.rejected) return this;
                    if ((0, _utils.isPromise)(error)) throw new Error("Can not reject promise with another promise");
                    if (!error) {
                        var _err = error && "function" == typeof error.toString ? error.toString() : Object.prototype.toString.call(error);
                        error = new Error("Expected reject to be called with Error, got " + _err);
                    }
                    return this.rejected = !0, this.error = error, this.errorHandled || setTimeout(function() {
                        _this2.errorHandled || (0, _exceptions.dispatchPossiblyUnhandledError)(error);
                    }, 1), this.dispatch(), this;
                }
            }, {
                key: "asyncReject",
                value: function(error) {
                    this.errorHandled = !0, this.reject(error);
                }
            }, {
                key: "dispatch",
                value: function() {
                    var _this3 = this, dispatching = this.dispatching, resolved = this.resolved, rejected = this.rejected, handlers = this.handlers;
                    if (!dispatching && (resolved || rejected)) {
                        this.dispatching = !0;
                        for (var i = 0; i < handlers.length; i++) {
                            (function(i) {
                                var _handlers$i = handlers[i], onSuccess = _handlers$i.onSuccess, onError = _handlers$i.onError, promise = _handlers$i.promise, result = void 0;
                                if (resolved) try {
                                    result = onSuccess ? onSuccess(_this3.value) : _this3.value;
                                } catch (err) {
                                    return promise.reject(err), "continue";
                                } else if (rejected) {
                                    if (!onError) return promise.reject(_this3.error), "continue";
                                    try {
                                        result = onError(_this3.error);
                                    } catch (err) {
                                        return promise.reject(err), "continue";
                                    }
                                }
                                result instanceof ZalgoPromise && (result.resolved || result.rejected) ? (result.resolved ? promise.resolve(result.value) : promise.reject(result.error), 
                                result.errorHandled = !0) : (0, _utils.isPromise)(result) ? result instanceof ZalgoPromise && (result.resolved || result.rejected) ? result.resolved ? promise.resolve(result.value) : promise.reject(result.error) : result.then(function(res) {
                                    promise.resolve(res);
                                }, function(err) {
                                    promise.reject(err);
                                }) : promise.resolve(result);
                            })(i);
                        }
                        handlers.length = 0, this.dispatching = !1;
                    }
                }
            }, {
                key: "then",
                value: function(onSuccess, onError) {
                    if (onSuccess && "function" != typeof onSuccess && !onSuccess.call) throw new Error("Promise.then expected a function for success handler");
                    if (onError && "function" != typeof onError && !onError.call) throw new Error("Promise.then expected a function for error handler");
                    var promise = new ZalgoPromise();
                    return this.handlers.push({
                        promise: promise,
                        onSuccess: onSuccess,
                        onError: onError
                    }), this.errorHandled = !0, this.dispatch(), promise;
                }
            }, {
                key: "catch",
                value: function(onError) {
                    return this.then(void 0, onError);
                }
            }, {
                key: "finally",
                value: function(handler) {
                    return this.then(function(result) {
                        return ZalgoPromise.try(handler).then(function() {
                            return result;
                        });
                    }, function(err) {
                        return ZalgoPromise.try(handler).then(function() {
                            throw err;
                        });
                    });
                }
            }, {
                key: "timeout",
                value: function(time, err) {
                    var _this4 = this;
                    if (this.resolved || this.rejected) return this;
                    var timeout = setTimeout(function() {
                        _this4.resolved || _this4.rejected || _this4.reject(err || new Error("Promise timed out after " + time + "ms"));
                    }, time);
                    return this.then(function(result) {
                        return clearTimeout(timeout), result;
                    });
                }
            }, {
                key: "toPromise",
                value: function() {
                    if (!window.Promise) throw new Error("Could not find window.Promise");
                    return window.Promise.resolve(this);
                }
            } ], [ {
                key: "resolve",
                value: function(value) {
                    return value instanceof ZalgoPromise ? value : (0, _utils.isPromise)(value) ? new ZalgoPromise(function(resolve, reject) {
                        return value.then(resolve, reject);
                    }) : new ZalgoPromise().resolve(value);
                }
            }, {
                key: "reject",
                value: function(error) {
                    return new ZalgoPromise().reject(error);
                }
            }, {
                key: "all",
                value: function(promises) {
                    var promise = new ZalgoPromise(), count = promises.length, results = [];
                    if (!count) return promise.resolve(results), promise;
                    for (var i = 0; i < promises.length; i++) !function(i) {
                        ZalgoPromise.resolve(promises[i]).then(function(result) {
                            results[i] = result, 0 === (count -= 1) && promise.resolve(results);
                        }, function(err) {
                            promise.reject(err);
                        });
                    }(i);
                    return promise;
                }
            }, {
                key: "map",
                value: function(promises, method) {
                    var promise = new ZalgoPromise(), count = promises.length, results = [];
                    if (!count) return promise.resolve(results), promise;
                    for (var i = 0; i < promises.length; i++) !function(i) {
                        ZalgoPromise.try(function() {
                            return method(promises[i]);
                        }).then(function(result) {
                            results[i] = result, 0 === (count -= 1) && promise.resolve(results);
                        }, function(err) {
                            promise.reject(err);
                        });
                    }(i);
                    return promise;
                }
            }, {
                key: "onPossiblyUnhandledException",
                value: function(handler) {
                    return (0, _exceptions.onPossiblyUnhandledException)(handler);
                }
            }, {
                key: "try",
                value: function(method, context, args) {
                    var result = void 0;
                    try {
                        result = method.apply(context, args || []);
                    } catch (err) {
                        return ZalgoPromise.reject(err);
                    }
                    return ZalgoPromise.resolve(result);
                }
            }, {
                key: "delay",
                value: function(_delay) {
                    return new ZalgoPromise(function(resolve) {
                        setTimeout(resolve, _delay);
                    });
                }
            }, {
                key: "hash",
                value: function(obj) {
                    var results = {}, promises = [];
                    for (var key in obj) !function(key) {
                        obj.hasOwnProperty(key) && promises.push(ZalgoPromise.resolve(obj[key]).then(function(result) {
                            results[key] = result;
                        }));
                    }(key);
                    return ZalgoPromise.all(promises).then(function() {
                        return results;
                    });
                }
            }, {
                key: "isPromise",
                value: function(value) {
                    return !!(value && value instanceof ZalgoPromise) || (0, _utils.isPromise)(value);
                }
            } ]), ZalgoPromise;
        }();
        exports.ZalgoPromise = ZalgoPromise;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function isPromise(item) {
            try {
                if (!item) return !1;
                if (window.Promise && item instanceof window.Promise) return !0;
                if (window.Window && item instanceof window.Window) return !1;
                if (window.constructor && item instanceof window.constructor) return !1;
                if (toString) {
                    var name = toString.call(item);
                    if ("[object Window]" === name || "[object global]" === name || "[object DOMWindow]" === name) return !1;
                }
                if ("function" == typeof item.then) return !0;
            } catch (err) {
                return !1;
            }
            return !1;
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.isPromise = isPromise;
        var toString = {}.toString;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function cleanUpWindow(win) {
            var requestPromises = _global.global.requestPromises.get(win);
            if (requestPromises) for (var _iterator = requestPromises, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    if (_i = _iterator.next(), _i.done) break;
                    _ref = _i.value;
                }
                var promise = _ref;
                promise.reject(new Error("No response from window - cleaned up"));
            }
            _global.global.popupWindowsByWin && _global.global.popupWindowsByWin.delete(win), 
            _global.global.remoteWindows && _global.global.remoteWindows.delete(win), _global.global.requestPromises.delete(win), 
            _global.global.methods.delete(win), _global.global.readyPromises.delete(win);
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.cleanUpWindow = cleanUpWindow;
        var _global = __webpack_require__(3);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function _defineProperty(obj, key, value) {
            return key in obj ? Object.defineProperty(obj, key, {
                value: value,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : obj[key] = value, obj;
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.CONFIG = void 0;
        var _ALLOWED_POST_MESSAGE, _constants = __webpack_require__(10), CONFIG = exports.CONFIG = {
            ALLOW_POSTMESSAGE_POPUP: !0,
            LOG_LEVEL: "info",
            BRIDGE_TIMEOUT: 5e3,
            ACK_TIMEOUT: 1e3,
            RES_TIMEOUT: 1 / 0,
            LOG_TO_PAGE: !1,
            ALLOWED_POST_MESSAGE_METHODS: (_ALLOWED_POST_MESSAGE = {}, _defineProperty(_ALLOWED_POST_MESSAGE, _constants.CONSTANTS.SEND_STRATEGIES.POST_MESSAGE, !0), 
            _defineProperty(_ALLOWED_POST_MESSAGE, _constants.CONSTANTS.SEND_STRATEGIES.BRIDGE, !0), 
            _defineProperty(_ALLOWED_POST_MESSAGE, _constants.CONSTANTS.SEND_STRATEGIES.GLOBAL, !0), 
            _ALLOWED_POST_MESSAGE)
        };
        0 === window.location.href.indexOf(_constants.CONSTANTS.FILE_PROTOCOL) && (CONFIG.ALLOW_POSTMESSAGE_POPUP = !0);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function parseMessage(message) {
            var parsedMessage = void 0;
            try {
                parsedMessage = (0, _lib.jsonParse)(message);
            } catch (err) {
                return;
            }
            if (parsedMessage && "object" === (void 0 === parsedMessage ? "undefined" : _typeof(parsedMessage)) && null !== parsedMessage && (parsedMessage = parsedMessage[_conf.CONSTANTS.WINDOW_PROPS.POSTROBOT]) && "object" === (void 0 === parsedMessage ? "undefined" : _typeof(parsedMessage)) && null !== parsedMessage && parsedMessage.type && "string" == typeof parsedMessage.type && _types.RECEIVE_MESSAGE_TYPES[parsedMessage.type]) return parsedMessage;
        }
        function receiveMessage(event) {
            if (!window || window.closed) throw new Error("Message recieved in closed window");
            try {
                if (!event.source) return;
            } catch (err) {
                return;
            }
            var source = event.source, origin = event.origin, data = event.data, message = parseMessage(data);
            if (message) {
                if (!message.sourceDomain || "string" != typeof message.sourceDomain) throw new Error("Expected message to have sourceDomain");
                if (0 !== message.sourceDomain.indexOf(_conf.CONSTANTS.MOCK_PROTOCOL) && 0 !== message.sourceDomain.indexOf(_conf.CONSTANTS.FILE_PROTOCOL) || (origin = message.sourceDomain), 
                -1 === _global.global.receivedMessages.indexOf(message.id)) {
                    _global.global.receivedMessages.push(message.id);
                    var level = void 0;
                    if (level = -1 !== _conf.POST_MESSAGE_NAMES_LIST.indexOf(message.name) || message.type === _conf.CONSTANTS.POST_MESSAGE_TYPE.ACK ? "debug" : "error" === message.ack ? "error" : "info", 
                    _lib.log.logLevel(level, [ "\n\n\t", "#receive", message.type.replace(/^postrobot_message_/, ""), "::", message.name, "::", origin, "\n\n", message ]), 
                    (0, _src.isWindowClosed)(source)) return void _lib.log.debug("Source window is closed - can not send " + message.type + " " + message.name);
                    message.data && (message.data = (0, _lib.deserializeMethods)(source, origin, message.data)), 
                    _types.RECEIVE_MESSAGE_TYPES[message.type](source, origin, message);
                }
            }
        }
        function messageListener(event) {
            try {
                event.source;
            } catch (err) {
                return;
            }
            var messageEvent = {
                source: event.source || event.sourceElement,
                origin: event.origin || event.originalEvent && event.originalEvent.origin,
                data: event.data
            };
            receiveMessage(messageEvent);
        }
        function listenForMessages() {
            (0, _lib.addEventListener)(window, "message", messageListener);
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        exports.receiveMessage = receiveMessage, exports.messageListener = messageListener, 
        exports.listenForMessages = listenForMessages;
        var _src = __webpack_require__(1), _conf = __webpack_require__(0), _lib = __webpack_require__(4), _global = __webpack_require__(3), _types = __webpack_require__(23);
        _global.global.receivedMessages = _global.global.receivedMessages || [];
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function _defineProperty(obj, key, value) {
            return key in obj ? Object.defineProperty(obj, key, {
                value: value,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : obj[key] = value, obj;
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.RECEIVE_MESSAGE_TYPES = void 0;
        var _RECEIVE_MESSAGE_TYPE, _extends = Object.assign || function(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];
                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
            }
            return target;
        }, _src = __webpack_require__(2), _src2 = __webpack_require__(1), _conf = __webpack_require__(0), _lib = __webpack_require__(4), _send = __webpack_require__(12), _listeners = __webpack_require__(11);
        exports.RECEIVE_MESSAGE_TYPES = (_RECEIVE_MESSAGE_TYPE = {}, _defineProperty(_RECEIVE_MESSAGE_TYPE, _conf.CONSTANTS.POST_MESSAGE_TYPE.ACK, function(source, origin, message) {
            var options = (0, _listeners.getResponseListener)(message.hash);
            if (!options) throw new Error("No handler found for post message ack for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
            if (!(0, _src2.matchDomain)(options.domain, origin)) throw new Error("Ack origin " + origin + " does not match domain " + options.domain.toString());
            options.ack = !0;
        }), _defineProperty(_RECEIVE_MESSAGE_TYPE, _conf.CONSTANTS.POST_MESSAGE_TYPE.REQUEST, function(source, origin, message) {
            function respond(data) {
                return message.fireAndForget || (0, _src2.isWindowClosed)(source) ? _src.ZalgoPromise.resolve() : (0, 
                _send.sendMessage)(source, _extends({
                    target: message.originalSource,
                    hash: message.hash,
                    name: message.name
                }, data), origin);
            }
            var options = (0, _listeners.getRequestListener)({
                name: message.name,
                win: source,
                domain: origin
            });
            return _src.ZalgoPromise.all([ respond({
                type: _conf.CONSTANTS.POST_MESSAGE_TYPE.ACK
            }), _src.ZalgoPromise.try(function() {
                if (!options) throw new Error("No handler found for post message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                if (!(0, _src2.matchDomain)(options.domain, origin)) throw new Error("Request origin " + origin + " does not match domain " + options.domain.toString());
                var data = message.data;
                return options.handler({
                    source: source,
                    origin: origin,
                    data: data
                });
            }).then(function(data) {
                return respond({
                    type: _conf.CONSTANTS.POST_MESSAGE_TYPE.RESPONSE,
                    ack: _conf.CONSTANTS.POST_MESSAGE_ACK.SUCCESS,
                    data: data
                });
            }, function(err) {
                var error = (0, _lib.stringifyError)(err).replace(/^Error: /, "");
                return respond({
                    type: _conf.CONSTANTS.POST_MESSAGE_TYPE.RESPONSE,
                    ack: _conf.CONSTANTS.POST_MESSAGE_ACK.ERROR,
                    error: error
                });
            }) ]).then(_lib.noop).catch(function(err) {
                if (options && options.handleError) return options.handleError(err);
                _lib.log.error((0, _lib.stringifyError)(err));
            });
        }), _defineProperty(_RECEIVE_MESSAGE_TYPE, _conf.CONSTANTS.POST_MESSAGE_TYPE.RESPONSE, function(source, origin, message) {
            var options = (0, _listeners.getResponseListener)(message.hash);
            if (!options) throw new Error("No handler found for post message response for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
            if (!(0, _src2.matchDomain)(options.domain, origin)) throw new Error("Response origin " + origin + " does not match domain " + options.domain);
            if ((0, _listeners.deleteResponseListener)(message.hash), message.ack === _conf.CONSTANTS.POST_MESSAGE_ACK.ERROR) return options.respond(new Error(message.error), null);
            if (message.ack === _conf.CONSTANTS.POST_MESSAGE_ACK.SUCCESS) {
                var data = message.data || message.response;
                return options.respond(null, {
                    source: source,
                    origin: origin,
                    data: data
                });
            }
        }), _RECEIVE_MESSAGE_TYPE);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.SEND_MESSAGE_STRATEGIES = void 0;
        var _src = __webpack_require__(1), _conf = __webpack_require__(0), SEND_MESSAGE_STRATEGIES = exports.SEND_MESSAGE_STRATEGIES = {};
        SEND_MESSAGE_STRATEGIES[_conf.CONSTANTS.SEND_STRATEGIES.POST_MESSAGE] = function(win, serializedMessage, domain) {
            var domains = void 0;
            domains = Array.isArray(domain) ? domain : domain ? [ domain ] : [ _conf.CONSTANTS.WILDCARD ], 
            domains = domains.map(function(dom) {
                if (0 === dom.indexOf(_conf.CONSTANTS.MOCK_PROTOCOL)) {
                    if (window.location.protocol === _conf.CONSTANTS.FILE_PROTOCOL) return _conf.CONSTANTS.WILDCARD;
                    if (!(0, _src.isActuallySameDomain)(win)) throw new Error("Attempting to send messsage to mock domain " + dom + ", but window is actually cross-domain");
                    return (0, _src.getActualDomain)(win);
                }
                return 0 === dom.indexOf(_conf.CONSTANTS.FILE_PROTOCOL) ? _conf.CONSTANTS.WILDCARD : dom;
            }), domains.forEach(function(dom) {
                return win.postMessage(serializedMessage, dom);
            });
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _interface = __webpack_require__(8);
        Object.keys(_interface).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _interface[key];
                }
            });
        });
        var INTERFACE = function(obj) {
            if (obj && obj.__esModule) return obj;
            var newObj = {};
            if (null != obj) for (var key in obj) Object.prototype.hasOwnProperty.call(obj, key) && (newObj[key] = obj[key]);
            return newObj.default = obj, newObj;
        }(_interface);
        exports.default = INTERFACE;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function initOnReady() {
            (0, _interface.on)(_conf.CONSTANTS.POST_MESSAGE_NAMES.READY, {
                window: _conf.CONSTANTS.WILDCARD,
                domain: _conf.CONSTANTS.WILDCARD
            }, function(event) {
                var win = event.source, promise = _global.global.readyPromises.get(win);
                promise ? promise.resolve(event) : (promise = new _src3.ZalgoPromise().resolve(event), 
                _global.global.readyPromises.set(win, promise));
            });
            var parent = (0, _src2.getAncestor)();
            parent && (0, _interface.send)(parent, _conf.CONSTANTS.POST_MESSAGE_NAMES.READY, {}, {
                domain: _conf.CONSTANTS.WILDCARD,
                timeout: 1 / 0
            }).catch(function(err) {
                _log.log.debug((0, _util.stringifyError)(err));
            });
        }
        function onWindowReady(win) {
            var timeout = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5e3, name = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "Window", promise = _global.global.readyPromises.get(win);
            return promise || (promise = new _src3.ZalgoPromise(), _global.global.readyPromises.set(win, promise), 
            setTimeout(function() {
                return promise.reject(new Error(name + " did not load after " + timeout + "ms"));
            }, timeout), promise);
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.initOnReady = initOnReady, exports.onWindowReady = onWindowReady;
        var _src = __webpack_require__(5), _src2 = __webpack_require__(1), _src3 = __webpack_require__(2), _conf = __webpack_require__(0), _interface = __webpack_require__(8), _log = __webpack_require__(9), _global = __webpack_require__(3), _util = __webpack_require__(7);
        _global.global.readyPromises = _global.global.readyPromises || new _src.WeakMap();
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function isSerialized(item, type) {
            return "object" === (void 0 === item ? "undefined" : _typeof(item)) && null !== item && item.__type__ === type;
        }
        function serializeMethod(destination, domain, method, name) {
            var id = (0, _util.uniqueID)(), methods = _global.global.methods.get(destination);
            return methods || (methods = {}, _global.global.methods.set(destination, methods)), 
            methods[id] = {
                domain: domain,
                method: method
            }, {
                __type__: _conf.CONSTANTS.SERIALIZATION_TYPES.METHOD,
                __id__: id,
                __name__: name
            };
        }
        function serializeError(err) {
            return {
                __type__: _conf.CONSTANTS.SERIALIZATION_TYPES.ERROR,
                __message__: (0, _util.stringifyError)(err)
            };
        }
        function serializePromise(destination, domain, promise, name) {
            return {
                __type__: _conf.CONSTANTS.SERIALIZATION_TYPES.PROMISE,
                __then__: serializeMethod(destination, domain, function(resolve, reject) {
                    return promise.then(resolve, reject);
                }, name + ".then")
            };
        }
        function serializeZalgoPromise(destination, domain, promise, name) {
            return {
                __type__: _conf.CONSTANTS.SERIALIZATION_TYPES.ZALGO_PROMISE,
                __then__: serializeMethod(destination, domain, function(resolve, reject) {
                    return promise.then(resolve, reject);
                }, name + ".then")
            };
        }
        function serializeRegex(regex) {
            return {
                __type__: _conf.CONSTANTS.SERIALIZATION_TYPES.REGEX,
                __source__: regex.source
            };
        }
        function serializeMethods(destination, domain, obj) {
            return (0, _util.replaceObject)({
                obj: obj
            }, function(item, key) {
                return "function" == typeof item ? serializeMethod(destination, domain, item, key.toString()) : item instanceof Error ? serializeError(item) : window.Promise && item instanceof window.Promise ? serializePromise(destination, domain, item, key.toString()) : _src3.ZalgoPromise.isPromise(item) ? serializeZalgoPromise(destination, domain, item, key.toString()) : (0, 
                _util.isRegex)(item) ? serializeRegex(item) : void 0;
            }).obj;
        }
        function deserializeMethod(source, origin, obj) {
            function wrapper() {
                var args = Array.prototype.slice.call(arguments);
                return _log.log.debug("Call foreign method", obj.__name__, args), (0, _interface.send)(source, _conf.CONSTANTS.POST_MESSAGE_NAMES.METHOD, {
                    id: obj.__id__,
                    name: obj.__name__,
                    args: args
                }, {
                    domain: origin,
                    timeout: 1 / 0
                }).then(function(_ref2) {
                    var data = _ref2.data;
                    return _log.log.debug("Got foreign method result", obj.__name__, data.result), data.result;
                }, function(err) {
                    throw _log.log.debug("Got foreign method error", (0, _util.stringifyError)(err)), 
                    err;
                });
            }
            return wrapper.__name__ = obj.__name__, wrapper.__xdomain__ = !0, wrapper.source = source, 
            wrapper.origin = origin, wrapper;
        }
        function deserializeError(source, origin, obj) {
            return new Error(obj.__message__);
        }
        function deserializeZalgoPromise(source, origin, prom) {
            return new _src3.ZalgoPromise(function(resolve, reject) {
                return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
            });
        }
        function deserializePromise(source, origin, prom) {
            return window.Promise ? new window.Promise(function(resolve, reject) {
                return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
            }) : deserializeZalgoPromise(source, origin, prom);
        }
        function deserializeRegex(source, origin, item) {
            return new RegExp(item.__source__);
        }
        function deserializeMethods(source, origin, obj) {
            return (0, _util.replaceObject)({
                obj: obj
            }, function(item, key) {
                if ("object" === (void 0 === item ? "undefined" : _typeof(item)) && null !== item) return isSerialized(item, _conf.CONSTANTS.SERIALIZATION_TYPES.METHOD) ? deserializeMethod(source, origin, item) : isSerialized(item, _conf.CONSTANTS.SERIALIZATION_TYPES.ERROR) ? deserializeError(source, origin, item) : isSerialized(item, _conf.CONSTANTS.SERIALIZATION_TYPES.PROMISE) ? deserializePromise(source, origin, item) : isSerialized(item, _conf.CONSTANTS.SERIALIZATION_TYPES.ZALGO_PROMISE) ? deserializeZalgoPromise(source, origin, item) : isSerialized(item, _conf.CONSTANTS.SERIALIZATION_TYPES.REGEX) ? deserializeRegex(source, origin, item) : void 0;
            }).obj;
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.listenForMethods = void 0;
        var _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        exports.serializeMethod = serializeMethod, exports.serializeMethods = serializeMethods, 
        exports.deserializeMethod = deserializeMethod, exports.deserializeError = deserializeError, 
        exports.deserializeZalgoPromise = deserializeZalgoPromise, exports.deserializePromise = deserializePromise, 
        exports.deserializeRegex = deserializeRegex, exports.deserializeMethods = deserializeMethods;
        var _src = __webpack_require__(5), _src2 = __webpack_require__(1), _src3 = __webpack_require__(2), _conf = __webpack_require__(0), _util = __webpack_require__(7), _interface = __webpack_require__(8), _log = __webpack_require__(9), _global = __webpack_require__(3);
        _global.global.methods = _global.global.methods || new _src.WeakMap();
        exports.listenForMethods = (0, _util.once)(function() {
            (0, _interface.on)(_conf.CONSTANTS.POST_MESSAGE_NAMES.METHOD, {
                window: _conf.CONSTANTS.WILDCARD,
                origin: _conf.CONSTANTS.WILDCARD
            }, function(_ref) {
                var source = _ref.source, origin = _ref.origin, data = _ref.data, methods = _global.global.methods.get(source);
                if (!methods) throw new Error("Could not find any methods this window has privileges to call");
                var meth = methods[data.id];
                if (!meth) throw new Error("Could not find method with id: " + data.id);
                if (!(0, _src2.matchDomain)(meth.domain, origin)) throw new Error("Method domain " + meth.domain + " does not match origin " + origin);
                return _log.log.debug("Call local method", data.name, data.args), _src3.ZalgoPromise.try(function() {
                    return meth.method.apply({
                        source: source,
                        origin: origin,
                        data: data
                    }, data.args);
                }).then(function(result) {
                    return {
                        result: result,
                        id: data.id,
                        name: data.name
                    };
                });
            });
        });
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function request(options) {
            return _src2.ZalgoPromise.try(function() {
                if (!options.name) throw new Error("Expected options.name");
                var name = options.name, win = options.window, domain = void 0;
                if ("string" == typeof win) {
                    var el = document.getElementById(win);
                    if (!el) throw new Error("Expected options.window " + Object.prototype.toString.call(win) + " to be a valid element id");
                    if ("iframe" !== el.tagName.toLowerCase()) throw new Error("Expected options.window " + Object.prototype.toString.call(win) + " to be an iframe");
                    if (!el.contentWindow) throw new Error("Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.");
                    win = el.contentWindow;
                } else if (win instanceof HTMLElement) {
                    if ("iframe" !== win.tagName.toLowerCase()) throw new Error("Expected options.window " + Object.prototype.toString.call(win) + " to be an iframe");
                    if (win && !win.contentWindow) throw new Error("Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.");
                    win && win.contentWindow && (win = win.contentWindow);
                }
                if (!win) throw new Error("Expected options.window to be a window object, iframe, or iframe element id.");
                domain = options.domain || _conf.CONSTANTS.WILDCARD;
                var hash = options.name + "_" + (0, _lib.uniqueID)();
                if ((0, _src3.isWindowClosed)(win)) throw new Error("Target window is closed");
                var hasResult = !1, requestPromises = _global.global.requestPromises.get(win);
                requestPromises || (requestPromises = [], _global.global.requestPromises.set(win, requestPromises));
                var requestPromise = _src2.ZalgoPromise.try(function() {
                    if ((0, _src3.isAncestor)(window, win)) return _src2.ZalgoPromise.resolve((0, _lib.onWindowReady)(win));
                }).then(function() {
                    return new _src2.ZalgoPromise(function(resolve, reject) {
                        var responseListener = {
                            name: name,
                            window: win,
                            domain: domain,
                            respond: function(err, result) {
                                err || (hasResult = !0, requestPromises.splice(requestPromises.indexOf(requestPromise, 1))), 
                                err ? reject(err) : resolve(result);
                            }
                        };
                        if ((0, _drivers.addResponseListener)(hash, responseListener), (0, _drivers.sendMessage)(win, {
                            type: _conf.CONSTANTS.POST_MESSAGE_TYPE.REQUEST,
                            hash: hash,
                            name: name,
                            data: options.data,
                            fireAndForget: options.fireAndForget
                        }, domain).catch(reject), options.fireAndForget) return resolve();
                        var ackTimeout = _conf.CONFIG.ACK_TIMEOUT, resTimeout = options.timeout || _conf.CONFIG.RES_TIMEOUT, cycleTime = 100, cycle = function cycle() {
                            if (!hasResult) {
                                if ((0, _src3.isWindowClosed)(win)) return reject(responseListener.ack ? new Error("Window closed for " + name + " before response") : new Error("Window closed for " + name + " before ack"));
                                ackTimeout -= cycleTime, resTimeout -= cycleTime;
                                if (responseListener.ack) {
                                    if (resTimeout === 1 / 0) return;
                                    cycleTime = Math.min(resTimeout, 2e3);
                                } else {
                                    if (ackTimeout <= 0) return reject(new Error("No ack for postMessage " + name + " in " + _conf.CONFIG.ACK_TIMEOUT + "ms"));
                                    if (resTimeout <= 0) return reject(new Error("No response for postMessage " + name + " in " + (options.timeout || _conf.CONFIG.RES_TIMEOUT) + "ms"));
                                }
                                setTimeout(cycle, cycleTime);
                            }
                        };
                        setTimeout(cycle, cycleTime);
                    });
                });
                return requestPromise.catch(function() {
                    (0, _drivers.deleteResponseListener)(hash);
                }), requestPromises.push(requestPromise), requestPromise;
            });
        }
        function _send(window, name, data, options) {
            return options = options || {}, options.window = window, options.name = name, options.data = data, 
            request(options);
        }
        function sendToParent(name, data, options) {
            var win = (0, _src3.getAncestor)();
            return win ? _send(win, name, data, options) : new _src2.ZalgoPromise(function(resolve, reject) {
                return reject(new Error("Window does not have a parent"));
            });
        }
        function client() {
            var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (!options.window) throw new Error("Expected options.window");
            return {
                send: function(name, data) {
                    return _send(options.window, name, data, options);
                }
            };
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.send = void 0, exports.request = request, exports.sendToParent = sendToParent, 
        exports.client = client;
        var _src = __webpack_require__(5), _src2 = __webpack_require__(2), _src3 = __webpack_require__(1), _conf = __webpack_require__(0), _drivers = __webpack_require__(6), _lib = __webpack_require__(4), _global = __webpack_require__(3);
        _global.global.requestPromises = _global.global.requestPromises || new _src.WeakMap(), 
        exports.send = _send;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function disable() {
            delete window[_conf.CONSTANTS.WINDOW_PROPS.POSTROBOT], window.removeEventListener("message", _drivers.messageListener);
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.CONSTANTS = exports.CONFIG = void 0;
        var _conf = __webpack_require__(0);
        Object.defineProperty(exports, "CONFIG", {
            enumerable: !0,
            get: function() {
                return _conf.CONFIG;
            }
        }), Object.defineProperty(exports, "CONSTANTS", {
            enumerable: !0,
            get: function() {
                return _conf.CONSTANTS;
            }
        }), exports.disable = disable;
        var _drivers = __webpack_require__(6);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.bridge = exports.parent = void 0;
        var _client = __webpack_require__(28);
        Object.keys(_client).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _client[key];
                }
            });
        });
        var _server = __webpack_require__(31);
        Object.keys(_server).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _server[key];
                }
            });
        });
        var _config = __webpack_require__(29);
        Object.keys(_config).forEach(function(key) {
            "default" !== key && "__esModule" !== key && Object.defineProperty(exports, key, {
                enumerable: !0,
                get: function() {
                    return _config[key];
                }
            });
        });
        var _src = __webpack_require__(1);
        exports.parent = (0, _src.getAncestor)(), exports.bridge = void 0;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function listen(options) {
            if (!options.name) throw new Error("Expected options.name");
            if (!options.handler) throw new Error("Expected options.handler");
            var listenerOptions = {
                handler: options.handler,
                handleError: options.errorHandler || function(err) {
                    throw err;
                },
                window: options.window,
                domain: options.domain || _conf.CONSTANTS.WILDCARD,
                name: options.name
            }, requestListener = (0, _drivers.addRequestListener)({
                name: listenerOptions.name,
                win: listenerOptions.window,
                domain: listenerOptions.domain
            }, listenerOptions);
            if (options.once) {
                var _handler = listenerOptions.handler;
                listenerOptions.handler = (0, _lib.once)(function() {
                    return requestListener.cancel(), _handler.apply(this, arguments);
                });
            }
            if (listenerOptions.window && options.errorOnClose) var interval = (0, _lib.safeInterval)(function() {
                (0, _src.isWindowClosed)(listenerOptions.window) && (interval.cancel(), listenerOptions.handleError(new Error("Post message target window is closed")));
            }, 50);
            return {
                cancel: function() {
                    requestListener.cancel();
                }
            };
        }
        function _on(name, options, handler) {
            return "function" == typeof options && (handler = options, options = {}), options = options || {}, 
            options.name = name, options.handler = handler || options.handler, listen(options);
        }
        function once(name) {
            var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, handler = arguments[2];
            "function" == typeof options && (handler = options, options = {}), options = options || {}, 
            handler = handler || options.handler;
            var errorHandler = options.errorHandler, promise = new _src2.ZalgoPromise(function(resolve, reject) {
                options = options || {}, options.name = name, options.once = !0, options.handler = function(event) {
                    if (resolve(event), handler) return handler(event);
                }, options.errorHandler = function(err) {
                    if (reject(err), errorHandler) return errorHandler(err);
                };
            }), onceListener = listen(options);
            return promise.cancel = onceListener.cancel, promise;
        }
        function listener() {
            var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return {
                on: function(name, handler) {
                    return _on(name, options, handler);
                }
            };
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.on = void 0, exports.listen = listen, exports.once = once, exports.listener = listener;
        var _src = __webpack_require__(1), _src2 = __webpack_require__(2), _lib = __webpack_require__(4), _drivers = __webpack_require__(6), _conf = __webpack_require__(0);
        exports.on = _on;
    } ]);
});
//# sourceMappingURL=post-robot.js.map

/***/ }),

/***/ "b7Yt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonContext = undefined;

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = __webpack_require__("iy81");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _TabContext2 = __webpack_require__("E60P");

var _CustomFields = __webpack_require__("S6PW");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 * @extends {Context}
 */
var PersonContext = exports.PersonContext = function (_TabContext) {
  (0, _inherits3.default)(PersonContext, _TabContext);
  (0, _createClass3.default)(PersonContext, null, [{
    key: 'tryAndCreate',


    /**
     * @method
     * @static
     *
     * @param {EventDispatcher} outgoingDispatcher
     * @param {EventDispatcher} incomingDispatcher
     * @param {InstanceProps} instanceProps
     * @param {ContextProps} contextProps
     * @return {PersonContext|null}
     */
    value: function tryAndCreate(_ref) {
      var outgoingDispatcher = _ref.outgoingDispatcher,
          incomingDispatcher = _ref.incomingDispatcher,
          instanceProps = _ref.instanceProps,
          contextProps = _ref.contextProps;

      if (contextProps.contextType === PersonContext.TYPE) {
        var props = (0, _extends3.default)({
          outgoingDispatcher: outgoingDispatcher,
          incomingDispatcher: incomingDispatcher
        }, contextProps.toJS(), {
          type: contextProps.contextType,
          instanceId: instanceProps.instanceId
        });
        return new PersonContext(props);
      }

      return null;
    }

    /**
     * @constructor
     *
     * @param {string} instanceId
     * @param {{}} rest
     */

  }, {
    key: 'TYPE',

    /**
     * @static
     * @readonly
     * @type {string}
     */
    get: function get() {
      return 'person';
    }
  }]);

  function PersonContext(_ref2) {
    var instanceId = _ref2.instanceId,
        rest = (0, _objectWithoutProperties3.default)(_ref2, ['instanceId']);
    (0, _classCallCheck3.default)(this, PersonContext);
    return (0, _possibleConstructorReturn3.default)(this, (PersonContext.__proto__ || (0, _getPrototypeOf2.default)(PersonContext)).call(this, (0, _extends3.default)({ instanceId: instanceId }, rest)));
  }

  /**
   * @public
   * @return {CustomFieldsClient}
   */


  (0, _createClass3.default)(PersonContext, [{
    key: 'customFields',
    get: function get() {
      var _props = this.props,
          outgoingDispatcher = _props.outgoingDispatcher,
          instanceId = _props.instanceId;

      return new _CustomFields.CustomFieldsClient({
        outgoingDispatcher: outgoingDispatcher,
        instanceId: instanceId,
        endpoint: 'people/' + this.entityId
      });
    }
  }]);
  return PersonContext;
}(_TabContext2.TabContext);

/***/ }),

/***/ "b9e4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerEventHandlers = undefined;

var _Events = __webpack_require__("ok1y");

var Events = _interopRequireWildcard(_Events);

var _EventHandler = __webpack_require__("zx9m");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @method
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {App} app
 */
/**
 * @module DeskproWindow/TicketEventHandlers
 */

var registerEventHandlers = exports.registerEventHandlers = function registerEventHandlers(windowBridge, app) {
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, Events.EVENT_DESKPROWINDOW_INSERT_MARKUP, Events.props.EVENT_DESKPROWINDOW_INSERT_MARKUP);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, Events.EVENT_DESKPROWINDOW_SHOW_NOTIFICATION, Events.props.EVENT_DESKPROWINDOW_SHOW_NOTIFICATION);
};

/***/ }),

/***/ "cM6o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("KIIz");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ "cQBz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerEventHandlers = undefined;

var _AppEvents = __webpack_require__("nadw");

var Events = _interopRequireWildcard(_AppEvents);

var _EventHandler = __webpack_require__("zx9m");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @method
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {App} app
 */
/**
 * @module Core/AppEventHandlers
 */

var registerEventHandlers = exports.registerEventHandlers = function registerEventHandlers(windowBridge, app) {
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, Events.EVENT_RESET_SIZE, Events.props.EVENT_RESET_SIZE);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, Events.EVENT_SUBSCRIBE, Events.props.EVENT_SUBSCRIBE);
};

/***/ }),

/***/ "d64R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageAdapter = undefined;

var _regenerator = __webpack_require__("ED1s");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__("iK2U");

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__("xs8S");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _asyncToGenerator2 = __webpack_require__("Dfz+");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _StorageAdapter2 = __webpack_require__("2njn");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 */
var LocalStorageAdapter = exports.LocalStorageAdapter = function (_StorageAdapter) {
  (0, _inherits3.default)(LocalStorageAdapter, _StorageAdapter);
  (0, _createClass3.default)(LocalStorageAdapter, null, [{
    key: 'fromGlobals',

    /**
     * @method
     * @return {LocalStorageAdapter}
     */
    value: function fromGlobals() {
      var _window = window,
          localStorage = _window.localStorage;

      return new LocalStorageAdapter(localStorage);
    }

    /**
     * @param {LocalStorage} localStorage
     */

  }]);

  function LocalStorageAdapter(localStorage) {
    (0, _classCallCheck3.default)(this, LocalStorageAdapter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LocalStorageAdapter.__proto__ || (0, _getPrototypeOf2.default)(LocalStorageAdapter)).call(this));

    _this.props = { localStorage: localStorage };
    return _this;
  }

  /**
   * @method
   * @param {Promise.<{outgoingDispatcher:EventDispatcher}>} dispatchPromise
   * @param {Array<Array>} nameValuePairsList
   * @param entityId
   * @return {Promise}
   */


  (0, _createClass3.default)(LocalStorageAdapter, [{
    key: 'handleSetBatchStorage',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dispatchPromise, nameValuePairsList, entityId) {
        var localStorage;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                localStorage = this.props.localStorage;
                return _context.abrupt('return', dispatchPromise.then(function (props) {

                  nameValuePairsList.map(function (nameAndValue) {
                    var _nameAndValue = (0, _slicedToArray3.default)(nameAndValue, 2),
                        name = _nameAndValue[0],
                        value = _nameAndValue[1];

                    return ['apps/' + props.instanceId + '/state/' + entityId + '/' + name, value];
                  }).forEach(function (keyAndValue) {
                    var _keyAndValue = (0, _slicedToArray3.default)(keyAndValue, 2),
                        key = _keyAndValue[0],
                        value = _keyAndValue[1];

                    localStorage.setItem(key, (0, _stringify2.default)(value));
                  });

                  return nameValuePairsList;
                }));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSetBatchStorage(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return handleSetBatchStorage;
    }()
  }, {
    key: 'handleSetStorage',


    /**
     * @method
     * @param {Promise.<{outgoingDispatcher:EventDispatcher}>} dispatchPromise
     * @param name
     * @param value
     * @param entityId
     * @return {Promise}
     */
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(dispatchPromise, name, value, entityId) {
        var localStorage;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                localStorage = this.props.localStorage;
                return _context2.abrupt('return', dispatchPromise.then(function (props) {
                  var key = 'apps/' + props.instanceId + '/state/' + entityId + '/' + name;

                  if (!value) {
                    localStorage.removeItem(key);
                  } else {
                    localStorage.setItem(key, (0, _stringify2.default)(value));
                  }

                  return value;
                }));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSetStorage(_x4, _x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return handleSetStorage;
    }()
  }, {
    key: 'handleGetStorage',


    /**
     * @method
     * @param {Promise.<{outgoingDispatcher:EventDispatcher}>} dispatchPromise
     * @param name
     * @param entityId
     * @param defaultValue
     * @return {Promise.<*>}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(dispatchPromise, name, entityId) {
        var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var localStorage;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                localStorage = this.props.localStorage;
                return _context3.abrupt('return', dispatchPromise.then(function (props) {
                  var key = 'apps/' + props.instanceId + '/state/' + entityId + '/' + name;
                  var value = localStorage.getItem(key);

                  if (value) {
                    return JSON.parse(value);
                  }

                  return defaultValue;
                }));

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleGetStorage(_x8, _x9, _x10) {
        return _ref3.apply(this, arguments);
      }

      return handleGetStorage;
    }()
  }, {
    key: 'handleGetBatchStorage',


    /**
     * @method
     * @param {Promise.<{outgoingDispatcher:EventDispatcher}>} dispatchPromise
     * @param {Array<String>} nameList
     * @param {String} entityId
     * @param {*} defaultValue
     * @return {Promise.<{}>}
     */
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(dispatchPromise, nameList, entityId) {
        var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var localStorage;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                localStorage = this.props.localStorage;
                return _context4.abrupt('return', dispatchPromise.then(function (props) {
                  return nameList.map(function (name) {
                    return [name, 'apps/' + props.instanceId + '/state/' + entityId + '/' + name];
                  }).reduce(function (values, nameAndKey) {
                    var _nameAndKey = (0, _slicedToArray3.default)(nameAndKey, 2),
                        name = _nameAndKey[0],
                        key = _nameAndKey[1];

                    var value = localStorage.getItem(key);
                    if (value) {
                      values[name] = JSON.parse(value);
                    }
                    return values;
                  }, {});
                }));

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleGetBatchStorage(_x12, _x13, _x14) {
        return _ref4.apply(this, arguments);
      }

      return handleGetBatchStorage;
    }()
  }]);
  return LocalStorageAdapter;
}(_StorageAdapter2.StorageAdapter);

/***/ }),

/***/ "dUh9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(idHandler) {
    var eventListeners = {};

    /**
     * Gets all listeners for the given element.
     * @public
     * @param {element} element The element to get all listeners for.
     * @returns All listeners for the given element.
     */
    function getListeners(element) {
        var id = idHandler.get(element);

        if (id === undefined) {
            return [];
        }

        return eventListeners[id] || [];
    }

    /**
     * Stores the given listener for the given element. Will not actually add the listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The callback that the element has added.
     */
    function addListener(element, listener) {
        var id = idHandler.get(element);

        if(!eventListeners[id]) {
            eventListeners[id] = [];
        }

        eventListeners[id].push(listener);
    }

    function removeListener(element, listener) {
        var listeners = getListeners(element);
        for (var i = 0, len = listeners.length; i < len; ++i) {
            if (listeners[i] === listener) {
              listeners.splice(i, 1);
              break;
            }
        }
    }

    function removeAllListeners(element) {
      var listeners = getListeners(element);
      if (!listeners) { return; }
      listeners.length = 0;
    }

    return {
        get: getListeners,
        add: addListener,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners
    };
};


/***/ }),

/***/ "dbB1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

/**
 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
 * @public
 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
 */
utils.forEach = function(collection, callback) {
    for(var i = 0; i < collection.length; i++) {
        var result = callback(collection[i]);
        if(result) {
            return result;
        }
    }
};


/***/ }),

/***/ "eMMM":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("IlDj");
__webpack_require__("skuU");
module.exports = __webpack_require__("LO75").f('iterator');

/***/ }),

/***/ "eZLJ":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("/MHE");
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),

/***/ "fQko":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("YGBz"), __esModule: true };

/***/ }),

/***/ "fr7W":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("8VHH");
module.exports = __webpack_require__("Y4Oj").Object.getPrototypeOf;

/***/ }),

/***/ "gM7W":
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),

/***/ "gWZE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("fr7W"), __esModule: true };

/***/ }),

/***/ "gozv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecurityEvents = exports.OauthToken = exports.DeskproWindowEvents = exports.TicketEvents = exports.ContextEvents = exports.StorageEvents = exports.UIConstants = exports.UIEvents = exports.AppEvents = exports.App = exports.createAppFromProps = exports.createApp = undefined;

var _createApp2 = __webpack_require__("yvFe");

Object.defineProperty(exports, 'createAppFromProps', {
  enumerable: true,
  get: function get() {
    return _createApp2.createAppFromProps;
  }
});

var _UI = __webpack_require__("t2//");

Object.defineProperty(exports, 'UIEvents', {
  enumerable: true,
  get: function get() {
    return _UI.UIEvents;
  }
});
Object.defineProperty(exports, 'UIConstants', {
  enumerable: true,
  get: function get() {
    return _UI.UIConstants;
  }
});

var _Storage = __webpack_require__("yNLq");

Object.defineProperty(exports, 'StorageEvents', {
  enumerable: true,
  get: function get() {
    return _Storage.StorageEvents;
  }
});

var _Context = __webpack_require__("peDZ");

Object.defineProperty(exports, 'TicketEvents', {
  enumerable: true,
  get: function get() {
    return _Context.TicketEvents;
  }
});

var _createApp3 = _interopRequireDefault(_createApp2);

var _App2 = __webpack_require__("QqyQ");

var _App3 = _interopRequireDefault(_App2);

var _AppEvents = __webpack_require__("nadw");

var AppEvents = _interopRequireWildcard(_AppEvents);

var _ContextEvents = __webpack_require__("GKfY");

var ContextEvents = _interopRequireWildcard(_ContextEvents);

var _Events = __webpack_require__("ok1y");

var DeskproWindowEvents = _interopRequireWildcard(_Events);

var _Security = __webpack_require__("Xjm4");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createApp = _createApp3.default; /**
                                          * @method
                                          */


/**
 * @type {App}
 */

exports.App = _App3.default;
exports.AppEvents = AppEvents;
exports.ContextEvents = ContextEvents;
exports.DeskproWindowEvents = DeskproWindowEvents;
exports.OauthToken = _Security.OauthToken;
exports.SecurityEvents = _Security.SecurityEvents;

/***/ }),

/***/ "hUDZ":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("3/3c")
  , core    = __webpack_require__("Y4Oj")
  , fails   = __webpack_require__("gM7W");
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),

/***/ "hYG7":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("3/3c");
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__("FRPW").set});

/***/ }),

/***/ "i2QE":
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__("yMXy")
  , ITERATOR  = __webpack_require__("XGUc")('iterator')
  , Iterators = __webpack_require__("50hw");
module.exports = __webpack_require__("Y4Oj").getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),

/***/ "i81l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetResponse = undefined;

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _WidgetMessage2 = __webpack_require__("EL/j");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 * @extends {WidgetMessage}
 */
var WidgetResponse = exports.WidgetResponse = function (_WidgetMessage) {
  (0, _inherits3.default)(WidgetResponse, _WidgetMessage);
  (0, _createClass3.default)(WidgetResponse, null, [{
    key: 'parse',

    /**
     * @static
     * @method
     *
     * @param {*} raw
     * @return {WidgetResponse}
     */
    value: function parse(raw) {
      var id = raw.id,
          widgetId = raw.widgetId,
          correlationId = raw.correlationId,
          body = raw.body,
          status = raw.status;
      // still receiving json encoded strings as body from success responses

      var parsedBody = typeof body === 'string' ? JSON.parse(body) : body;
      return new WidgetResponse({ id: id, widgetId: widgetId, correlationId: correlationId.toString(), body: parsedBody, status: status });
    }
  }]);

  /**
   * @param {String} id
   * @param {String} widgetId
   * @param {String} correlationId
   * @param {*} body
   * @param {String} status
   */
  function WidgetResponse(_ref) {
    var id = _ref.id,
        widgetId = _ref.widgetId,
        correlationId = _ref.correlationId,
        body = _ref.body,
        status = _ref.status;
    (0, _classCallCheck3.default)(this, WidgetResponse);
    return (0, _possibleConstructorReturn3.default)(this, (WidgetResponse.__proto__ || (0, _getPrototypeOf2.default)(WidgetResponse)).call(this, { id: id, widgetId: widgetId, correlationId: correlationId, body: body, status: status }));
  }

  /**
   * @readonly
   *
   * @type {String}
   */


  (0, _createClass3.default)(WidgetResponse, [{
    key: 'status',
    get: function get() {
      return this.props.status;
    }
  }, {
    key: 'rawBody',


    /**
     * @readonly
     *
     * @type {*}
     */
    get: function get() {
      return this.props.body;
    }
  }, {
    key: 'body',


    /**
     * @readonly
     *
     * @type {*}
     */
    get: function get() {
      return this.props.body;
    }
  }]);
  return WidgetResponse;
}(_WidgetMessage2.WidgetMessage);

/***/ }),

/***/ "iImc":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("eZLJ")
  , $keys    = __webpack_require__("GBSe");

__webpack_require__("hUDZ")('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),

/***/ "iK2U":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("OmsT"), __esModule: true };

/***/ }),

/***/ "iUVn":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("shmw")
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),

/***/ "iy81":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ "jD66":
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__("shmw")
  , core           = __webpack_require__("Y4Oj")
  , LIBRARY        = __webpack_require__("XAet")
  , wksExt         = __webpack_require__("LO75")
  , defineProperty = __webpack_require__("PR1c").f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),

/***/ "jjy6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("7kNb");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "jzCG":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("PJO8");
var $Object = __webpack_require__("Y4Oj").Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),

/***/ "k3wI":
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__("u9Aa")
  , toIObject    = __webpack_require__("Uc+M")
  , arrayIndexOf = __webpack_require__("tp8E")(false)
  , IE_PROTO     = __webpack_require__("JYxG")('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),

/***/ "kJI2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Event = exports.isInvocation = exports.matchEvent = exports.buildMap = exports.invocations = exports.INVOCATION_REQUESTRESPONSE = exports.INVOCATION_FIREANDFORGET = exports.channels = exports.CHANNEL_OUTGOING = exports.CHANNEL_INCOMING = exports.CHANNEL_INTERNAL = undefined;

var _stringify = __webpack_require__("iK2U");

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _typeof2 = __webpack_require__("KIIz");

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__("q+0m");

var _keys2 = _interopRequireDefault(_keys);

var _EventMap = __webpack_require__("BHzd");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @type {string}
 */
var CHANNEL_INTERNAL = exports.CHANNEL_INTERNAL = 'event.channel_internal';

/**
 * @type {string}
 */
/**
 * @module Core/Event
 */

var CHANNEL_INCOMING = exports.CHANNEL_INCOMING = 'event.channel_incoming';

/**
 * @type {string}
 */
var CHANNEL_OUTGOING = exports.CHANNEL_OUTGOING = 'event.channel_outgoing';

/**
 * @enum
 * @type {{CHANNEL_INCOMING: string, CHANNEL_INTERNAL: string, CHANNEL_OUTGOING: string}}
 */
var channels = exports.channels = {
  CHANNEL_INCOMING: CHANNEL_INCOMING,
  CHANNEL_INTERNAL: CHANNEL_INTERNAL,
  CHANNEL_OUTGOING: CHANNEL_OUTGOING
};

/**
 * @type {string}
 */
var INVOCATION_FIREANDFORGET = exports.INVOCATION_FIREANDFORGET = 'event.invocation_fireandforget';

/**
 * @type {string}
 */
var INVOCATION_REQUESTRESPONSE = exports.INVOCATION_REQUESTRESPONSE = 'event.invocation_requestresponse';

/**
 * @enum
 * @type {{INVOCATION_FIREANDFORGET: string, INVOCATION_REQUESTRESPONSE: string}}
 */
var invocations = exports.invocations = {
  INVOCATION_FIREANDFORGET: INVOCATION_FIREANDFORGET,
  INVOCATION_REQUESTRESPONSE: INVOCATION_REQUESTRESPONSE
};

/**
 * Builds an event map from an object literal description where keys are event keys and values are event names
 *
 * @method
 *
 * @param {Object} events
 * @param {Object} eventProps
 * @return {EventMap}
 */
var buildMap = exports.buildMap = function buildMap(events, eventProps) {
  var names = (0, _keys2.default)(events).map(function (key) {
    return events[key];
  });

  var map = {};
  (0, _keys2.default)(events).forEach(function (key) {
    var value = events[key];
    map[key] = value;
    map[value] = key;
  });

  return new _EventMap.EventMap({ map: map, names: names, props: eventProps });
};

/**
 * @method
 *
 * @param {String} eventName
 * @param {Object} propsPattern
 * @param {EventMap} eventMap
 * @return {boolean}
 */
var matchEvent = exports.matchEvent = function matchEvent(eventName, propsPattern, eventMap) {
  if (!eventMap.isEventName(eventName)) {
    return false;
  }

  if (!propsPattern) {
    return true;
  }

  var actualProps = eventMap.getEventProps(eventName);
  return matchProps(actualProps, propsPattern);
};

/**
 * @param {{}} props
 * @return {boolean}
 */
var isInvocation = exports.isInvocation = function isInvocation(props) {
  if (!props || (typeof props === 'undefined' ? 'undefined' : (0, _typeof3.default)(props)) !== 'object') {
    return false;
  }

  var event = props.event;

  if (typeof event !== 'string') {
    return false;
  }

  var invocationType = props.invocationType;

  return -1 !== (0, _keys2.default)(invocations).reduce(function (acc, key) {
    return acc.concat(invocations[key]);
  }, []).indexOf(invocationType);
};

/**
 *
 * @param {*} actualProps
 * @param {String} channelType
 * @param {String} invocationType
 * @return {boolean}
 */
var matchProps = function matchProps(actualProps, _ref) {
  var channelType = _ref.channelType,
      invocationType = _ref.invocationType;

  if (!actualProps) {
    return !channelType && !invocationType;
  }

  if (!channelType && !invocationType) {
    return false;
  }
  if (channelType && actualProps.channelType !== channelType) {
    return false;
  }
  if (invocationType && actualProps.invocationType !== invocationType) {
    return false;
  }

  return true;
};

/**
 * @class Event
 */

var Event = function () {
  /**
   * @param {String} name event name
   * @param {Array} args event arguments
   */
  function Event(_ref2) {
    var name = _ref2.name,
        args = _ref2.args;
    (0, _classCallCheck3.default)(this, Event);

    this.props = { name: name, enabled: true, args: args };
  }

  /**
   * @readonly
   * @type {Array}
   */


  (0, _createClass3.default)(Event, [{
    key: 'args',
    get: function get() {
      return JSON.parse((0, _stringify2.default)(this.props.args));
    }

    /**
     * @param {boolean} flag
     */

  }, {
    key: 'enabled',
    set: function set(flag) {
      this.props.enabled = flag;
    }

    /**
     * @public
     * @type {boolean}
     */
    ,
    get: function get() {
      return this.props.enabled;
    }
  }]);
  return Event;
}();

exports.Event = Event;

/***/ }),

/***/ "ke43":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__("shmw")
  , core        = __webpack_require__("Y4Oj")
  , dP          = __webpack_require__("PR1c")
  , DESCRIPTORS = __webpack_require__("NLIV")
  , SPECIES     = __webpack_require__("XGUc")('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),

/***/ "mexi":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),

/***/ "mkZG":
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ "msdQ":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("ngM3");
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),

/***/ "mwgz":
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__("RIJu")
  , call        = __webpack_require__("msdQ")
  , isArrayIter = __webpack_require__("Kf0p")
  , anObject    = __webpack_require__("ngM3")
  , toLength    = __webpack_require__("OpEi")
  , getIterFn   = __webpack_require__("i2QE")
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),

/***/ "nadw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventName = exports.eventNames = exports.props = exports.EVENT_SUBSCRIBE = exports.EVENT_RESET_SIZE = exports.EVENT_ICON_CHANGED = exports.EVENT_TITLE_CHANGED = exports.EVENT_UNLOAD = exports.EVENT_REFRESH = exports.EVENT_MOUNT = undefined;

var _keys = __webpack_require__("q+0m");

var _keys2 = _interopRequireDefault(_keys);

var _Event = __webpack_require__("kJI2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @type {string}
 */
var EVENT_MOUNT = exports.EVENT_MOUNT = 'app.mount';

/**
 * @type {string}
 */
/**
 * @module Core/AppEvents
 */

var EVENT_REFRESH = exports.EVENT_REFRESH = 'app.refresh';

/**
 * @type {string}
 */
var EVENT_UNLOAD = exports.EVENT_UNLOAD = 'app.unload';

/**
 * @type {string}
 */
var EVENT_TITLE_CHANGED = exports.EVENT_TITLE_CHANGED = 'app.title_changed';

/**
 * @type {string}
 */
var EVENT_ICON_CHANGED = exports.EVENT_ICON_CHANGED = 'app.icon_changed';

/**
 * @type {string}
 */
var EVENT_RESET_SIZE = exports.EVENT_RESET_SIZE = 'app.reset_size';

/**
 * @type {string}
 */
var EVENT_SUBSCRIBE = exports.EVENT_SUBSCRIBE = 'app.subscribe_to_event';

var events = {
  EVENT_MOUNT: EVENT_MOUNT,

  EVENT_REFRESH: EVENT_REFRESH,
  EVENT_UNLOAD: EVENT_UNLOAD,

  EVENT_RESET_SIZE: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },
  EVENT_SUBSCRIBE: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_FIREANDFORGET }
};
/**
 * @enum
 * @readonly
 * @type {{EVENT_MOUNT: string, EVENT_REFRESH: string, EVENT_UNLOAD: string, EVENT_RESET_SIZE: {channelType: string, invocationType: string}, EVENT_SUBSCRIBE: {channelType: string, invocationType: string}}}
 */
var props = exports.props = events;

/**
 * @readonly
 * @type {Array<string>}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 *
 * @param {string} name
 * @return boolean
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};

/***/ }),

/***/ "ngM3":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("9Ob+");
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),

/***/ "nl26":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ "o91r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerEventHandlers = undefined;

var _Events = __webpack_require__("uLjq");

var Events = _interopRequireWildcard(_Events);

var _EventHandler = __webpack_require__("zx9m");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @method
 * @param {WidgetWindowBridge} windowBridge
 * @param {App} app
 */
/**
 * WebAPI/EventHandlers module.
 * @module WebAPI/EventHandlers
 */

var registerEventHandlers = exports.registerEventHandlers = function registerEventHandlers(windowBridge, app) {
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, Events.EVENT_WEBAPI_REQUEST_DESKPRO, Events.props.EVENT_WEBAPI_REQUEST_DESKPRO);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, Events.EVENT_WEBAPI_REQUEST_FETCH, Events.props.EVENT_WEBAPI_REQUEST_FETCH);
};

/***/ }),

/***/ "oIaV":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("Uc+M")
  , gOPN      = __webpack_require__("4VVB").f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "oRMJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeskproAPIClient = exports.create = undefined;

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__("ED1s");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("Dfz+");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _Events = __webpack_require__("uLjq");

var Events = _interopRequireWildcard(_Events);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {EventDispatcher} eventDispatcher
 * @return {DeskproAPIClient}
 */
var create = exports.create = function create(eventDispatcher) {
  return new DeskproAPIClient(eventDispatcher);
};

/**
 * @class
 */

var DeskproAPIClient = exports.DeskproAPIClient = function () {
  /**
   * @param {EventDispatcher} eventDispatcher
   */
  function DeskproAPIClient(eventDispatcher) {
    var _this = this;

    (0, _classCallCheck3.default)(this, DeskproAPIClient);

    this['delete'] = function (path) {
      return _this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_DESKPRO, { method: 'delete', path: path });
    };

    this.props = { eventDispatcher: eventDispatcher };
  }

  /**
   * @method
   *
   * @param {string} url
   * @param {object} init
   *
   * @return {Promise}
   */


  (0, _createClass3.default)(DeskproAPIClient, [{
    key: 'fetch',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(url, init) {
        var request;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                request = { url: url, init: init };
                return _context.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_FETCH, request));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetch(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: 'fetchCORS',


    /**
     * @method
     *
     * @param {string} url
     * @param {object} init
     *
     * @return {Promise}
     */
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(url, init) {
        var corsInit;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                corsInit = (0, _extends3.default)({}, init, { mode: 'cors' });
                return _context2.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: corsInit }));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchCORS(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return fetchCORS;
    }()
  }, {
    key: 'get',


    /**
     * @param {string} path
     * @return {Promise}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(path) {
        var request;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                request = { method: 'get', path: path };
                return _context3.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_DESKPRO, request));

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function get(_x5) {
        return _ref3.apply(this, arguments);
      }

      return get;
    }()

    /**
     * @method
     *
     * @param {string} path
     * @param {object} body
     *
     * @return {Promise}
     */

  }, {
    key: 'post',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(path, body) {
        var request;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                request = { method: 'post', path: path, body: body };
                return _context4.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_DESKPRO, request));

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function post(_x6, _x7) {
        return _ref4.apply(this, arguments);
      }

      return post;
    }()

    /**
     * @method
     *
     * @param {string} path
     * @param {Object} body
     *
     * @return {Promise}
     */

  }, {
    key: 'put',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(path, body) {
        var request;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                request = { method: 'put', path: path, body: body };
                return _context5.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_DESKPRO, request));

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function put(_x8, _x9) {
        return _ref5.apply(this, arguments);
      }

      return put;
    }()

    /**
     * @method
     *
     * @param {String} path
     * @return {Promise}
     */

  }, {
    key: 'del',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(path) {
        var request;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                request = { method: 'delete', path: path };
                return _context6.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_DESKPRO, request));

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function del(_x10) {
        return _ref6.apply(this, arguments);
      }

      return del;
    }()

    /**
     * @method
     *
     * @param {string} path
     *
     * @return {Promise}
     */

  }]);
  return DeskproAPIClient;
}();

/***/ }),

/***/ "ofgR":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),

/***/ "ok1y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchEvent = exports.eventMap = exports.props = exports.events = exports.EVENT_DESKPROWINDOW_INSERT_MARKUP = exports.EVENT_DESKPROWINDOW_SHOW_NOTIFICATION = undefined;

var _Event = __webpack_require__("kJI2");

/**
 * @readonly
 * @type {string}
 */
var EVENT_DESKPROWINDOW_SHOW_NOTIFICATION = exports.EVENT_DESKPROWINDOW_SHOW_NOTIFICATION = 'deskpro_window.show_notification';

/**
 * @readonly
 * @type {string}
 */
/**
 * @module DeskproWindow/Events
 */

var EVENT_DESKPROWINDOW_INSERT_MARKUP = exports.EVENT_DESKPROWINDOW_INSERT_MARKUP = 'deskpro_window.insert_markup';

/**
 * @readonly
 * @enum
 *
 * @type {{EVENT_DESKPROWINDOW_INSERT_MARKUP: string, EVENT_DESKPROWINDOW_SHOW_NOTIFICATION: string}}
 */
var events = exports.events = {
  EVENT_DESKPROWINDOW_INSERT_MARKUP: EVENT_DESKPROWINDOW_INSERT_MARKUP,
  EVENT_DESKPROWINDOW_SHOW_NOTIFICATION: EVENT_DESKPROWINDOW_SHOW_NOTIFICATION
};

/**
 * @readonly
 * @enum
 *
 * @type {{EVENT_DESKPROWINDOW_INSERT_MARKUP: {channelType: string, invocationType: string}, EVENT_DESKPROWINDOW_SHOW_NOTIFICATION: {channelType: string, invocationType: string}}}
 */
var props = exports.props = {
  EVENT_DESKPROWINDOW_INSERT_MARKUP: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_FIREANDFORGET },
  EVENT_DESKPROWINDOW_SHOW_NOTIFICATION: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_FIREANDFORGET }
};

/**
 * @type {EventMap}
 */
var eventMap = exports.eventMap = (0, _Event.buildMap)(events, props);

/**
 * @method
 *
 * @param {string} eventName
 * @param {string} channelType
 * @param {string} invocationType
 * @return {boolean}
 */
var matchEvent = exports.matchEvent = function matchEvent(eventName, _ref) {
  var channelType = _ref.channelType,
      invocationType = _ref.invocationType;
  return (0, _Event.matchEvent)(eventName, { channelType: channelType, invocationType: invocationType }, eventMap);
};

/***/ }),

/***/ "p+xz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchEvent = exports.eventMap = exports.props = exports.events = exports.EVENT_TICKET_REPLY = exports.EVENT_BEFORE_MESSAGE_ADDED = exports.EVENT_MESSAGE_ADDED = undefined;

var _Event = __webpack_require__("kJI2");

/**
 * @type {string}
 */
var EVENT_MESSAGE_ADDED = exports.EVENT_MESSAGE_ADDED = 'context.ticket.message_added';

/**
 * @type {string}
 */
/**
 * @module Context/TicketEvents
 */

var EVENT_BEFORE_MESSAGE_ADDED = exports.EVENT_BEFORE_MESSAGE_ADDED = 'context.ticket.before_message_added';

/**
 * @type {string}
 */
var EVENT_TICKET_REPLY = exports.EVENT_TICKET_REPLY = 'context.ticket.reply';

/**
 * @enum
 * @type {{EVENT_MESSAGE_ADDED: string, EVENT_BEFORE_MESSAGE_ADDED: string, EVENT_TICKET_REPLY: string}}
 */
var events = exports.events = {
  EVENT_MESSAGE_ADDED: EVENT_MESSAGE_ADDED,
  EVENT_BEFORE_MESSAGE_ADDED: EVENT_BEFORE_MESSAGE_ADDED,
  EVENT_TICKET_REPLY: EVENT_TICKET_REPLY
};

/**
 * @enum
 * @type {{EVENT_TICKET_REPLY: {channelType, invocationType}}}
 */
var props = exports.props = {
  EVENT_TICKET_REPLY: { channelType: _Event.CHANNEL_INCOMING, invocationType: _Event.INVOCATION_REQUESTRESPONSE }
};

/**
 * @constant
 * @type {EventMap}
 */
var eventMap = exports.eventMap = (0, _Event.buildMap)(events, props);

/**
 * @method
 *
 * @param {String} eventName
 * @param {Object} propsPattern
 * @return {boolean}
 */
var matchEvent = exports.matchEvent = function matchEvent(eventName, propsPattern) {
  return (0, _Event.matchEvent)(eventName, propsPattern, eventMap);
};

/***/ }),

/***/ "p1oW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var getState = options.stateHandler.getState;

    /**
     * Tells if the element has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is detectable or not.
     */
    function isDetectable(element) {
        var state = getState(element);
        return state && !!state.isDetectable;
    }

    /**
     * Marks the element that it has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to mark.
     */
    function markAsDetectable(element) {
        getState(element).isDetectable = true;
    }

    /**
     * Tells if the element is busy or not.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is busy or not.
     */
    function isBusy(element) {
        return !!getState(element).busy;
    }

    /**
     * Marks the object is busy and should not be made detectable.
     * @public
     * @param {element} element The element to mark.
     * @param {boolean} busy If the element is busy or not.
     */
    function markBusy(element, busy) {
        getState(element).busy = !!busy;
    }

    return {
        isDetectable: isDetectable,
        markAsDetectable: markAsDetectable,
        isBusy: isBusy,
        markBusy: markBusy
    };
};


/***/ }),

/***/ "pASt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerEventHandlers = undefined;

var _Events = __webpack_require__("BNfS");

var Events = _interopRequireWildcard(_Events);

var _EventHandler = __webpack_require__("zx9m");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @method
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {App} app
 */
/**
 * Security/EventHandlers module.
 * @module Security/EventHandlers
 */

var registerEventHandlers = exports.registerEventHandlers = function registerEventHandlers(windowBridge, app) {
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, Events.EVENT_SECURITY_AUTHENTICATE_OAUTH, Events.props.EVENT_SECURITY_AUTHENTICATE_OAUTH);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, Events.EVENT_SECURITY_SETTINGS_OAUTH, Events.props.EVENT_SECURITY_SETTINGS_OAUTH);
};

/***/ }),

/***/ "peDZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createContext = exports.ContextFactory = exports.TicketEvents = exports.registerTicketEventHandlers = undefined;

var _TicketEventHandlers = __webpack_require__("wFLP");

var _TicketEvents = __webpack_require__("p+xz");

var TicketEvents = _interopRequireWildcard(_TicketEvents);

var _ContextFactory = __webpack_require__("y1go");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.registerTicketEventHandlers = _TicketEventHandlers.registerEventHandlers; /**
                                                                                   * @module Context
                                                                                   */

exports.TicketEvents = TicketEvents;
exports.ContextFactory = _ContextFactory.ContextFactory;

/**
 * @method
 *
 * @param {EventDispatcher} outgoingDispatcher
 * @param {EventDispatcher} incomingDispatcher
 * @param {InstanceProps} instanceProps
 * @param {ContextProps} contextProps
 * @return {Context}
 */

var createContext = exports.createContext = function createContext(outgoingDispatcher, incomingDispatcher, instanceProps, contextProps) {
  return _ContextFactory.ContextFactory.create(outgoingDispatcher, incomingDispatcher, instanceProps, contextProps);
};

/***/ }),

/***/ "pfI3":
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),

/***/ "pmdG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetRequest = undefined;

var _getPrototypeOf = __webpack_require__("gWZE");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("cM6o");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__("w1mi");

var _inherits3 = _interopRequireDefault(_inherits2);

var _WidgetMessage2 = __webpack_require__("EL/j");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 * @extends {WidgetMessage}
 */
var WidgetRequest = exports.WidgetRequest = function (_WidgetMessage) {
  (0, _inherits3.default)(WidgetRequest, _WidgetMessage);
  (0, _createClass3.default)(WidgetRequest, null, [{
    key: 'parse',

    /**
     * @method
     *
     * @param {*} raw
     * @return {WidgetRequest}
     */
    value: function parse(raw) {
      var id = raw.id,
          widgetId = raw.widgetId,
          correlationId = raw.correlationId,
          body = raw.body;

      var parsedBody = typeof body === 'string' ? JSON.parse(body) : body;
      return new WidgetRequest({ id: id, widgetId: widgetId, correlationId: correlationId.toString(), body: parsedBody });
    }
  }]);

  /**
   * @param {String} id
   * @param {String} widgetId
   * @param {String} correlationId
   * @param {*} body
   */
  function WidgetRequest(_ref) {
    var id = _ref.id,
        widgetId = _ref.widgetId,
        correlationId = _ref.correlationId,
        body = _ref.body;
    (0, _classCallCheck3.default)(this, WidgetRequest);
    return (0, _possibleConstructorReturn3.default)(this, (WidgetRequest.__proto__ || (0, _getPrototypeOf2.default)(WidgetRequest)).call(this, { id: id, widgetId: widgetId, correlationId: correlationId, body: body }));
  }

  return WidgetRequest;
}(_WidgetMessage2.WidgetMessage);

/***/ }),

/***/ "pzZL":
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__("pfI3")('meta')
  , isObject = __webpack_require__("9Ob+")
  , has      = __webpack_require__("u9Aa")
  , setDesc  = __webpack_require__("PR1c").f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__("gM7W")(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),

/***/ "q+0m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("HCjt"), __esModule: true };

/***/ }),

/***/ "qQzT":
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),

/***/ "qvG3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerEventHandlers = exports.createDeskproApiClient = exports.WebAPIEvents = undefined;

var _DeskproAPIClient = __webpack_require__("oRMJ");

Object.defineProperty(exports, 'createDeskproApiClient', {
  enumerable: true,
  get: function get() {
    return _DeskproAPIClient.create;
  }
});

var _EventHandlers = __webpack_require__("o91r");

Object.defineProperty(exports, 'registerEventHandlers', {
  enumerable: true,
  get: function get() {
    return _EventHandlers.registerEventHandlers;
  }
});

var _Events = __webpack_require__("uLjq");

var WebAPIEvents = _interopRequireWildcard(_Events);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.WebAPIEvents = WebAPIEvents; /**
                                      * UI module.
                                      * @module WebAPI
                                      */

/***/ }),

/***/ "rNJP":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__("u9Aa")
  , toObject    = __webpack_require__("eZLJ")
  , IE_PROTO    = __webpack_require__("JYxG")('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),

/***/ "rR7O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventName = exports.eventNames = exports.props = exports.EVENT_WINDOW_RESIZE = exports.EVENT_WINDOW_MOUSEEVENT = undefined;

var _keys = __webpack_require__("q+0m");

var _keys2 = _interopRequireDefault(_keys);

var _Event = __webpack_require__("kJI2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @readonly
 * @type {string}
 */
var EVENT_WINDOW_MOUSEEVENT = exports.EVENT_WINDOW_MOUSEEVENT = 'window.mouseevent';

/**
 * @todo Should be named 'window.window-resize' when this event will be handled by the container
 * @readonly
 * @type {string}
 */
/**
 * @module Core/ContextEvents
 */

var EVENT_WINDOW_RESIZE = exports.EVENT_WINDOW_RESIZE = 'app.reset_size';

var events = {

  EVENT_WINDOW_MOUSEEVENT: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_FIREANDFORGET },

  EVENT_WINDOW_RESIZE: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_FIREANDFORGET }

};

/**
 * @enum
 * @readonly
 * @type {{EVENT_WINDOW_MOUSEEVENT: {channelType: string, invocationType: string}, EVENT_WINDOW_RESIZE: {channelType: string, invocationType: string}}}
 */
var props = exports.props = events;

/**
 * @readonly
 * @type {Array<string>}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 *
 * @param {string} name
 * @return {boolean}
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};

/***/ }),

/***/ "rZLs":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("skuU");
__webpack_require__("IlDj");
module.exports = __webpack_require__("ybqV");

/***/ }),

/***/ "rq3c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("shmw").document && document.documentElement;

/***/ }),

/***/ "seUs":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("zJ0u");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("v4eW")))

/***/ }),

/***/ "shmw":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),

/***/ "siAl":
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__("PR1c")
  , createDesc = __webpack_require__("/Aoj");
module.exports = __webpack_require__("NLIV") ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),

/***/ "skuU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Wd3d");
var global        = __webpack_require__("shmw")
  , hide          = __webpack_require__("siAl")
  , Iterators     = __webpack_require__("50hw")
  , TO_STRING_TAG = __webpack_require__("XGUc")('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),

/***/ "t2//":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.UIConstants = exports.UIEvents = undefined;

var _Events = __webpack_require__("zKo7");

var UIEvents = _interopRequireWildcard(_Events);

var _Constants = __webpack_require__("tMk4");

var UIConstants = _interopRequireWildcard(_Constants);

var _UIFacade = __webpack_require__("R5tu");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.UIEvents = UIEvents; /**
                              * UI module.
                              * @module UI
                              */

exports.UIConstants = UIConstants;


/**
 * @method
 *
 * @param {EventDispatcher} internalEventDispatcher
 * @return {UIFacade}
 */
var create = exports.create = function create(internalEventDispatcher) {
  return new _UIFacade.UIFacade(internalEventDispatcher);
};

/***/ }),

/***/ "tMk4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @module UI/Constants
 */

/**
 * @readonly
 * @type {string}
 */
var VISIBILITY_HIDDEN = exports.VISIBILITY_HIDDEN = 'hidden';

/**
 * @readonly
 * @type {string}
 */
var VISIBILITY_VISIBLE = exports.VISIBILITY_VISIBLE = 'visible';

/**
 * @readonly
 * @type {string}
 */
var STATE_READY = exports.STATE_READY = 'ready';

/**
 * @readonly
 * @type {string}
 */
var STATE_ERROR = exports.STATE_ERROR = 'visible';

/**
 * @readonly
 * @type {string}
 */
var STATE_LOADING = exports.STATE_LOADING = 'loading';

/**
 * @readonly
 * @type {string}
 */
var STATE_EMPTY = exports.STATE_EMPTY = 'empty';

/**
 * @readonly
 * @type {string}
 */
var STATE_PARTIAL = exports.STATE_PARTIAL = 'partial';

/**
 * @readonly
 * @type {string}
 */
var DISPLAY_COLLAPSED = exports.DISPLAY_COLLAPSED = 'collapsed';

/**
 * @readonly
 * @type {string}
 */
var DISPLAY_EXPANDED = exports.DISPLAY_EXPANDED = 'expanded';

/***/ }),

/***/ "tp8E":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("Uc+M")
  , toLength  = __webpack_require__("OpEi")
  , toIndex   = __webpack_require__("CDue");
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),

/***/ "u0i7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetFactories = exports.WidgetResponse = exports.WidgetRequest = exports.WidgetWindowBridge = undefined;

var _WidgetWindowBridge = __webpack_require__("4x0R");

var _WidgetRequest = __webpack_require__("pmdG");

var _WidgetResponse = __webpack_require__("i81l");

var _WidgetFactories = __webpack_require__("HgED");

/**
 * @module Widget
 */

exports.WidgetWindowBridge = _WidgetWindowBridge.WidgetWindowBridge;
exports.WidgetRequest = _WidgetRequest.WidgetRequest;
exports.WidgetResponse = _WidgetResponse.WidgetResponse;
exports.WidgetFactories = _WidgetFactories.WidgetFactories;

/***/ }),

/***/ "u2hb":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),

/***/ "u9Aa":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),

/***/ "uLjq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventName = exports.eventNames = exports.props = exports.EVENT_WEBAPI_REQUEST_FETCH = exports.EVENT_WEBAPI_REQUEST_DESKPRO = undefined;

var _keys = __webpack_require__("q+0m");

var _keys2 = _interopRequireDefault(_keys);

var _Event = __webpack_require__("kJI2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_WEBAPI_REQUEST_DESKPRO = exports.EVENT_WEBAPI_REQUEST_DESKPRO = 'webapi.request.deskpro'; /**
                                                                                                     * WebAPI module.
                                                                                                     * @module WebAPI/Events
                                                                                                     */

var EVENT_WEBAPI_REQUEST_FETCH = exports.EVENT_WEBAPI_REQUEST_FETCH = 'webapi.request.fetch';

var events = {
  EVENT_WEBAPI_REQUEST_DESKPRO: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },
  EVENT_WEBAPI_REQUEST_FETCH: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE }
};
/**
 * @enum
 * @readonly
 *
 * @type {{EVENT_WEBAPI_REQUEST_DESKPRO: {channelType, invocationType}, EVENT_WEBAPI_REQUEST_FETCH: {channelType, invocationType}}}
 */
var props = exports.props = events;

/**
 * @readonly
 * @type {Array}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 * @param {String} name
 * @return {boolean}
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};

/***/ }),

/***/ "uk2G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var forEach                 = __webpack_require__("dbB1").forEach;
var elementUtilsMaker       = __webpack_require__("p1oW");
var listenerHandlerMaker    = __webpack_require__("dUh9");
var idGeneratorMaker        = __webpack_require__("CGCf");
var idHandlerMaker          = __webpack_require__("601f");
var reporterMaker           = __webpack_require__("Og1S");
var browserDetector         = __webpack_require__("Saiw");
var batchProcessorMaker     = __webpack_require__("GpqH");
var stateHandler            = __webpack_require__("+1cx");

//Detection strategies.
var objectStrategyMaker     = __webpack_require__("SKY5");
var scrollStrategyMaker     = __webpack_require__("S1QW");

function isCollection(obj) {
    return Array.isArray(obj) || obj.length !== undefined;
}

function toArray(collection) {
    if (!Array.isArray(collection)) {
        var array = [];
        forEach(collection, function (obj) {
            array.push(obj);
        });
        return array;
    } else {
        return collection;
    }
}

function isElement(obj) {
    return obj && obj.nodeType === 1;
}

/**
 * @typedef idHandler
 * @type {object}
 * @property {function} get Gets the resize detector id of the element.
 * @property {function} set Generate and sets the resize detector id of the element.
 */

/**
 * @typedef Options
 * @type {object}
 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
                                    If not provided, a default id handler will be used.
 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
                                    If not provided, a default id handler will be used.
                                    If set to false, then nothing will be reported.
 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
 */

/**
 * Creates an element resize detector instance.
 * @public
 * @param {Options?} options Optional global options object that will decide how this instance will work.
 */
module.exports = function(options) {
    options = options || {};

    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var idHandler;

    if (options.idHandler) {
        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
        idHandler = {
            get: function (element) { return options.idHandler.get(element, true); },
            set: options.idHandler.set
        };
    } else {
        var idGenerator = idGeneratorMaker();
        var defaultIdHandler = idHandlerMaker({
            idGenerator: idGenerator,
            stateHandler: stateHandler
        });
        idHandler = defaultIdHandler;
    }

    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var reporter = options.reporter;

    if(!reporter) {
        //If options.reporter is false, then the reporter should be quiet.
        var quiet = reporter === false;
        reporter = reporterMaker(quiet);
    }

    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));

    //Options to be used as default for the listenTo function.
    var globalOptions = {};
    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
    globalOptions.debug         = !!getOption(options, "debug", false);

    var eventListenerHandler    = listenerHandlerMaker(idHandler);
    var elementUtils            = elementUtilsMaker({
        stateHandler: stateHandler
    });

    //The detection strategy to be used.
    var detectionStrategy;
    var desiredStrategy = getOption(options, "strategy", "object");
    var strategyOptions = {
        reporter: reporter,
        batchProcessor: batchProcessor,
        stateHandler: stateHandler,
        idHandler: idHandler
    };

    if(desiredStrategy === "scroll") {
        if (browserDetector.isLegacyOpera()) {
            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
            desiredStrategy = "object";
        } else if (browserDetector.isIE(9)) {
            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
            desiredStrategy = "object";
        }
    }

    if(desiredStrategy === "scroll") {
        detectionStrategy = scrollStrategyMaker(strategyOptions);
    } else if(desiredStrategy === "object") {
        detectionStrategy = objectStrategyMaker(strategyOptions);
    } else {
        throw new Error("Invalid strategy name: " + desiredStrategy);
    }

    //Calls can be made to listenTo with elements that are still being installed.
    //Also, same elements can occur in the elements list in the listenTo function.
    //With this map, the ready callbacks can be synchronized between the calls
    //so that the ready callback can always be called when an element is ready - even if
    //it wasn't installed from the function itself.
    var onReadyCallbacks = {};

    /**
     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
     * @public
     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
     * @param {function} listener The callback to be executed for each resize event for each element.
     */
    function listenTo(options, elements, listener) {
        function onResizeCallback(element) {
            var listeners = eventListenerHandler.get(element);
            forEach(listeners, function callListenerProxy(listener) {
                listener(element);
            });
        }

        function addListener(callOnAdd, element, listener) {
            eventListenerHandler.add(element, listener);

            if(callOnAdd) {
                listener(element);
            }
        }

        //Options object may be omitted.
        if(!listener) {
            listener = elements;
            elements = options;
            options = {};
        }

        if(!elements) {
            throw new Error("At least one element required.");
        }

        if(!listener) {
            throw new Error("Listener required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        var elementsReady = 0;

        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
        var onReadyCallback = getOption(options, "onReady", function noop() {});
        var debug = getOption(options, "debug", globalOptions.debug);

        forEach(elements, function attachListenerToElement(element) {
            if (!stateHandler.getState(element)) {
                stateHandler.initState(element);
                idHandler.set(element);
            }

            var id = idHandler.get(element);

            debug && reporter.log("Attaching listener to element", id, element);

            if(!elementUtils.isDetectable(element)) {
                debug && reporter.log(id, "Not detectable.");
                if(elementUtils.isBusy(element)) {
                    debug && reporter.log(id, "System busy making it detectable");

                    //The element is being prepared to be detectable. Do not make it detectable.
                    //Just add the listener, because the element will soon be detectable.
                    addListener(callOnAdd, element, listener);
                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
                    onReadyCallbacks[id].push(function onReady() {
                        elementsReady++;

                        if(elementsReady === elements.length) {
                            onReadyCallback();
                        }
                    });
                    return;
                }

                debug && reporter.log(id, "Making detectable...");
                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
                elementUtils.markBusy(element, true);
                return detectionStrategy.makeDetectable({ debug: debug }, element, function onElementDetectable(element) {
                    debug && reporter.log(id, "onElementDetectable");

                    if (stateHandler.getState(element)) {
                        elementUtils.markAsDetectable(element);
                        elementUtils.markBusy(element, false);
                        detectionStrategy.addListener(element, onResizeCallback);
                        addListener(callOnAdd, element, listener);

                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
                        // so that a resize event may be emitted.
                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
                        var state = stateHandler.getState(element);
                        if (state && state.startSize) {
                            var width = element.offsetWidth;
                            var height = element.offsetHeight;
                            if (state.startSize.width !== width || state.startSize.height !== height) {
                                onResizeCallback(element);
                            }
                        }

                        if(onReadyCallbacks[id]) {
                            forEach(onReadyCallbacks[id], function(callback) {
                                callback();
                            });
                        }
                    } else {
                        // The element has been unisntalled before being detectable.
                        debug && reporter.log(id, "Element uninstalled before being detectable.");
                    }

                    delete onReadyCallbacks[id];

                    elementsReady++;
                    if(elementsReady === elements.length) {
                        onReadyCallback();
                    }
                });
            }

            debug && reporter.log(id, "Already detecable, adding listener.");

            //The element has been prepared to be detectable and is ready to be listened to.
            addListener(callOnAdd, element, listener);
            elementsReady++;
        });

        if(elementsReady === elements.length) {
            onReadyCallback();
        }
    }

    function uninstall(elements) {
        if(!elements) {
            return reporter.error("At least one element is required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        forEach(elements, function (element) {
            eventListenerHandler.removeAllListeners(element);
            detectionStrategy.uninstall(element);
            stateHandler.cleanState(element);
        });
    }

    return {
        listenTo: listenTo,
        removeListener: eventListenerHandler.removeListener,
        removeAllListeners: eventListenerHandler.removeAllListeners,
        uninstall: uninstall
    };
};

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),

/***/ "v+o1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Context = undefined;

var _regenerator = __webpack_require__("ED1s");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("Dfz+");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("iy81");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ContextEvents = __webpack_require__("GKfY");

var ContextEvents = _interopRequireWildcard(_ContextEvents);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 */
var Context = exports.Context = function () {
  /**
   * @param {EventDispatcher} outgoingDispatcher
   * @param {EventDispatcher} incomingDispatcher
   * @param {String} type
   * @param {String} entityId
   * @param {String} locationId
   * @param rest
   */
  function Context(_ref) {
    var outgoingDispatcher = _ref.outgoingDispatcher,
        incomingDispatcher = _ref.incomingDispatcher,
        type = _ref.type,
        entityId = _ref.entityId,
        locationId = _ref.locationId,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['outgoingDispatcher', 'incomingDispatcher', 'type', 'entityId', 'locationId']);
    (0, _classCallCheck3.default)(this, Context);

    this.props = (0, _extends3.default)({ outgoingDispatcher: outgoingDispatcher, incomingDispatcher: incomingDispatcher, type: type, entityId: entityId, locationId: locationId }, rest);
  }

  /**
   * @public
   * @return {CustomFieldsClient}
   */


  (0, _createClass3.default)(Context, [{
    key: 'hasProperty',


    /**
     * @method
     *
     * @param {String} propName
     * @return {boolean}
     */
    value: function hasProperty(propName) {
      return this.props.hasOwnProperty(propName);
    }
  }, {
    key: 'getProperty',


    /**
     * @method
     *
     * @param {String} propName
     * @return {*}
     */
    value: function getProperty(propName) {
      if (this.props.hasOwnProperty(propName)) {
        return this.props[propName];
      }

      return undefined;
    }
  }, {
    key: 'getMe',


    /**
     * @public
     * @method
     * @async
     * @return {Promise}
     */
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.props.outgoingDispatcher.emitAsync(ContextEvents.EVENT_ME_GET));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMe() {
        return _ref2.apply(this, arguments);
      }

      return getMe;
    }()

    /**
     * @method
     *
     * @return {Object}
     */

  }, {
    key: 'toJS',
    value: function toJS() {
      return (0, _extends3.default)({}, this.props);
    }
  }, {
    key: 'customFields',
    get: function get() {
      throw new Error('The current context does not support custom fields');
    }

    /**
     * @public
     * @return {String}
     */

  }, {
    key: 'type',
    get: function get() {
      return this.props.type.toString();
    }

    /**
     * @public
     * @return {String}
     */

  }, {
    key: 'entityId',
    get: function get() {
      return this.props.entityId.toString();
    }

    /**
     * @public
     * @return {String}
     */

  }, {
    key: 'locationId',
    get: function get() {
      return this.props.locationId.toString();
    }
  }]);
  return Context;
}();

/***/ }),

/***/ "v3IQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeskproWindowFacade = exports.createDeskproWindowFacade = exports.registerEventHandlers = exports.DeskproWindowEvents = undefined;

var _EventHandlers = __webpack_require__("b9e4");

Object.defineProperty(exports, 'registerEventHandlers', {
  enumerable: true,
  get: function get() {
    return _EventHandlers.registerEventHandlers;
  }
});

var _DeskproWindowFacade = __webpack_require__("4WzZ");

Object.defineProperty(exports, 'createDeskproWindowFacade', {
  enumerable: true,
  get: function get() {
    return _DeskproWindowFacade.create;
  }
});
Object.defineProperty(exports, 'DeskproWindowFacade', {
  enumerable: true,
  get: function get() {
    return _DeskproWindowFacade.DeskproWindowFacade;
  }
});

var _Events = __webpack_require__("ok1y");

var DeskproWindowEvents = _interopRequireWildcard(_Events);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.DeskproWindowEvents = DeskproWindowEvents; /**
                                                    * @module DeskproWindow
                                                    */

/***/ }),

/***/ "v4eW":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "vSv8":
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),

/***/ "vWGD":
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__("RIJu")
  , invoke             = __webpack_require__("HFsX")
  , html               = __webpack_require__("rq3c")
  , cel                = __webpack_require__("ZVhn")
  , global             = __webpack_require__("shmw")
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__("nl26")(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),

/***/ "vbpo":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("jD66")('observable');

/***/ }),

/***/ "w1mi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("ymDj");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("0Sp3");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("KIIz");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "wFLP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerEventHandlers = undefined;

var _EventHandler = __webpack_require__("zx9m");

var _TicketEvents = __webpack_require__("p+xz");

var Events = _interopRequireWildcard(_TicketEvents);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @method
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {App} app
 */
/**
 * @module Context/TicketEventHandlers
 */

var registerEventHandlers = exports.registerEventHandlers = function registerEventHandlers(windowBridge, app) {
  (0, _EventHandler.handleIncomingEvent)(windowBridge, app, Events.EVENT_TICKET_REPLY, Events.props.EVENT_TICKET_REPLY);
};

/***/ }),

/***/ "xs8S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__("U4Vh");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__("XGVB");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ "y1go":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextFactory = undefined;

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = __webpack_require__("XGVB");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _Context = __webpack_require__("v+o1");

var _TicketContext = __webpack_require__("Q0K3");

var _PersonContext = __webpack_require__("b7Yt");

var _OrganizationContext = __webpack_require__("GKUm");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @readonly
 * @type {Array.<function>}
 */
var factories = [_TicketContext.TicketContext.tryAndCreate, _PersonContext.PersonContext.tryAndCreate, _OrganizationContext.OrganizationContext.tryAndCreate];

var ContextFactory = exports.ContextFactory = function () {
  function ContextFactory() {
    (0, _classCallCheck3.default)(this, ContextFactory);
  }

  (0, _createClass3.default)(ContextFactory, null, [{
    key: 'create',


    /**
     * @method
     *
     * @param {EventDispatcher} outgoingDispatcher
     * @param {EventDispatcher} incomingDispatcher
     * @param {InstanceProps} instanceProps
     * @param {ContextProps} contextProps
     * @return {Context}
     */
    value: function create(outgoingDispatcher, incomingDispatcher, instanceProps, contextProps) {
      var props = { outgoingDispatcher: outgoingDispatcher, incomingDispatcher: incomingDispatcher, instanceProps: instanceProps, contextProps: contextProps };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(factories), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var factory = _step.value;

          var context = factory(props);
          if (context) {
            return context;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return ContextFactory.createDefaultContext(outgoingDispatcher, incomingDispatcher, instanceProps, contextProps);
    }

    /**
     * @param {EventDispatcher} outgoingDispatcher
     * @param {EventDispatcher} incomingDispatcher
     * @param {InstanceProps} instanceProps
     * @param {ContextProps} contextProps
     * @return {Context}
     */

  }, {
    key: 'createDefaultContext',
    value: function createDefaultContext(outgoingDispatcher, incomingDispatcher, instanceProps, contextProps) {
      var props = (0, _extends3.default)({ outgoingDispatcher: outgoingDispatcher, incomingDispatcher: incomingDispatcher }, contextProps.toJS(), { type: contextProps.contextType });
      return new _Context.Context(props);
    }
  }, {
    key: 'contextTypes',
    get: function get() {
      return [_TicketContext.TicketContext.TYPE, _PersonContext.PersonContext.TYPE, _OrganizationContext.OrganizationContext.TYPE];
    }
  }]);
  return ContextFactory;
}();

/***/ }),

/***/ "yMXy":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("nl26")
  , TAG = __webpack_require__("XGUc")('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),

/***/ "yNLq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStorageAPIClient = exports.StorageApiFacade = exports.registerEventHandlers = exports.StorageEvents = undefined;

var _EventHandlers = __webpack_require__("UQxd");

Object.defineProperty(exports, 'registerEventHandlers', {
  enumerable: true,
  get: function get() {
    return _EventHandlers.registerEventHandlers;
  }
});

var _StorageApiFacade = __webpack_require__("zCgN");

Object.defineProperty(exports, 'StorageApiFacade', {
  enumerable: true,
  get: function get() {
    return _StorageApiFacade.StorageApiFacade;
  }
});

var _Events = __webpack_require__("QIOw");

var StorageEvents = _interopRequireWildcard(_Events);

var _FetchStorageAdapter = __webpack_require__("VCyk");

var _LocalStorageAdapter = __webpack_require__("d64R");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Storage module.
 * @module Storage
 */

exports.StorageEvents = StorageEvents;


var storageAdapterProps = function storageAdapterProps(instanceProps, contextProps) {
  return {
    appId: instanceProps.appId,
    instanceId: instanceProps.instanceId,
    contextEntityType: contextProps.contextType,
    contextEntityId: contextProps.entityId
  };
};

/**
 * @method
 *
 * @param {EventDispatcher} outgoingDispatcher
 * @param {EventDispatcher} internalDispatcher
 * @param {InstanceProps} instanceProps
 * @param {ContextProps} contextProps
 *
 * @return {StorageApiFacade}
 */
var createStorageAPIClient = exports.createStorageAPIClient = function createStorageAPIClient(outgoingDispatcher, internalDispatcher, instanceProps, contextProps) {
  var props = storageAdapterProps(instanceProps, contextProps);
  var env = contextProps.getProperty('appsEnvironment');
  var adapter = contextProps.getProperty('appsStorageadapter');

  var storageAdapter = new _FetchStorageAdapter.FetchStorageAdapter();
  if (env === 'development') {
    if (adapter !== 'fetch') {
      storageAdapter = _LocalStorageAdapter.LocalStorageAdapter.fromGlobals();
    }
  }

  return new _StorageApiFacade.StorageApiFacade(outgoingDispatcher, internalDispatcher, storageAdapter, props);
};

/***/ }),

/***/ "ybqV":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("ngM3")
  , get      = __webpack_require__("i2QE");
module.exports = __webpack_require__("Y4Oj").getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),

/***/ "ymDj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("Pob6"), __esModule: true };

/***/ }),

/***/ "yvFe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAppFromProps = undefined;

var _Widget = __webpack_require__("u0i7");

var _EventDispatcher = __webpack_require__("CurJ");

var _EventHandler = __webpack_require__("zx9m");

var _Storage = __webpack_require__("yNLq");

var _Security = __webpack_require__("Xjm4");

var _AppEventHandlers = __webpack_require__("cQBz");

var _ContextEventHandlers = __webpack_require__("AuTW");

var _WebAPI = __webpack_require__("qvG3");

var _Context = __webpack_require__("peDZ");

var _DeskproWindow = __webpack_require__("v3IQ");

var _App = __webpack_require__("QqyQ");

var _App2 = _interopRequireDefault(_App);

var _AppProps = __webpack_require__("/iXD");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {WidgetWindowBridge} windowBridge
 * @param {App} app
 */
/**
 * @module Core/createApp
 */

var registerAppEventListeners = function registerAppEventListeners(windowBridge, app) {
  (0, _EventHandler.handleInvokeEvents)(windowBridge, app);

  [_Security.registerEventHandlers, _Storage.registerEventHandlers, _AppEventHandlers.registerEventHandlers, _ContextEventHandlers.registerEventHandlers, _WebAPI.registerEventHandlers, _DeskproWindow.registerEventHandlers, _Context.registerTicketEventHandlers].forEach(function (registrar) {
    return registrar(windowBridge, app, _EventDispatcher.IncomingEventDispatcher, _EventDispatcher.OutgoingEventDispatcher);
  });

  return app;
};

/**
 * Creates an application using the keys defined on the props object
 *
 * @method
 * @param {Object} instanceProps
 * @param {Object} contextProps
 * @return {App}
 */
var createAppFromProps = exports.createAppFromProps = function createAppFromProps(_ref) {
  var instanceProps = _ref.instanceProps,
      contextProps = _ref.contextProps;

  var appProps = {
    incomingDispatcher: _EventDispatcher.IncomingEventDispatcher,
    outgoingDispatcher: _EventDispatcher.OutgoingEventDispatcher,
    internalDispatcher: _EventDispatcher.InternalEventDispatcher,
    instanceProps: new _AppProps.InstanceProps(instanceProps),
    contextProps: new _AppProps.ContextProps(contextProps)
  };

  return new _App2.default(appProps);
};

/**
 * @method
 * @param {function} cb
 */
var createApp = function createApp(cb) {
  var WidgetWindow = _Widget.WidgetFactories.windowBridgeFromWindow(window);

  WidgetWindow.connect(createAppFromProps).then(registerAppEventListeners.bind(null, WidgetWindow)).then(cb).catch(function (err) {
    cb(err);
  }); // the error scenario needs re-thinking
};

exports.default = createApp;

/***/ }),

/***/ "zCgN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorageApiFacade = undefined;

var _regenerator = __webpack_require__("ED1s");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("fQko");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("Dfz+");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("iy81");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _slicedToArray2 = __webpack_require__("xs8S");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _Events = __webpack_require__("QIOw");

var Events = _interopRequireWildcard(_Events);

var _StorageAdapter = __webpack_require__("2njn");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APP_TYPE = 'app';

var validName = function validName(nameString) {
  return typeof nameString === 'string' && nameString.length > 0;
};

var validNameValuePair = function validNameValuePair(nameAndValue) {
  var isValid = false;

  if (nameAndValue instanceof Array && nameAndValue.length >= 2) {
    var _nameAndValue = (0, _slicedToArray3.default)(nameAndValue, 1),
        name = _nameAndValue[0];

    isValid = validName(name);
  }

  return isValid;
};

/**
 * @private
 * @ignore
 * @param batch
 * @return {Error|null}
 */
var validateNameValuePairsList = function validateNameValuePairsList(batch) {
  if (!batch instanceof Array || batch.length === 0) {
    return new Error('In batch mode, the first parameter must be a non-empty Array');
  }

  var invalidPairs = batch.filter(function (nameAndValue) {
    return !validNameValuePair(nameAndValue);
  });
  if (invalidPairs.length) {
    return new Error('Bad method call: some of the name and value pairs were invalid. A name-value pair should have a non empty name and a value');
  }

  return null;
};

/**
 * @class
 */

var StorageApiFacade = function () {
  /**
   * @param {EventDispatcher} outgoingDispatcher
   * @param {EventDispatcher} internalDispatcher
   * @param {StorageAdapter} storageAdapter
   * @param {String} instanceId
   * @param {String} contextEntityType
   * @param {String} contextEntityId
   * @param {String} appId
   * @param other
   */
  function StorageApiFacade(outgoingDispatcher, internalDispatcher, storageAdapter, _ref) {
    var instanceId = _ref.instanceId,
        contextEntityType = _ref.contextEntityType,
        contextEntityId = _ref.contextEntityId,
        appId = _ref.appId,
        other = (0, _objectWithoutProperties3.default)(_ref, ['instanceId', 'contextEntityType', 'contextEntityId', 'appId']);
    (0, _classCallCheck3.default)(this, StorageApiFacade);

    if (!storageAdapter instanceof _StorageAdapter.StorageAdapter) {
      throw new Error('param storageAdapter must be an instance of StorageAdapter');
    }
    this.props = (0, _extends3.default)({ outgoingDispatcher: outgoingDispatcher, internalDispatcher: internalDispatcher, storageAdapter: storageAdapter, instanceId: instanceId, contextEntityType: contextEntityType, contextEntityId: contextEntityId, appId: appId }, other);
  }

  /**
   * @public
   * @method
   *
   * @param args
   * @return {Promise}
   */


  (0, _createClass3.default)(StorageApiFacade, [{
    key: 'setStorage',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var _this = this;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var storageAdapter, name, value, entityId, batch, _entityId, batchError;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                storageAdapter = this.props.storageAdapter;

                if (!(args.length === 3)) {
                  _context.next = 6;
                  break;
                }

                //
                name = args[0], value = args[1], entityId = args[2];

                if (validName(name)) {
                  _context.next = 5;
                  break;
                }

                throw new Error('Bad method call: name parameter must be a non empty string');

              case 5:
                return _context.abrupt('return', storageAdapter.handleSetStorage(_promise2.default.resolve(this.props), name, value, entityId).then(function (resp) {
                  _this.props.internalDispatcher.emit(entityId.indexOf(APP_TYPE) === 0 ? Events.EVENT_APP_CHANGED : Events.EVENT_ENTITY_CHANGED, entityId, name, value);

                  return resp;
                }));

              case 6:
                if (!(args.length === 2)) {
                  _context.next = 12;
                  break;
                }

                batch = args[0], _entityId = args[1];
                batchError = validateNameValuePairsList(batch);

                if (!(batchError instanceof Error)) {
                  _context.next = 11;
                  break;
                }

                throw batchError;

              case 11:
                return _context.abrupt('return', storageAdapter.handleSetBatchStorage(_promise2.default.resolve(this.props), batch, _entityId).then(function (resp) {
                  _this.props.internalDispatcher.emit(_entityId.indexOf(APP_TYPE) === 0 ? Events.EVENT_APP_CHANGED : Events.EVENT_ENTITY_CHANGED, _entityId, batch);

                  return resp;
                }));

              case 12:
                throw new Error('Bad method call: unknown number of args: ' + args.length);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setStorage() {
        return _ref2.apply(this, arguments);
      }

      return setStorage;
    }()

    /**
     * @public
     * @method
     *
     * @param args
     * @return {Promise}
     */

  }, {
    key: 'setAppStorage',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var entityId, name, value, batch;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                entityId = APP_TYPE + ':' + this.props.appId;

                if (!(args.length == 2)) {
                  _context2.next = 4;
                  break;
                }

                name = args[0], value = args[1];
                return _context2.abrupt('return', this.setStorage(name, value, entityId));

              case 4:
                if (!(args.length == 1)) {
                  _context2.next = 7;
                  break;
                }

                batch = args[0];
                return _context2.abrupt('return', this.setStorage(batch, entityId));

              case 7:
                throw new Error('Bad method call: unknown number of args: ' + args.length);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setAppStorage() {
        return _ref3.apply(this, arguments);
      }

      return setAppStorage;
    }()

    /**
     * @deprecated
     * @public
     * @method
     *
     * @param args
     * @return {Promise}
     */

  }, {
    key: 'setAppState',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var _args3 = arguments;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.setAppStorage.apply(this, _args3));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setAppState() {
        return _ref4.apply(this, arguments);
      }

      return setAppState;
    }()

    /**
     * @public
     * @method
     *
     * @return {Promise}
     */

  }, {
    key: 'setEntityStorage',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        var entityId, name, value, batch;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                entityId = this.props.contextEntityType + ':' + this.props.contextEntityId;

                if (!(args.length == 2)) {
                  _context4.next = 4;
                  break;
                }

                name = args[0], value = args[1];
                return _context4.abrupt('return', this.setStorage(name, value, entityId));

              case 4:
                if (!(args.length == 1)) {
                  _context4.next = 7;
                  break;
                }

                batch = args[0];
                return _context4.abrupt('return', this.setStorage(batch, entityId));

              case 7:
                throw new Error('Bad method call: unknown number of args: ' + args.length);

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function setEntityStorage() {
        return _ref5.apply(this, arguments);
      }

      return setEntityStorage;
    }()

    /**
     * @deprecated
     * @public
     * @method
     *
     * @return {Promise}
     */

  }, {
    key: 'setEntityState',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
        var _args5 = arguments;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', this.setEntityStorage.apply(this, _args5));

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setEntityState() {
        return _ref6.apply(this, arguments);
      }

      return setEntityState;
    }()

    /**
     * @public
     * @method
     *
     * @param {string|Array<string>}name
     * @param {string} entityId
     * @param {*} defaultValue
     * @return {Promise}
     */

  }, {
    key: 'getStorage',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(name, entityId) {
        var _this2 = this;

        var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var storageAdapter, batch, invalidName;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                storageAdapter = this.props.storageAdapter;

                if (!validName(name)) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt('return', storageAdapter.handleGetStorage(_promise2.default.resolve(this.props), name, entityId, defaultValue || null).then(function (value) {
                  _this2.props.internalDispatcher.emit(entityId.indexOf(APP_TYPE) === 0 ? Events.EVENT_APP_FETCHED : Events.EVENT_ENTITY_FETCHED, entityId, name, value);

                  return value;
                }));

              case 3:
                batch = name;

                if (!(batch instanceof Array)) {
                  _context6.next = 11;
                  break;
                }

                if (!(batch.length === 0)) {
                  _context6.next = 7;
                  break;
                }

                throw new Error('In batch mode, the first parameter must be a non-empty Array');

              case 7:
                invalidName = batch.filter(function (nameString) {
                  return !validName(nameString);
                });

                if (!invalidName.length) {
                  _context6.next = 10;
                  break;
                }

                throw new Error('Bad method call: some names were not syntactically valid');

              case 10:
                return _context6.abrupt('return', storageAdapter.handleGetBatchStorage(_promise2.default.resolve(this.props), batch, entityId, defaultValue || null).then(function (values) {
                  _this2.props.internalDispatcher.emit(entityId.indexOf(APP_TYPE) === 0 ? Events.EVENT_APP_FETCHED : Events.EVENT_ENTITY_FETCHED, entityId, batch, values);

                  return values;
                }));

              case 11:
                throw new Error('Bad method call');

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getStorage(_x, _x2) {
        return _ref7.apply(this, arguments);
      }

      return getStorage;
    }()

    /**
     * @public
     * @method
     *
     * @param name
     * @param defaultValue
     * @return {Promise}
     */

  }, {
    key: 'getEntityStorage',
    value: function () {
      var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(name) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var entityId;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                entityId = this.props.contextEntityType + ':' + this.props.contextEntityId;
                return _context7.abrupt('return', this.getStorage(name, entityId, defaultValue));

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getEntityStorage(_x4) {
        return _ref8.apply(this, arguments);
      }

      return getEntityStorage;
    }()

    /**
     * @deprecated
     * @public
     * @method
     *
     * @param name
     * @param defaultValue
     * @return {Promise}
     */

  }, {
    key: 'getEntityState',
    value: function () {
      var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(name) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt('return', this.getEntityStorage(name, defaultValue));

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getEntityState(_x6) {
        return _ref9.apply(this, arguments);
      }

      return getEntityState;
    }()

    /**
     * @public
     * @method
     *
     * @param name
     * @param defaultValue
     * @return {Promise}
     */

  }, {
    key: 'getAppStorage',
    value: function () {
      var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(name) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var entityId;
        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                entityId = 'app:' + this.props.appId;
                return _context9.abrupt('return', this.getStorage(name, entityId, defaultValue));

              case 2:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getAppStorage(_x8) {
        return _ref10.apply(this, arguments);
      }

      return getAppStorage;
    }()

    /**
     * @deprecated
     * @public
     * @method
     *
     * @param name
     * @param defaultValue
     * @return {Promise}
     */

  }, {
    key: 'getAppState',
    value: function () {
      var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(name) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return _regenerator2.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt('return', this.getAppStorage(name, defaultValue));

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getAppState(_x10) {
        return _ref11.apply(this, arguments);
      }

      return getAppState;
    }()
  }]);
  return StorageApiFacade;
}();

exports.StorageApiFacade = StorageApiFacade;

/***/ }),

/***/ "zJ0u":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("v4eW")))

/***/ }),

/***/ "zKo7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventName = exports.eventNames = exports.events = exports.EVENT_BADGE_VISIBILITYCHANGED = exports.EVENT_BADGE_COUNTCHANGED = exports.EVENT_MENU_VISIBILITYCHANGED = exports.EVENT_UI_DISPLAYCHANGED = exports.EVENT_UI_BEFOREDISPLAYCHANGED = exports.EVENT_UI_VISIBILITYCHANGED = exports.EVENT_UI_BEFOREVISIBILITYCHANGED = exports.EVENT_UI_STATECHANGED = exports.EVENT_SETTINGS_VISIBILITYCHANGED = undefined;

var _keys = __webpack_require__("q+0m");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module UI/Events
 */

/**
 * @type {string}
 */
var EVENT_SETTINGS_VISIBILITYCHANGED = exports.EVENT_SETTINGS_VISIBILITYCHANGED = 'ui.show-settings';

/**
 * @type {string}
 */
var EVENT_UI_STATECHANGED = exports.EVENT_UI_STATECHANGED = 'ui.state-transition';

/**
 * @type {string}
 */
var EVENT_UI_BEFOREVISIBILITYCHANGED = exports.EVENT_UI_BEFOREVISIBILITYCHANGED = 'ui.before-visibility-change';

/**
 * @type {string}
 */
var EVENT_UI_VISIBILITYCHANGED = exports.EVENT_UI_VISIBILITYCHANGED = 'ui.visibility-change';

/**
 * @type {string}
 */
var EVENT_UI_BEFOREDISPLAYCHANGED = exports.EVENT_UI_BEFOREDISPLAYCHANGED = 'ui.before-display-change';

/**
 * @type {string}
 */
var EVENT_UI_DISPLAYCHANGED = exports.EVENT_UI_DISPLAYCHANGED = 'ui.display-change';

/**
 * @type {string}
 */
var EVENT_MENU_VISIBILITYCHANGED = exports.EVENT_MENU_VISIBILITYCHANGED = 'ui.menu-change';

/**
 * @type {string}
 */
var EVENT_BADGE_COUNTCHANGED = exports.EVENT_BADGE_COUNTCHANGED = 'ui.badge_count-changed';

/**
 * @type {string}
 */
var EVENT_BADGE_VISIBILITYCHANGED = exports.EVENT_BADGE_VISIBILITYCHANGED = 'ui.badge_visibility-changed';

/**
 * @readonly
 * @enum {string}
 * @type {{EVENT_UI_STATECHANGED: string, EVENT_UI_BEFOREDISPLAYCHANGED: string, EVENT_UI_DISPLAYCHANGED: string, EVENT_UI_BEFOREVISIBILITYCHANGED: string, EVENT_UI_VISIBILITYCHANGED: string, EVENT_SETTINGS_VISIBILITYCHANGED: string, EVENT_MENU_VISIBILITYCHANGED: string, EVENT_BADGE_COUNTCHANGED: string, EVENT_BADGE_VISIBILITYCHANGED: string}}
 */
var events = exports.events = {
  EVENT_UI_STATECHANGED: EVENT_UI_STATECHANGED,
  EVENT_UI_BEFOREDISPLAYCHANGED: EVENT_UI_BEFOREDISPLAYCHANGED,
  EVENT_UI_DISPLAYCHANGED: EVENT_UI_DISPLAYCHANGED,
  EVENT_UI_BEFOREVISIBILITYCHANGED: EVENT_UI_BEFOREVISIBILITYCHANGED,
  EVENT_UI_VISIBILITYCHANGED: EVENT_UI_VISIBILITYCHANGED,

  EVENT_SETTINGS_VISIBILITYCHANGED: EVENT_SETTINGS_VISIBILITYCHANGED,
  EVENT_MENU_VISIBILITYCHANGED: EVENT_MENU_VISIBILITYCHANGED,

  EVENT_BADGE_COUNTCHANGED: EVENT_BADGE_COUNTCHANGED,
  EVENT_BADGE_VISIBILITYCHANGED: EVENT_BADGE_VISIBILITYCHANGED
};

/**
 * @readonly
 * @type {Array}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 * @param {String} name
 * @return {boolean}
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};

/***/ }),

/***/ "zx9m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleOutgoingEvent = exports.handleIncomingEvent = exports.handleInvokeEvents = undefined;

var _extends2 = __webpack_require__("GZ7I");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__("iy81");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__("4nfh");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("jjy6");

var _createClass3 = _interopRequireDefault(_createClass2);

var _EventDispatcher = __webpack_require__("CurJ");

var _Widget = __webpack_require__("u0i7");

var _Event = __webpack_require__("kJI2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO this should form the basic for the driver for WidgetWindowBridge

var EventHandler = function () {
  function EventHandler() {
    (0, _classCallCheck3.default)(this, EventHandler);
  }

  (0, _createClass3.default)(EventHandler, null, [{
    key: 'handleOutgoingEvent',

    /**
     * @param {WidgetWindowBridge} windowBridge
     * @param {function} resolve
     * @param {function} reject
     * @param {string} event
     * @param {*} data
     * @param {string} invocationType
     */
    value: function handleOutgoingEvent(windowBridge, resolve, reject, _ref) {
      var event = _ref.event,
          invocationType = _ref.invocationType,
          data = _ref.data;

      if (invocationType === _Event.INVOCATION_REQUESTRESPONSE) {
        windowBridge.emitRequest(event, data).then(function (_ref2) {
          var request = _ref2.request,
              emit = _ref2.emit;

          // resolve the promise when response comes
          var responseExecutor = function responseExecutor(response) {
            return response.status == 'success' ? resolve(response.body) : reject(response.body);
          };
          _EventDispatcher.MessageBus.once(request.correlationId, responseExecutor);
          return { request: request, emit: emit };
        }).then(function (_ref3) {
          var emit = _ref3.emit;
          return emit();
        });
      } else if (invocationType === _Event.INVOCATION_FIREANDFORGET) {
        windowBridge.emitRequest(event, data).then(function (_ref4) {
          var emit = _ref4.emit;
          return emit();
        }).then(function () {
          return resolve(data);
        });
      }
    }

    /**
     * @param {WidgetWindowBridge} windowBridge
     * @param {string} event
     * @param {string} invocationType
     * @param {WidgetRequest} request
     */

  }, {
    key: 'handleIncomingEvent',
    value: function handleIncomingEvent(windowBridge, _ref5, request) {
      var event = _ref5.event,
          invocationType = _ref5.invocationType;

      if (invocationType === _Event.INVOCATION_REQUESTRESPONSE) {
        var cb = function cb(error, data) {
          windowBridge.emitResponse(event, error, data, request).then(function (_ref6) {
            var response = _ref6.response,
                emit = _ref6.emit;
            return emit();
          });
        };

        _EventDispatcher.IncomingEventDispatcher.emit(event, cb, request.body);
      } else if (invocationType === _Event.INVOCATION_FIREANDFORGET) {
        _EventDispatcher.IncomingEventDispatcher.emit(event, request.body);
      }
    }
  }]);
  return EventHandler;
}();

/**
 * @param {WidgetWindowBridge} windowBridge
 * @param {String} eventName
 * @param {Object} eventProps
 * @param {{ data:* }} event
 */
/**
 * @module Core/EventHandler
 */

var dispatchIncomingEvent = function dispatchIncomingEvent(windowBridge, eventName, eventProps, event) {
  var rawMessage = event.data;


  var message = _Widget.WidgetFactories.parseMessageFromJS(rawMessage);
  if (message instanceof _Widget.WidgetRequest && eventProps.invocationType === _Event.INVOCATION_REQUESTRESPONSE) {
    _EventDispatcher.MessageBus.emit(eventName, message);
  }

  if (message instanceof _Widget.WidgetRequest && eventProps.invocationType === _Event.INVOCATION_FIREANDFORGET) {
    _EventDispatcher.MessageBus.emit(eventName, message);
  }

  if (message instanceof _Widget.WidgetResponse && eventProps.invocationType === _Event.INVOCATION_REQUESTRESPONSE) {
    _EventDispatcher.MessageBus.emit(message.correlationId, message);
  }
};

/**
 * @param {WidgetWindowBridge} windowBridge
 * @param {App} app
 */
var handleInvokeEvents = exports.handleInvokeEvents = function handleInvokeEvents(windowBridge, app) {
  _EventDispatcher.OutgoingEventDispatcher.onInvoke(EventHandler.handleOutgoingEvent.bind(null, windowBridge));
};

/**
 * @method
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {App} app
 * @param {String} eventName
 * @param {Object} eventProps
 */
var handleIncomingEvent = function handleIncomingEvent(windowBridge, app, eventName, eventProps) {
  var invocationType = eventProps.invocationType,
      otherProps = (0, _objectWithoutProperties3.default)(eventProps, ['invocationType']);


  if (-1 !== [_Event.INVOCATION_FIREANDFORGET, _Event.INVOCATION_REQUESTRESPONSE].indexOf(invocationType)) {

    var invocation = (0, _extends3.default)({ event: eventName, invocationType: invocationType }, otherProps);
    _EventDispatcher.MessageBus.on(eventName, EventHandler.handleIncomingEvent.bind(windowBridge, invocation));
    windowBridge.on(eventName, dispatchIncomingEvent.bind(undefined, windowBridge, eventName, eventProps));
  }
};

/**
 * @method
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {App} app
 * @param {string} eventName
 * @param {{invocationType:String}} eventProps
 */
exports.handleIncomingEvent = handleIncomingEvent;
var handleOutgoingEvent = function handleOutgoingEvent(windowBridge, app, eventName, eventProps) {
  var invocationType = eventProps.invocationType,
      otherProps = (0, _objectWithoutProperties3.default)(eventProps, ['invocationType']);


  if (-1 !== [_Event.INVOCATION_FIREANDFORGET, _Event.INVOCATION_REQUESTRESPONSE].indexOf(invocationType)) {
    var handler = function handler(resolve, reject, data) {
      return EventHandler.handleOutgoingEvent(windowBridge, resolve, reject, (0, _extends3.default)({ event: eventName, data: data, invocationType: invocationType }, otherProps));
    };

    _EventDispatcher.OutgoingEventDispatcher.on(eventName, handler);
    windowBridge.on(eventName, dispatchIncomingEvent.bind(undefined, windowBridge, eventName, eventProps));
  }
};
exports.handleOutgoingEvent = handleOutgoingEvent;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// deskproapps-sdk-core.js